import React, { useContext, useEffect, useState } from "react";
import PatientDetails from "../../../Components/PatientInformation";
import SaveAndNavigate from "../../../Components/SaveAndNavigate";
import {
  PageDesignConstants,
  SideMenuItems,
  HTTPResponse,
  ToastMessageType,
  ToastMessages,
  RRMMCohortTreatment,
  NDMMCohortTreatmentID,
  DiscontinuationReason,
} from "../../../Helpers/Enums";
import SideBarMenu from "../../../Components/SideBarMenu";
import ErrorField from "../../../Components/ErrorField";
import {
  CommonError_Msgs,
  BispecificCartTreatmentCohort_Msgs,
  hyperlinkTextLineOfTherapy,
} from "../../../Helpers/HelperText";
import { AppContext } from "../../../Contexts/AppContextProvider";
import {
  GetLocalStorageData,
  GetLoggedInUserID,
  IsDateLessThan,
  isStringEmpty,
  IsAdmin,
  IsDateAfter,
  IsDateEqualOrAfter,
  IsDateEqual,
  IsDateValid,
  useCollapsibleGroups,
  CollapsibleSectionHeader,
} from "../../../Helpers/Utilities";
import { Collapse } from "react-bootstrap";
import { BispecificsCartTreatmentCohortService } from "../../../WebApiServices/BispecificsCartTreatmentCohort.service";
import InfoPopUp from "../../../Components/InfoPopUp";
import DatePickerComponent from "../../../Components/DatePickerComponent";
import dayjs from "dayjs";

const BispecificsCartTreatmentCohort = () => {
  const [ndmmAvailable, setNdmmAvailable] = useState(false);
  const navigatePaths = {
    prevPage: ndmmAvailable
      ? "/NDMMTreatmentCohort"
      : "/CohortDefiningTreatment",
    currPage: "/BispecificsCartTreatmentCohort",
    nextPage: "/LineOfTherapy",
  };

  const pid = GetLocalStorageData("patientId") ?? 0;

  const storedData = GetLocalStorageData("CohortTreatment");

  const { ShowActionPopUp } = useContext(AppContext);

  const [showConfirm, setShowConfirm] = useState(false);
  const [endFollowUpDate, setEndFollowUpDate] = useState(null);
  const [intialMMDiagnosisDate, setIntialMMDiagnosisDate] = useState(null);
  const [ndmmIndexDate, setNdmmIndexDate] = useState(null);
  const [deathDeath, setDeathDeath] = useState(null);
  const [lastEncounterDate, setLastEncounterDate] = useState(null);
  const [treatmentErrors, setTreatmentErrors] = useState({});
  // per‑cohort soft terminate flags (for warning + termination on save)
  const [cohortTerminate, setCohortTerminate] = useState({});
  // per-group date order / age rule failures (AG11.1 rules 2 and 3), these block validating the form
  const [cohortDateErrors, setCohortDateErrors] = useState({});
  const { isCollapsed: isCohortCollapsed, toggleGroup: toggleCohortCollapse } =
    useCollapsibleGroups();

  const [confirmResolve, setConfirmResolve] = useState(null);

  const [bispecificHighestLotList, setBispecificHighestLotList] = useState([]);
  //Q26.2 chain validation - start date of the subsequent LOT (max of Q27 and Q31), if reported
  const [subsequentLotStartDate, setSubsequentLotStartDate] = useState(null);
  //Q26.2 1L row chain - max first/last administration date across Q22, Q23, Q24, Q25 (all NDMM agents)
  const [ndmm1LMaxAdminDate, setNdmm1LMaxAdminDate] = useState(null);

  const [modalDescription, setModalDescription] = useState(
    "You have changed the number of Tecvayli or Talquetamab administrations.\nPlease ensure that this change will affect the number of dose administrations (rows) listed in Q36.\nDo you want to continue?",
  );
  const [isNewEcrfA, setIsNewEcrfA] = useState(false);
  const [isNewEcrfC, setIsNewEcrfC] = useState(false);

  const [isSaving, setIsSaving] = useState(false);

  const cohortConfig = [
    {
      cohortIds: [
        NDMMCohortTreatmentID.DVRd_TIE,
        NDMMCohortTreatmentID.DVRd_TE,
      ],
      flag: "isDvrd",
    },
    {
      cohortIds: [NDMMCohortTreatmentID.DRd_TIE],
      flag: "isDrd",
    },
    {
      cohortIds: [NDMMCohortTreatmentID.DKRd_TE, NDMMCohortTreatmentID.DKRd_TE],
      flag: "isDkrd",
    },
    {
      cohortIds: [NDMMCohortTreatmentID.VRd_TIE, NDMMCohortTreatmentID.VRd_TE],
      flag: "isVrd",
    },
    {
      cohortIds: [
        NDMMCohortTreatmentID.ISAVRD_TIE,
        NDMMCohortTreatmentID.ISAVRD_TE,
      ],
      flag: "isIsaVrd",
    },
    {
      cohortIds: [RRMMCohortTreatment.TECVAYLI],
      flag: "isTec",
    },
    {
      cohortIds: [RRMMCohortTreatment.TALVEY],
      flag: "isTal",
    },
    {
      cohortIds: [RRMMCohortTreatment.ELREXFIO],
      flag: "isElr",
    },
    {
      cohortIds: [RRMMCohortTreatment.Linvoseltamab],
      flag: "isLyno",
    },
    {
      cohortIds: [RRMMCohortTreatment.CARVYKTI],
      flag: "isCarv",
    },
    {
      cohortIds: [RRMMCohortTreatment.ABECMA],
      flag: "isAbec",
    },
  ];

  const confirmChanges = () => {
    return new Promise((resolve) => {
      setConfirmResolve(() => resolve);
      setShowConfirm(true);
    });
  };

  const handleYes = () => {
    setShowConfirm(false);
    confirmResolve(true);
  };

  const handleNo = () => {
    setShowConfirm(false);
    confirmResolve(false);
  };

  const handleCheckChanges = async () => {
    let TechChanged = false;
    let TalChanged = false;

    bispecificTreatment.forEach((item) => {
      if (
        item.cohorttreatmentid === 9 &&
        item.noOfAdmission !== NumberofAdministrationTecBefore
      ) {
        TechChanged = true;
      } else if (
        item.cohorttreatmentid === 10 &&
        item.noOfAdmission !== NumberofAdministrationTalBefore
      ) {
        TalChanged = true;
      }
    });

    if (TechChanged || TalChanged) {
      const proceed = await confirmChanges(
        "You have changed the number of Tecvayli or Talquetamab administrations. Please ensure that this change will affect the number of dose administrations (rows) listed in Q36. Do you want to continue?",
      );
      return proceed;
    }
    return true;
  };

  const [NumberofAdministrationTecBefore, setNumberofTecAdministrationBefore] =
    useState(null);
  const [NumberofAdministrationTalBefore, setNumberofTalAdministrationBefore] =
    useState(null);

  const [TalAdministrationChanged, setTalAdministrationChanged] =
    useState(false);

  let cohortTreatmentModelListt = [];
  let cohortTreatmentModelListtndmm = [];
  if (storedData) {
    cohortTreatmentModelListt = JSON.parse(storedData);
    cohortTreatmentModelListtndmm = cohortTreatmentModelListt.filter(
      (c) => c.isEligible == true && c.ndmm == true,
    );
    cohortTreatmentModelListt = cohortTreatmentModelListt.filter(
      (c) => c.isEligible == true && c.ndmm == false,
    );
  }
  const {
    ShowToast,
    ToggleLoader,
    HandleSessionTimeout,
    isSideMenuActive,
    setIsSideMenuActive,
  } = useContext(AppContext);
  const [showTopErrMsg, setShowTopErrMsg] = useState(false);
  const [showHideHyperlinkModal, setShowHideHyperlinkModal] = useState(false);

  const cartTreatment = {
    bispecificTreatmentcohortid: 0,
    cohorttreatmentid: 0,
    cohortTreatmentName: "",
    AgentId: 0,
    AgentName: "",

    cohortIndexDate: "",
    supscripttext: "",
    endOfFollowUpDate: "",
    lOT: "",
    discontinueAgent: null,
    firstDate: null,
    lastDate: null,
    lastDateRadio: null,
    lastDateUnk: null,
    noOfAdmission: null,
    noOfAdmissionRadio: null,
    noOfAdmissionUnk: null,
    noOfAdmissionUnkTxt: "",
    doseAdministrationRadiomg: null,
    doseAdministrationmg: null,
    doseAdministrationRadiokg: null,
    doseAdministrationkg: null,
    doseAdministrationRadiomgm: null,
    doseAdministrationmgm: null,
    doseAdministrationRadiocell: null,
    doseAdministrationcell: null,
    doseAdministrationRadioUnknown: null,
    reasonForDiscontinuingMedications: [
      {
        bispecificCohortId: 0,
        cohorttreatmentid: 0,
        reasonid: 0,
        reasonName: null,
        reasonText: null,
        supscripttext: "",
        isSelected: false,
        reasonUnk: false,
      },
    ],

    showColBError: false,
    showColBDuplicateLotError: false,
    showColDError: false,
    showSecondDateRangeError: false,
    showColD_SEFDateError: false,
    showColD_LEFDateError: false,
    showColD_DateError: false,
    showColD_EFDateError: false,
    showColD_InvalidDate: false,
    showColEError: false,
    showColEUkTxtError: false,
    showColFError: false,
    showColG: false,
    showColGError: false,
    showColGUnknownError: false,
    showColGOthError: false,
    showColHError: false,
    discontinuationSoftError: false,
    lastAdministrationSoftError: false,
    discontinuationUnkSoftError: false,
    showAdverseEventError: false,
    showAdverseNeuroEventError: false,
    showAdverseNeuroEventOtherTextError: false,
    agentDateRangeError: false,
    agentDateError: false,
  };

  const [bispecificTreatment, setbispecificTreatment] = useState([
    cartTreatment,
  ]);

  const [endOfFollowUpDate, setEndOfFollowUpDate] = useState(null); //Date from Cohort Defining page Q20
  const [bispecificAgent, setbispecificAgent] = useState([cartTreatment]);

  //Q26.2
  const BispecificHighestLot = {
    cohorttreatmentid: null,
    cohorttreatmentNdmmid: null,
    cohorttreatmentName: null,
    bindedCohorttreatmentid: null,
    q262_rbl_A: null,
    q262_rbl_B: null,
    q262_date_B: null,
    q262_autodate_B: null,
    q262_rbl_C: null,
    q262_date_C: null,
    q262_autodate_C: null,

    chk_q262_received_tmt: false,
    q262_selectedReceivedTmtList: [],

    q262_rbl_E: null,
    q262_rbl_F: null,

    // Agents Refractory (Element C)
    q262_agentRefractoryLena: false,
    q262_agentRefractoryDara: false,
    q262_agentRefractoryDarafaspro: false,
    q262_agentRefractoryIsatu: false,
    q262_agentRefractoryNone: false,

    q262_B_empty_err: false,
    q262_B_invalid_date: false,
    q262_B_unk_err: false,
    q262_B_before_err: false,
    q262_B_before_next_lot_err: false,
    q262_B_beyond_eof_err: false,
    q262_B_after_end_err: false,
    q262_C_unk_err: false,
    q262_C_empty_err: false,
    q262_C_invalid_date: false,
    q262_C_before_err: false,
    q262_C_citaabecm_err: false,
    q262_C_before_next_lot_err: false,
    q262_C_beyond_eof_err: false,
    q262_D_empty_err: false,
    q262_D_txt_empty_err: false,
    q262_DaraNotSelected_err: false,
    q262_E_empty_err: false,
    q262_F_empty_err: false,
    q262_G_empty_err: false,
    q262ChainErrStart: false,
    q262ChainErrStartMsg: null,
    q262ChainErrEnd: false,
    q262ChainErrEndMsg: null,
    q262RowChainErrStart: false,
    q262RowChainErrStartMsg: null,
    q262RowChainErrEnd: false,
    q262RowChainErrEndMsg: null,

    prescribedTreatments: [],
    prescribedTmtOtherID: null,

    //Q26.3 (Element C) - Date of daratumumab discontinuation on most recent prior LOT that utilized daratumumab
    q263_rbl_D: null,
    q263_date_D: null,
    q263_C_empty_err: false,
    q263_C_invalid_date: false,
    q263_C_chain_err: false,

    // Q26.3 (Element C) date-chain validation support (from backend)
    q263_ndmmIndexDate: null,
    q263_daraMinAdminDate: null,
    q263_daraMaxAdminDate: null,
    q263_daraS121InitiationDate: null,
  };

  // Q26.2 - Agents Refractory (Element C): treatments that trigger the "Agents Refractory" checkbox list
  const RefractoryAgentOptions = [
    { name: "Lenalidomide (Revlimid)", field: "q262_agentRefractoryLena" },
    { name: "Daratumumab (Darzalex)", field: "q262_agentRefractoryDara" },
    {
      name: "Daratumumab (Darzalex Faspro)",
      field: "q262_agentRefractoryDarafaspro",
    },
    { name: "Isatuximab (Sarclisa)", field: "q262_agentRefractoryIsatu" },
  ];

  // Returns the RefractoryAgentOptions that were actually selected in the row's "Treatments Received" list
  const getQualifyingRefractoryAgentOptions = (row) => {
    const receivedTreatments = (row.prescribedTreatments ?? []).flatMap(
      (category) => category.treatments ?? [],
    );

    return RefractoryAgentOptions.filter((option) =>
      row.q262_selectedReceivedTmtList?.some((selected) => {
        const treatment = receivedTreatments.find(
          (t) => t.prescribedTreatmentId === selected.prescribedTreatmentId,
        );
        return treatment?.name === option.name;
      }),
    );
  };

  // Q26.3 (Element C) - Was Daratumumab (Darzalex/Darzalex Faspro) selected as a treatment received on this LOT (Q26.2 column D)?
  const DaratumumabTreatmentNames = [
    "Daratumumab (Darzalex)",
    "Daratumumab (Darzalex Faspro)",
  ];
  const rowHasDaratumumab = (row) => {
    const receivedTreatments = (row.prescribedTreatments ?? []).flatMap(
      (category) => category.treatments ?? [],
    );

    return !!row.q262_selectedReceivedTmtList?.some((selected) => {
      const treatment = receivedTreatments.find(
        (t) => t.prescribedTreatmentId === selected.prescribedTreatmentId,
      );
      return treatment && DaratumumabTreatmentNames.includes(treatment.name);
    });
  };

  // Q26.3 - take the overall highest LOT in Q26.2, subtract 1 (range 1L to max LOT - 1), then within that range
  // find the highest-numbered LOT that has daratumumab selected in column D. Only that single LOT is shown.
  const GetQ263EligibleRow = (list) => {
    if (!list || list.length === 0) return null;

    const maxLot = Math.max(...list.map((r) => Number(r.q262_rbl_A)));

    const eligibleRows = list.filter(
      (r) => Number(r.q262_rbl_A) < maxLot && rowHasDaratumumab(r),
    );

    if (eligibleRows.length === 0) return null;

    return eligibleRows.reduce((prev, curr) =>
      Number(curr.q262_rbl_A) > Number(prev.q262_rbl_A) ? curr : prev,
    );
  };

  // Only Q26.1 dara agents belonging to the eligible LOT (highest daratumumab LOT within 1L to max LOT - 1) are considered
  const GetQ263AutoDiscontinuationDate = (q263Row) => {
    if (!q263Row) return null;

    const daraAgent = bispecificAgent
      ?.filter((c) => Number(c.lineOfTherapy) === Number(q263Row.q262_rbl_A))
      .flatMap((c) => c.agentLists ?? [])
      .find(
        (a) =>
          a.agentName?.toLowerCase().includes("daratumumab") &&
          a.discontinueAgent === 1 &&
          !isStringEmpty(a.lastDate),
      );

    return daraAgent ? daraAgent.lastDate : null;
  };

  // Q26.3 - resolves the effective discontinuation date/unknown-flag for the eligible row, preferring the Q26.1 auto-populated value
  const GetQ263DiscontinuationInfo = (q263Row) => {
    const autoDate = GetQ263AutoDiscontinuationDate(q263Row);

    if (!isStringEmpty(autoDate)) {
      return { isAuto: true, date: autoDate, isUnknown: false };
    }
    return {
      isAuto: false,
      date: q263Row.q263_rbl_D === 1 ? q263Row.q263_date_D : null,
      isUnknown: q263Row.q263_rbl_D === 99,
    };
  };

  // Q26.3 (Element C) - date-chain validation
  // 1L:  NDMM index date <= min(dara admin dates Q22-Q25) <= max(dara admin dates Q22-Q25) <= discontinuation date <= LOT end date <= next LOT start date
  // 2L+: Bispecifics/CAR-T index date <= dara initiation date (S12.1) <= discontinuation date <= LOT end date <= next LOT start date <= end of follow-up
  const ValidateQ263DateChain = (q263Row, discontinuationDate) => {
    if (
      !q263Row ||
      isStringEmpty(discontinuationDate) ||
      !IsDateValid(discontinuationDate)
    ) {
      return true;
    }

    const nextLotRow = bispecificHighestLotList.find(
      (r) => Number(r.q262_rbl_A) === Number(q263Row.q262_rbl_A) + 1,
    );

    const lotEndDate = !isStringEmpty(q263Row.q262_autodate_C)
      ? q263Row.q262_autodate_C
      : q263Row.q262_date_C;

    const nextLotStartDate = nextLotRow
      ? !isStringEmpty(nextLotRow.q262_autodate_B)
        ? nextLotRow.q262_autodate_B
        : nextLotRow.q262_date_B
      : null;

    let chain = [];

    if (Number(q263Row.q262_rbl_A) === 1) {
      chain = [
        q263Row.q263_ndmmIndexDate,
        q263Row.q263_daraMinAdminDate,
        q263Row.q263_daraMaxAdminDate,
        discontinuationDate,
        lotEndDate,
        nextLotStartDate,
      ];
    } else {
      // If a Q26 (Bispecific/CAR-T) entry exists at this same LOT number, use that cohort's index date;
      // otherwise skip this bound in the chain below, but separately require the discontinuation date to be
      // on or after this LOT's own start date (only checked when there's no Bispecific/CAR-T index date to compare against).
      const cartIndexDate = bispecificTreatment?.find(
        (t) => Number(t.lOT) === Number(q263Row.q262_rbl_A),
      )?.earliestCohortIndexDate;

      if (isStringEmpty(cartIndexDate)) {
        const lotStartDate = !isStringEmpty(q263Row.q262_autodate_B)
          ? q263Row.q262_autodate_B
          : q263Row.q262_date_B;

        if (
          !isStringEmpty(lotStartDate) &&
          IsDateValid(lotStartDate) &&
          IsDateAfter(lotStartDate, discontinuationDate)
        ) {
          return false;
        }
      }

      chain = [
        cartIndexDate,
        q263Row.q263_daraS121InitiationDate,
        discontinuationDate,
        lotEndDate,
        nextLotStartDate,
        endFollowUpDate,
      ];
    }

    const validDates = chain.filter((d) => !isStringEmpty(d) && IsDateValid(d));

    for (let i = 0; i < validDates.length - 1; i++) {
      if (IsDateAfter(validDates[i], validDates[i + 1])) {
        return false;
      }
    }
    return true;
  };

  useEffect(() => {
    async function FetchData() {
      //Set previous path
      setNdmmAvailable(cohortTreatmentModelListtndmm.length > 0);

      if (!isNaN(pid) && Number(pid) !== 0) {
        ToggleLoader(true);
        await LoadData();

        ToggleLoader(false);
      }
    }
    FetchData();
  }, []);

  const LoadData = async () => {
    try {
      if (pid > 0) {
        const response =
          await BispecificsCartTreatmentCohortService.GetBispecificCartTreatmentCohortData(
            pid,
          );

        if (response?.status === HTTPResponse.OK) {
          const { data } = response;

          setIsNewEcrfA(data.isNewEcrfA ?? false);
          setIsNewEcrfC(data.isNewEcrfC ?? false);
          setEndFollowUpDate(data.endOfFollowUpDate);
          setDeathDeath(data.deathDate);
          setLastEncounterDate(data.lastEncounterDate);
          setIntialMMDiagnosisDate(data.initialMMDiagnosisDate);
          setNdmmIndexDate(data.ndmmIndexDate);
          setNdmm1LMaxAdminDate(data.ndmm1LMaxAdminDate);

          const cohortTreatmentMap = new Map();
          if (cohortTreatmentModelListt) {
            cohortTreatmentModelListt.forEach((item) => {
              if (item.isEligible) {
                cohortTreatmentMap.set(
                  `${item.cohortTreatmentID}_${item.lineOfTherapy}`,
                  {
                    cohortTreatmentID: item.cohortTreatmentID,
                    lotnumber: item.lotnumber,
                    cohortTreatmentName: item.cohortTreatmentName,
                    cohortInitiationDate: item.cohortIndexDate,
                    cohortTreatmentNameSuperscript:
                      item.cohortTreatmentNameSuperscript,
                    earliestCohortIndexDate: item.earliestCohortIndexDate,
                  },
                );
              }
            });
          }

          let repeaterData = [];

          // Check if there is existing Bispecific cart data
          if (
            data.medicationTreatmentLists &&
            data.medicationTreatmentLists.length !== 0
          ) {
            repeaterData = data.medicationTreatmentLists.map((item) => {
              const cohortTreatment =
                [...cohortTreatmentMap.values()].find(
                  (x) => x.cohortTreatmentID === item.cohortTreatmentId,
                ) || {};

              if (item.cohortTreatmentId == 9) {
                setNumberofTecAdministrationBefore(item.noOfAdmission);
              }

              if (item.cohortTreatmentId == 10) {
                setNumberofTalAdministrationBefore(item.noOfAdmission);
              }

              // Rows without a saved record come back with empty reason lists;
              // fall back to the default lists so all options show before Save.
              const reasonSource = item.reasonForDiscontinuingMedications
                ?.length
                ? item.reasonForDiscontinuingMedications
                : (data.reasonForDiscontinuingMedications ?? []);
              const aeSource = item.adverseEventsDiscontinuationreason?.length
                ? item.adverseEventsDiscontinuationreason
                : (data.adverseEventsDiscontinuationreason ?? []);
              const neuroSource = item
                .adverseNeurologicalEventsDiscontinuationreason?.length
                ? item.adverseNeurologicalEventsDiscontinuationreason
                : (data.adverseNeurologicalEventsDiscontinuationreason ?? []);

              const discontinueAgentsLst = reasonSource.map((AgentItem) => ({
                bispecificCohortId: AgentItem.bispecificCohortId,
                cohorttreatmentid: item.cohortTreatmentId,
                reasonid: AgentItem.reasonid,
                reasonName: AgentItem.reasonName,
                reasonText: AgentItem.reasonText,
                supscripttext: AgentItem.supscripttext,
                isSelected: AgentItem.isSelected,
                reasonUnk: AgentItem.reasonUnk,
              }));

              const adverseEventsDiscontinuationreason = aeSource.map(
                (AgentItem) => ({
                  bispecifictreatmentdiscontinuationreasonaeid:
                    AgentItem.bispecifictreatmentdiscontinuationreasonaeid,
                  bispecifictreatmentdiscontinuationreasonaebridgeid:
                    AgentItem.bispecifictreatmentdiscontinuationreasonaebridgeid,
                  bispecifictreatmentcohortid:
                    AgentItem.bispecifictreatmentcohortid,
                  reasonName: AgentItem.reasonName,
                  superscripttext: AgentItem.superscripttext,
                  isSelected: AgentItem.isSelected,
                }),
              );

              const adverseNeuroEventsDiscontinuationreason = neuroSource.map(
                (AgentItem) => ({
                  bispecifictreatmentreasonneurologicalaeid:
                    AgentItem.bispecifictreatmentreasonneurologicalaeid,
                  bispecifictreatmentdiscontinuationreasonaeid:
                    AgentItem.bispecifictreatmentdiscontinuationreasonaeid,
                  bispecifictreatmentdiscontinuationreasonid:
                    AgentItem.bispecifictreatmentdiscontinuationreasonid,
                  bispecifictreatmentcohortid:
                    AgentItem.bispecifictreatmentcohortid,
                  reasonName: AgentItem.reasonName,
                  reasonText: AgentItem.reasonText,
                  isSelected: AgentItem.isSelected,
                }),
              );

              const cohortTreatmentData = cohortTreatmentModelListt.find(
                (cohort) => cohort.cohortTreatmentID === item.cohortTreatmentId,
              );

              const matchingLine =
                cohortTreatmentData?.receivedLinesOfTherapy?.find(
                  (line) => line.lineOfTherapy === item.lot,
                );

              return {
                cohorttreatmentid: item.cohortTreatmentId,
                cohortTreatmentName:
                  cohortTreatment.cohortTreatmentName || null,
                // initiation date (S12) drives the date-order checks; index date (S12 + S12.1) is for display
                cohortInitiationDate: matchingLine?.initiationDate || null,
                earliestCohortIndexDate: matchingLine?.indexDate || null,
                supscripttext: cohortTreatment.cohortTreatmentNameSuperscript,
                bispecificTreatmentcohortid: item.bispecificTreatmentcohortid,
                endOfFollowUpDate: data.endOfFollowUpDate,
                lOT: item.lot,
                firstDate: matchingLine?.initiationDate || null,
                lastDate: item.lastDate,
                lastDateRadio: item.lastDateRadio,
                lastDateUnk: item.lastDateUnk,
                noOfAdmission: item.noOfAdmission,
                noOfAdmissionRadio: item.noOfAdmissionRadio,
                noOfAdmissionUnk: item.noOfAdmissionUnk,
                noOfAdmissionUnkTxt: item.noOfAdmissionUnkTxt,
                doseAdministrationRadiomg: item.doseAdministrationRadiomg,
                doseAdministrationmg: item.doseAdministrationmg,
                doseAdministrationRadiokg: item.doseAdministrationRadiokg,
                doseAdministrationkg: item.doseAdministrationkg,
                doseAdministrationRadiomgm: item.doseAdministrationRadiomgm,
                doseAdministrationmgm: item.doseAdministrationmgm,
                doseAdministrationRadiocell: item.doseAdministrationRadiocell,
                doseAdministrationcell: item.doseAdministrationcell,
                doseAdministrationRadioUnknown:
                  item.doseAdministrationRadioUnknown,
                discontinueAgent: item.discontinueAgent,
                reasonForDiscontinuingMedications: discontinueAgentsLst,
                adverseEventsDiscontinuationreason:
                  adverseEventsDiscontinuationreason,
                adverseNeurologicalEventsDiscontinuationreason:
                  adverseNeuroEventsDiscontinuationreason,
                showColBError: false,
                showColBDuplicateLotError: false,
                showColDError: false,
                showColD_SEFDateError: false,
                showColD_LEFDateError: false,
                showColD_DateError: false,
                showColD_SortedDateError: false,
                showColD_EFDateError: false,
                showColD_InvalidDate: false,
                showColEError: false,
                showColEUkTxtError: false,
                showColHError: false,
                showColFError: false,
                showColG: item.discontinueAgent == 1 ? true : false,
                showColGError: false,
                showColGUnknownError:
                  discontinueAgentsLst[0].reasonUnk === true,
                showColGOthError: false,
                discontinuationSoftError: item.discontinuationSoftError,
                q26ChainErr: false,
                q26ChainErrMsg: null,
              };
            });

            const receivedLinesList = cohortTreatmentModelListt.flatMap(
              (cohort) =>
                (cohort.receivedLinesOfTherapy ?? []).map((line) => ({
                  patientId: cohort.patientId,
                  cohortTreatmentID: cohort.cohortTreatmentID,
                  cohortTreatmentName: cohort.cohortTreatmentName,
                  cohortTreatmentNameSuperscript:
                    cohort.cohortTreatmentNameSuperscript,
                  lineOfTherapy: line.lineOfTherapy,
                  cohortInitiationDate: line.initiationDate,
                  indexDateUnk: line.indexDateUnk,
                  earliestCohortIndexDate:
                    line.indexDate || cohort.earliestCohortIndexDate,
                })),
            );

            // Merge with cohortTreatmentModelListt
            receivedLinesList.forEach((cohort) => {
              if (
                !repeaterData.some(
                  (item) =>
                    item.cohorttreatmentid === cohort.cohortTreatmentID &&
                    item.lineOfTherapy === cohort.LineOfTherapy,
                )
              ) {
                const discontinueAgentsLst =
                  data.reasonForDiscontinuingMedications.map((AgentItem) => ({
                    bispecificCohortId: AgentItem.bispecificCohortId,
                    cohorttreatmentid: cohort.cohortTreatmentID,
                    reasonid: AgentItem.reasonid,
                    reasonName: AgentItem.reasonName,
                    reasonText: AgentItem.reasonText,
                    supscripttext: AgentItem.supscripttext,
                    isSelected: AgentItem.isSelected,
                    reasonUnk: AgentItem.reasonUnk,
                  }));

                const adverseEventsDiscontinuationreason =
                  data.adverseEventsDiscontinuationreason.map((AgentItem) => ({
                    bispecifictreatmentdiscontinuationreasonaeid:
                      AgentItem.bispecifictreatmentdiscontinuationreasonaeid,
                    bispecifictreatmentdiscontinuationreasonaebridgeid:
                      AgentItem.bispecifictreatmentdiscontinuationreasonaebridgeid,
                    bispecifictreatmentcohortid:
                      AgentItem.bispecifictreatmentcohortid,
                    reasonName: AgentItem.reasonName,
                    superscripttext: AgentItem.superscripttext,
                    isSelected: AgentItem.isSelected,
                  }));

                const adverseNeuroEventsDiscontinuationreason =
                  data.adverseNeurologicalEventsDiscontinuationreason.map(
                    (AgentItem) => ({
                      bispecifictreatmentreasonneurologicalaeid:
                        AgentItem.bispecifictreatmentreasonneurologicalaeid,
                      bispecifictreatmentdiscontinuationreasonaeid:
                        AgentItem.bispecifictreatmentdiscontinuationreasonaeid,
                      bispecifictreatmentdiscontinuationreasonid:
                        AgentItem.bispecifictreatmentdiscontinuationreasonid,
                      bispecifictreatmentcohortid:
                        AgentItem.bispecifictreatmentcohortid,
                      reasonName: AgentItem.reasonName,
                      reasonText: AgentItem.reasonText,
                      isSelected: AgentItem.isSelected,
                    }),
                  );

                repeaterData.push({
                  cohorttreatmentid: cohort.cohortTreatmentID,
                  cohortTreatmentName: cohort.cohortTreatmentName,
                  cohortInitiationDate: cohort.cohortInitiationDate,
                  earliestCohortIndexDate:
                    cohort.earliestCohortIndexDate || null,
                  supscripttext: cohort.cohortTreatmentNameSuperscript,
                  endOfFollowUpDate: data.endOfFollowUpDate,
                  bispecificTreatmentcohortid: 0,
                  lOT: null,
                  firstDate: cohort.cohortInitiationDate,
                  lastDate: null,
                  lastDateRadio: null,
                  lastDateUnk: null,
                  noOfAdmission: null,
                  noOfAdmissionRadio: null,
                  doseAdministrationRadiomg: null,
                  noOfAdmissionUnk: null,
                  noOfAdmissionUnkTxt: "",
                  doseAdministrationmg: null,
                  doseAdministrationRadiokg: null,
                  doseAdministrationkg: null,
                  doseAdministrationRadiomgm: null,
                  doseAdministrationmgm: null,
                  doseAdministrationRadiocell: null,
                  doseAdministrationRadioUnknown: null,
                  doseAdministrationcell: null,
                  discontinueAgent: null,
                  reasonForDiscontinuingMedications: discontinueAgentsLst,
                  adverseEventsDiscontinuationreason:
                    adverseEventsDiscontinuationreason,
                  adverseNeurologicalEventsDiscontinuationreason:
                    adverseNeuroEventsDiscontinuationreason,
                  showColBError: false,
                  showColBDuplicateLotError: false,
                  showColDError: false,
                  showColD_InvalidDate: false,
                  showColD_SEFDateError: false,
                  showColD_LEFDateError: false,
                  showColD_DateError: false,
                  showColD_SortedDateError: false,
                  showColD_EFDateError: false,
                  showColEError: false,
                  showColEUkTxtError: false,
                  showColHError: false,
                  showColFError: false,
                  showColG: false,
                  showColGError: false,
                  showColGUnknownError:
                    discontinueAgentsLst[0].reasonUnk === true,
                  showColGOthError: false,
                  q26ChainErr: false,
                  q26ChainErrMsg: null,
                });
              }
            });

            setbispecificTreatment(repeaterData);
          } else {
            // No bispecificdata
            const receivedLinesList = cohortTreatmentModelListt.flatMap(
              (cohort) =>
                (cohort.receivedLinesOfTherapy ?? []).map((line) => ({
                  patientId: cohort.patientId,
                  cohortTreatmentID: cohort.cohortTreatmentID,
                  cohortTreatmentName: cohort.cohortTreatmentName,
                  cohortTreatmentNameSuperscript:
                    cohort.cohortTreatmentNameSuperscript,
                  lineOfTherapy: line.lineOfTherapy,
                  cohortInitiationDate: line.initiationDate,
                  indexDateUnk: line.indexDateUnk,
                  earliestCohortIndexDate:
                    line.indexDate || cohort.earliestCohortIndexDate,
                })),
            );

            if (receivedLinesList != null) {
              receivedLinesList.forEach((cohort) => {
                const discontinueAgentsLst =
                  data.reasonForDiscontinuingMedications.map((AgentItem) => ({
                    bispecificCohortId: AgentItem.bispecificCohortId,
                    cohorttreatmentid: cohort.cohortTreatmentID,
                    reasonid: AgentItem.reasonid,
                    reasonName: AgentItem.reasonName,
                    reasonText: AgentItem.reasonText,
                    supscripttext: AgentItem.supscripttext,
                    isSelected: AgentItem.isSelected,
                    reasonUnk: AgentItem.reasonUnk,
                  }));

                const adverseEventsDiscontinuationreason =
                  data.adverseEventsDiscontinuationreason.map((AgentItem) => ({
                    bispecifictreatmentdiscontinuationreasonaeid:
                      AgentItem.bispecifictreatmentdiscontinuationreasonaeid,
                    bispecifictreatmentdiscontinuationreasonaebridgeid:
                      AgentItem.bispecifictreatmentdiscontinuationreasonaebridgeid,
                    bispecifictreatmentcohortid:
                      AgentItem.bispecifictreatmentcohortid,
                    reasonName: AgentItem.reasonName,
                    superscripttext: AgentItem.superscripttext,
                    isSelected: AgentItem.isSelected,
                  }));

                const adverseNeuroEventsDiscontinuationreason =
                  data.adverseNeurologicalEventsDiscontinuationreason.map(
                    (AgentItem) => ({
                      bispecifictreatmentreasonneurologicalaeid:
                        AgentItem.bispecifictreatmentreasonneurologicalaeid,
                      bispecifictreatmentdiscontinuationreasonaeid:
                        AgentItem.bispecifictreatmentdiscontinuationreasonaeid,
                      bispecifictreatmentdiscontinuationreasonid:
                        AgentItem.bispecifictreatmentdiscontinuationreasonid,
                      bispecifictreatmentcohortid:
                        AgentItem.bispecifictreatmentcohortid,
                      reasonName: AgentItem.reasonName,
                      reasonText: AgentItem.reasonText,
                      isSelected: AgentItem.isSelected,
                    }),
                  );

                repeaterData.push({
                  cohorttreatmentid: cohort.cohortTreatmentID,
                  cohortTreatmentName: cohort.cohortTreatmentName,
                  cohortInitiationDate: cohort.cohortInitiationDate,
                  earliestCohortIndexDate:
                    cohort.earliestCohortIndexDate || null,
                  supscripttext: cohort.cohortTreatmentNameSuperscript,
                  reasonForDiscontinuingMedications: discontinueAgentsLst,
                  adverseEventsDiscontinuationreason:
                    adverseEventsDiscontinuationreason,
                  adverseNeurologicalEventsDiscontinuationreason:
                    adverseNeuroEventsDiscontinuationreason,
                  bispecificTreatmentcohortid: 0,
                  endOfFollowUpDate: data.endOfFollowUpDate,
                  lOT: cohort.lineOfTherapy,
                  firstDate: cohort.cohortInitiationDate,
                  lastDate: null,
                  lastDateRadio: null,
                  lastDateUnk: null,
                  noOfAdmission: null,
                  noOfAdmissionRadio: null,
                  noOfAdmissionUnk: null,
                  noOfAdmissionUnkTxt: "",
                  doseAdministrationRadiomg: null,
                  doseAdministrationmg: null,
                  doseAdministrationRadiokg: null,
                  doseAdministrationkg: null,
                  doseAdministrationRadiomgm: null,
                  doseAdministrationmgm: null,
                  doseAdministrationRadiocell: null,
                  doseAdministrationcell: null,
                  doseAdministrationRadioUnknown: null,
                  discontinueAgent: null,
                  showColBError: false,
                  showColBDuplicateLotError: false,
                  showColDError: false,
                  showColD_InvalidDate: false,
                  showColD_SEFDateError: false,
                  showColD_LEFDateError: false,
                  showColD_DateError: false,
                  showColD_SortedDateError: false,
                  showColD_EFDateError: false,
                  showColEError: false,
                  showColEUkTxtError: false,
                  showColFError: false,
                  showColHError: false,
                  showColG: false,
                  showColGError: false,
                  showColGUnknownError:
                    discontinueAgentsLst[0].reasonUnk === true,
                  showColGOthError: false,
                  q26ChainErr: false,
                  q26ChainErrMsg: null,
                });
              });

              setbispecificTreatment(repeaterData);
            }
          }

          const receivedAgentLinesList =
            data.bispecificCartTreatmentAgentList.flatMap((cohort) =>
              (cohort.receivedLinesOfTherapy ?? []).flatMap((line) => {
                const matchingAgents = (cohort.agentLists ?? []).filter(
                  (agent) => agent.lot === line.lineOfTherapy,
                );

                // Only return rows where there is a matching agent
                if (matchingAgents.length === 0) {
                  return [];
                }

                return {
                  patientId: cohort.patientId,
                  cohortTreatmentId: cohort.cohortTreatmentId,
                  cohortTreatmentName: cohort.cohortTreatmentName,
                  cohortTreatmentNameSuperscript:
                    cohort.cohortTreatmentNameSuperscript,
                  lineOfTherapy: line.lineOfTherapy,
                  cohortIndexDate: line.indexDate,
                  agentLists: matchingAgents,
                };
              }),
            );

          if (receivedAgentLinesList?.length > 0) {
            data.bispecificCartTreatmentAgentList = receivedAgentLinesList.map(
              (cohortItem) => {
                const cohortName =
                  cohortTreatmentModelListt.find(
                    (c) => c.cohortTreatmentID === cohortItem.cohortTreatmentId,
                  )?.cohortTreatmentName ?? "";

                return {
                  ...cohortItem,
                  cohortTreatmentName: cohortName,
                  agentLists: (cohortItem.agentLists || []).map(
                    (agentItem) => ({
                      ...agentItem,
                      showFirstSiteCareError: false,
                      showSecondDateError: false,
                      showSecondDateRangeError: false,
                      showSecondSiteCareError: false,
                      q261ChainErr: false,
                      q261ChainErrMsg: null,
                      q261ChainErrField: null,
                      agentSortedDateError: false,
                    }),
                  ),
                };
              },
            );
          }

          setbispecificAgent(data.bispecificCartTreatmentAgentList);

          //Q26.2
          setEndOfFollowUpDate(data.endOfFollowUpDate);
          setSubsequentLotStartDate(data.subsequentLotStartDate);

          if (data.bispecificHighestLot != null) {
            let bispecificHighestList = data.bispecificHighestLot;
            const mappedBispecificHighestLot = bispecificHighestList.map(
              (itemRow) => {
                const cohortData =
                  cohortTreatmentMap.get(
                    `${itemRow.bindedCohorttreatmentid}_${itemRow.lotnumber}`,
                  ) || {};
                return {
                  ...BispecificHighestLot,

                  cohorttreatmentid: itemRow.cohorttreatmentid ?? null,
                  cohorttreatmentName: itemRow.cohorttreatmentName ?? null,
                  cohorttreatmentNdmmid: itemRow.cohorttreatmentNdmmid ?? null,
                  bindedCohorttreatmentid:
                    itemRow.bindedCohorttreatmentid ?? null,

                  // LOT DETAILS
                  q262_rbl_A: itemRow.lotnumber ?? null,
                  q262_rbl_B:
                    itemRow.lotStartdate ||
                    !isStringEmpty(itemRow.autoLotStartdate)
                      ? 1
                      : itemRow.lotStartdateUnk
                        ? 99
                        : null,
                  q262_date_B:
                    cohortData &&
                    !isStringEmpty(cohortData.earliestCohortIndexDate)
                      ? cohortData.earliestCohortIndexDate
                      : !isStringEmpty(itemRow.autoLotStartdate)
                        ? itemRow.autoLotStartdate
                        : itemRow.lotStartdate,
                  q262_autodate_B:
                    cohortData &&
                    !isStringEmpty(cohortData.earliestCohortIndexDate)
                      ? cohortData.earliestCohortIndexDate
                      : (itemRow.autoLotStartdate ?? null),
                  q262_rbl_C:
                    itemRow.lotEnddate || !isStringEmpty(itemRow.autoLotEnddate)
                      ? 1
                      : itemRow.lotEnddateUnk
                        ? 99
                        : null,
                  q262_date_C: !isStringEmpty(itemRow.autoLotEnddate)
                    ? itemRow.autoLotEnddate
                    : itemRow.lotEnddate,
                  q262_autodate_C: itemRow.autoLotEnddate ?? null,
                  q262_rbl_E: itemRow.receivedLot ?? null,
                  q262_rbl_F: itemRow.refractoryTreatment ?? null,

                  // AGENTS REFRACTORY (Element C)
                  q262_agentRefractoryLena:
                    itemRow.agentRefractoryLena ?? false,
                  q262_agentRefractoryDara:
                    itemRow.agentRefractoryDara ?? false,
                  q262_agentRefractoryDarafaspro:
                    itemRow.agentRefractoryDarafaspro ?? false,
                  q262_agentRefractoryIsatu:
                    itemRow.agentRefractoryIsatu ?? false,
                  q262_agentRefractoryNone:
                    itemRow.agentRefractoryNone ?? false,
                  //Warning messages retain on load
                  q262_B_unk_err: itemRow.lotStartdateUnk ?? false,
                  q262_C_unk_err: itemRow.lotEnddateUnk ?? false,

                  // RECEIVED TREATMENT FLAGS
                  chk_q262_received_tmt: itemRow.receivedLot ?? false,
                  q262_rb_received_tmt_unk:
                    itemRow.treatmentReceivedUnknown ?? false,

                  // SELECTED TREATMENTS LIST
                  q262_selectedReceivedTmtList:
                    itemRow.selectedPrescribedTreatmentList ?? [],
                  q262_B_empty_err: false,
                  q262_B_invalid_date: false,
                  q262_C_empty_err: false,
                  q262_C_invalid_date: false,
                  q262_D_empty_err: false,
                  q262_D_txt_empty_err: false,
                  q262_DaraNotSelected_err: false,
                  q262_E_empty_err: false,
                  q262_F_empty_err: false,

                  prescribedTreatments: itemRow.prescribedTreatmentList,
                  prescribedTmtOtherID:
                    itemRow.prescribedTreatmentList
                      ?.find((item) => item.category === null)
                      ?.treatments?.find((tmt) =>
                        tmt.name?.includes("Other, please specify"),
                      )?.prescribedTreatmentId ?? null,

                  // Q26.3 (Element C) date-chain validation support
                  q263_ndmmIndexDate: itemRow.ndmmIndexDate ?? null,
                  q263_daraMinAdminDate: itemRow.daraMinAdminDate ?? null,
                  q263_daraMaxAdminDate: itemRow.daraMaxAdminDate ?? null,
                  q263_daraS121InitiationDate:
                    itemRow.daraS121InitiationDate ?? null,
                };
              },
            );

            // Q26.3.C - Date of daratumumab discontinuation, one row per prior LOT (1L to highest daratumumab LOT - 1)
            const daraDiscontinuationLotList =
              data.bispecificDaratumumabDiscontinuationLot ?? [];
            daraDiscontinuationLotList.forEach((daraDiscontinuationLot) => {
              const q263RowIdx = mappedBispecificHighestLot.findIndex(
                (r) => r.q262_rbl_A === daraDiscontinuationLot.lotnumber,
              );
              if (q263RowIdx >= 0) {
                mappedBispecificHighestLot[q263RowIdx] = {
                  ...mappedBispecificHighestLot[q263RowIdx],
                  q263_rbl_D: daraDiscontinuationLot.daraDiscontinuationUnk
                    ? 99
                    : !isStringEmpty(
                          daraDiscontinuationLot.daraDiscontinuationDate,
                        )
                      ? 1
                      : null,
                  q263_date_D:
                    daraDiscontinuationLot.daraDiscontinuationDate ?? null,
                };
              }
            });

            setBispecificHighestLotList(mappedBispecificHighestLot);
          }
        } else if (response?.status === HTTPResponse.Unauthorized) {
          HandleSessionTimeout();
        }
      }
    } catch (error) {
      ShowToast(CommonError_Msgs.LOAD_ERR, ToastMessageType.Failed);
    }
  };

  const HandleRepeaterFieldChange = (
    e,
    agentName,
    reasonName,
    parentIdx,
    itemidx,
    aeIdx = null,
    aeNeuroIdx = null,
  ) => {
    let { name, id, value } = e.target;
    let updatedArray = [...bispecificTreatment];
    const index = id.split("_").pop(); // Extract the index from the id

    const cohortIndex = parentIdx ?? Number(id.split("_").pop());

    // find agent index inside agentLists
    const agentIndex = updatedArray[cohortIndex]?.agentLists?.findIndex(
      (a) => a.agentName === agentName,
    );

    if (agentIndex === -1) return;

    switch (name) {
      // case `q26b_${agentName}_lottxt_${index}`:
      //   {
      //     const highestLotIndex = updatedArray.reduce(
      //       (maxIndex, item, index, arr) =>
      //         Number(item.lOT) > Number(arr[maxIndex].lOT) ? index : maxIndex,
      //       0,
      //     );
      //     //updatedArray[highestLotIndex].discontinueAgent =!isStringEmpty(value) ? (Number(value)> updatedArray[highestLotIndex].lOT?(updatedArray[highestLotIndex].discontinueAgent===2?"":updatedArray[highestLotIndex].discontinueAgent):updatedArray[highestLotIndex].discontinueAgent):updatedArray[highestLotIndex].discontinueAgent;

      //     updatedArray[highestLotIndex].discontinueAgent =
      //       !isStringEmpty(value) &&
      //       Number(value) > Number(updatedArray[highestLotIndex].lOT) &&
      //       updatedArray[highestLotIndex].discontinueAgent === 2
      //         ? ""
      //         : updatedArray[highestLotIndex].discontinueAgent;

      //     updatedArray[index].lOT = !isStringEmpty(value) ? Number(value) : "";
      //     updatedArray[index].showColBError = false;
      //     updatedArray[index].showColBDuplicateLotError = false;
      //     SavePage(false);
      //   }
      //   break;
      case `q26d_LRadio_${agentName}_${index}`:
        updatedArray[index].lastDateRadio = 1;
        updatedArray[index].lastDate = null;
        updatedArray[index].lastDateUnk = "";
        updatedArray[index].showColDError = false;
        updatedArray[index].showColD_SEFDateError = false;
        updatedArray[index].showColD_LEFDateError = false;
        updatedArray[index].showColD_DateError = false;
        updatedArray[index].showColD_SortedDateError = false;

        updatedArray[index].showColD_EFDateError = false;
        updatedArray[index].showColD_InvalidDate = false;
        updatedArray[index].q26ChainErr = false;
        updatedArray[index].q26ChainErrMsg = null;
        break;
      case `q26d_${agentName}_LUnk_${index}`:
        {
          updatedArray[index].lastDateRadio = "";
          updatedArray[index].lastDate = null;
          updatedArray[index].lastDateUnk = Number(value);
          updatedArray[index].showColDError = false;
          updatedArray[index].showColD_SEFDateError = false;
          updatedArray[index].showColD_LEFDateError = false;
          updatedArray[index].showColD_DateError = false;
          updatedArray[index].showColD_SortedDateError = false;

          updatedArray[index].showColD_EFDateError = false;
          updatedArray[index].showColD_InvalidDate = false;
          updatedArray[index].q26ChainErr = false;
          updatedArray[index].q26ChainErrMsg = null;

          if (agentName == "Talquetamab" && Number(value) != 1) {
            setTalAdministrationChanged(true);
          }
        }
        break;
      case `q26e_${agentName}_Noa_${index}`:
        {
          updatedArray[index].noOfAdmissionRadio = Number(value);
          updatedArray[index].noOfAdmission = "";
          updatedArray[index].noOfAdmissionUnk = "";
          updatedArray[index].noOfAdmissionUnkTxt = "";
          updatedArray[index].showColEError = false;
          updatedArray[index].showColEUkTxtError = false;
        }
        break;
      case `q26e_${agentName}_Noatxt_${index}`:
        {
          updatedArray[index].noOfAdmissionRadio = 1;
          updatedArray[index].noOfAdmission = !isStringEmpty(value)
            ? Number(value)
            : "";
          updatedArray[index].noOfAdmissionUnk = "";
          updatedArray[index].noOfAdmissionUnkTxt = "";
          updatedArray[index].showColEError = false;
          updatedArray[index].showColEUkTxtError = false;
        }
        break;
      case `q26e_${agentName}_NoaUnk_${index}`:
        {
          updatedArray[index].noOfAdmissionRadio = "";
          updatedArray[index].noOfAdmission = "";
          updatedArray[index].noOfAdmissionUnk = Number(value);
          updatedArray[index].noOfAdmissionUnkTxt = "";
          updatedArray[index].showColEError = false;
          updatedArray[index].showColEUkTxtError = false;
        }
        break;
      case `q26e_${agentName}_NoaUnktxt_${index}`:
        {
          updatedArray[index].noOfAdmissionRadio = "";
          updatedArray[index].noOfAdmission = "";
          updatedArray[index].noOfAdmissionUnk = 1;
          updatedArray[index].noOfAdmissionUnkTxt = value;
          updatedArray[index].showColEError = false;
          updatedArray[index].showColEUkTxtError = false;
        }
        break;
      case `q26h1_${agentName}_mg_${index}`:
        {
          updatedArray[index].doseAdministrationRadiomg = Number(value);
          updatedArray[index].doseAdministrationmg = "";
          updatedArray[index].doseAdministrationRadiokg = null;
          updatedArray[index].doseAdministrationkg = "";
          updatedArray[index].doseAdministrationRadiomgm = null;
          updatedArray[index].doseAdministrationmgm = "";
          updatedArray[index].doseAdministrationRadiocell = null;
          updatedArray[index].doseAdministrationcell = "";
          updatedArray[index].doseAdministrationRadioUnknown = null;
          updatedArray[index].showColHError = false;
        }
        break;
      case `q26h1_${agentName}_mgtxt_${index}`:
        {
          updatedArray[index].doseAdministrationRadiomg = 1;
          updatedArray[index].doseAdministrationmg = value; // !isStringEmpty(value) ? Number(value) : "";
          updatedArray[index].doseAdministrationRadiokg = null;
          updatedArray[index].doseAdministrationkg = "";
          updatedArray[index].doseAdministrationRadiomgm = null;
          updatedArray[index].doseAdministrationmgm = "";
          updatedArray[index].doseAdministrationRadiocell = null;
          updatedArray[index].doseAdministrationRadioUnknown = null;
          updatedArray[index].doseAdministrationcell = "";
          updatedArray[index].showColHError = false;
        }
        break;
      case `q26h2_${agentName}_kg_${index}`:
        {
          updatedArray[index].doseAdministrationRadiokg = Number(value);
          updatedArray[index].doseAdministrationkg = "";
          updatedArray[index].doseAdministrationRadiomg = null;
          updatedArray[index].doseAdministrationmg = "";
          updatedArray[index].doseAdministrationRadiomgm = null;
          updatedArray[index].doseAdministrationmgm = "";
          updatedArray[index].doseAdministrationRadiocell = null;
          updatedArray[index].doseAdministrationRadioUnknown = null;
          updatedArray[index].doseAdministrationcell = "";
          updatedArray[index].showColHError = false;
        }
        break;
      case `q26h2_${agentName}_kgtxt_${index}`:
        {
          updatedArray[index].doseAdministrationRadiokg = 1;
          updatedArray[index].doseAdministrationkg = value; // !isStringEmpty(value) ? Number(value) : "";
          updatedArray[index].doseAdministrationRadiomg = null;
          updatedArray[index].doseAdministrationmg = "";
          updatedArray[index].doseAdministrationRadiomgm = null;
          updatedArray[index].doseAdministrationmgm = "";
          updatedArray[index].doseAdministrationRadiocell = null;
          updatedArray[index].doseAdministrationRadioUnknown = null;
          updatedArray[index].doseAdministrationcell = "";
          updatedArray[index].showColHError = false;
        }
        break;
      case `q26h3_${agentName}_m_${index}`:
        {
          updatedArray[index].doseAdministrationRadiomgm = Number(value);
          updatedArray[index].doseAdministrationmgm = "";
          updatedArray[index].doseAdministrationRadiokg = null;
          updatedArray[index].doseAdministrationkg = "";
          updatedArray[index].doseAdministrationRadiomg = null;
          updatedArray[index].doseAdministrationmg = "";
          updatedArray[index].doseAdministrationRadiocell = null;
          updatedArray[index].doseAdministrationRadioUnknown = null;
          updatedArray[index].doseAdministrationcell = "";
          updatedArray[index].showColHError = false;
        }
        break;
      case `q26h3_${agentName}_mtxt_${index}`:
        {
          updatedArray[index].doseAdministrationRadiomgm = 1;
          updatedArray[index].doseAdministrationmgm = value; // !isStringEmpty(value) ? Number(value) : "";
          updatedArray[index].doseAdministrationRadiokg = null;
          updatedArray[index].doseAdministrationkg = "";
          updatedArray[index].doseAdministrationRadiomg = null;
          updatedArray[index].doseAdministrationmg = "";
          updatedArray[index].doseAdministrationRadiocell = null;
          updatedArray[index].doseAdministrationRadioUnknown = null;
          updatedArray[index].doseAdministrationcell = "";
          updatedArray[index].showColHError = false;
        }
        break;
      case `q26h4_${agentName}_cell_${index}`:
        {
          updatedArray[index].doseAdministrationRadiocell = Number(value);
          updatedArray[index].doseAdministrationcell = "";
          updatedArray[index].doseAdministrationRadiokg = null;
          updatedArray[index].doseAdministrationkg = "";
          updatedArray[index].doseAdministrationRadiomg = null;
          updatedArray[index].doseAdministrationmg = "";
          updatedArray[index].doseAdministrationRadiomgm = null;
          updatedArray[index].doseAdministrationRadioUnknown = null;
          updatedArray[index].doseAdministrationmgm = "";
          updatedArray[index].showColHError = false;
        }
        break;
      case `q26h4_${agentName}_celltxt_${index}`:
        {
          updatedArray[index].doseAdministrationRadiocell = 1;
          updatedArray[index].doseAdministrationcell = value; // !isStringEmpty(value) ? Number(value) : "";
          updatedArray[index].doseAdministrationRadiokg = null;
          updatedArray[index].doseAdministrationkg = "";
          updatedArray[index].doseAdministrationRadiomg = null;
          updatedArray[index].doseAdministrationmg = "";
          updatedArray[index].doseAdministrationRadiomgm = null;
          updatedArray[index].doseAdministrationRadioUnknown = null;
          updatedArray[index].doseAdministrationmgm = "";
          updatedArray[index].showColHError = false;
        }
        break;
      case `q26h4_${agentName}_doseUnk_${index}`:
        {
          updatedArray[index].doseAdministrationRadiocell = null;
          updatedArray[index].doseAdministrationcell = "";
          updatedArray[index].doseAdministrationRadiokg = null;
          updatedArray[index].doseAdministrationkg = "";
          updatedArray[index].doseAdministrationRadiomg = null;
          updatedArray[index].doseAdministrationmg = "";
          updatedArray[index].doseAdministrationRadiomgm = null;
          updatedArray[index].doseAdministrationmgm = "";
          updatedArray[index].doseAdministrationRadioUnknown = Number(value);
          updatedArray[index].showColHError = false;
        }
        break;

      case `q26f_${agentName}_PdaYes_${index}`:
      case `q26f_${agentName}_PdaNo_${index}`:
      case `q26f_${agentName}_PdaUnk_${index}`:
        {
          updatedArray[index].discontinueAgent = Number(value);
          updatedArray[index].showColFError = false;
          updatedArray[index].showColGError = false;
          updatedArray[index].showColGUnknownError = false;
          updatedArray[index].showColGOthError = false;
          updatedArray[index].showColG = Number(value) === 1 ? true : false;
          if (Number(value) !== 1)
            updatedArray[index].reasonForDiscontinuingMedications =
              updatedArray[index].reasonForDiscontinuingMedications.map(
                (item) => {
                  return { ...item, isSelected: false, reasonUnk: "" };
                },
              );
        }
        break;

      case `discont_${parentIdx}_${agentName}_${reasonName}_${itemidx}`:
        {
          updatedArray[parentIdx].reasonForDiscontinuingMedications[
            itemidx
          ].cohorttreatmentid = updatedArray[parentIdx].cohorttreatmentid;
          updatedArray[parentIdx].reasonForDiscontinuingMedications[
            itemidx
          ].isSelected =
            !updatedArray[parentIdx].reasonForDiscontinuingMedications[itemidx]
              .isSelected;
          updatedArray[
            parentIdx
          ].reasonForDiscontinuingMedications[0].reasonUnk = "";
          updatedArray[parentIdx].showColGError = false;
          updatedArray[parentIdx].showColGOthError = false;
          updatedArray[parentIdx].showColGUnknownError = false;

          if (
            updatedArray[parentIdx].reasonForDiscontinuingMedications[0]
              .reasonName === DiscontinuationReason.PatientDeath &&
            updatedArray[parentIdx].reasonForDiscontinuingMedications[0]
              .isSelected === true &&
            !deathDeath // <-- adjust to your actual Q20 field
          ) {
            // show validation error (example)
            updatedArray[parentIdx].discontinuationSoftError = true;
          } else {
            updatedArray[parentIdx].discontinuationSoftError = false;
          }

          if (reasonName === DiscontinuationReason.AdverseEvent) {
            const aeList =
              updatedArray[parentIdx].adverseEventsDiscontinuationreason;
            if (aeList?.length) {
              aeList.forEach((ae) => {
                ae.isSelected = false;
              });
            }
            const aeNeuroList =
              updatedArray[parentIdx]
                .adverseNeurologicalEventsDiscontinuationreason;
            if (aeNeuroList?.length) {
              aeNeuroList.forEach((ae) => {
                ae.isSelected = false;
                if (ae.reasonName?.includes("Other")) {
                  ae.reasonText = "";
                }
              });
            }
          }

          if (
            updatedArray[parentIdx].reasonForDiscontinuingMedications[
              itemidx
            ].reasonName.includes("Other")
          ) {
            if (
              updatedArray[parentIdx].reasonForDiscontinuingMedications[itemidx]
                .isSelected == false
            )
              updatedArray[parentIdx].reasonForDiscontinuingMedications[
                itemidx
              ].reasonText = "";
          }
        }
        break;
      case `discont_unk_${agentName}_${parentIdx}`:
        {
          updatedArray[parentIdx].showColGError = false;
          updatedArray[parentIdx].showColGOthError = false;
          updatedArray[parentIdx].showColGUnknownError = true;
          updatedArray[parentIdx].reasonForDiscontinuingMedications =
            updatedArray[parentIdx].reasonForDiscontinuingMedications.map(
              (item) => {
                return {
                  ...item,
                  isSelected: false,
                  reasonUnk: 1,
                  reasonText: "",
                };
              },
            );

          updatedArray[parentIdx].adverseEventsDiscontinuationreason =
            updatedArray[parentIdx].adverseEventsDiscontinuationreason.map(
              (r) => ({
                ...r,
                isSelected: false,
              }),
            );

          updatedArray[
            parentIdx
          ].adverseNeurologicalEventsDiscontinuationreason = updatedArray[
            parentIdx
          ].adverseNeurologicalEventsDiscontinuationreason.map((r) => ({
            ...r,
            isSelected: false,
            reasonUnk: true,
            reasonText: "",
          }));
        }
        break;
      case `discont_${parentIdx}_${agentName}_${reasonName}txt_${itemidx}`:
        {
          updatedArray[parentIdx].showColGError = false;
          updatedArray[parentIdx].showColGOthError = false;
          updatedArray[parentIdx].showColGUnknownError = false;
          updatedArray[
            parentIdx
          ].reasonForDiscontinuingMedications[0].reasonUnk = "";
          updatedArray[parentIdx].reasonForDiscontinuingMedications[
            itemidx
          ].isSelected = updatedArray[
            parentIdx
          ].reasonForDiscontinuingMedications[itemidx]?.reasonName.includes(
            "Other",
          )
            ? true
            : false;

          if (value.length <= 300) {
            updatedArray[parentIdx].reasonForDiscontinuingMedications[
              itemidx
            ].reasonText = value;
          } else {
            updatedArray[parentIdx].reasonForDiscontinuingMedications[
              itemidx
            ].reasonText = value.substring(0, 300);
          }
        }
        break;

      case `adverse_${agentName}_${parentIdx}_${itemidx}_${aeIdx}`: {
        const aeList =
          updatedArray[parentIdx].adverseEventsDiscontinuationreason;

        if (!aeList) return;
        const selectedAE = aeList[aeIdx];

        const isAEUnknown = selectedAE.reasonName === "AE type unknown";

        if (isAEUnknown) {
          // Radio behavior
          aeList.forEach((ae) => (ae.isSelected = false));
          selectedAE.isSelected = true;
        } else {
          // Checkbox behavior
          aeList.forEach((ae) => {
            if (ae.reasonName === "AE type unknown") {
              ae.isSelected = false;
            }
          });
          selectedAE.isSelected = !selectedAE.isSelected;
        }

        if (
          selectedAE.reasonName === DiscontinuationReason.NeurologicalEvent &&
          !selectedAE.isSelected
        ) {
          const aeNeuroList =
            updatedArray[parentIdx]
              .adverseNeurologicalEventsDiscontinuationreason;
          if (aeNeuroList?.length) {
            aeNeuroList.forEach((ae) => {
              ae.isSelected = false;
              if (ae.reasonName?.includes("Other")) {
                ae.reasonText = "";
              }
            });
          }
        }

        break;
      }
      case `adverse_${agentName}_${itemidx}_${aeIdx}_${aeNeuroIdx}`: {
        const aeNeuroList =
          updatedArray[parentIdx]
            .adverseNeurologicalEventsDiscontinuationreason;
        const aeList =
          updatedArray[parentIdx].adverseEventsDiscontinuationreason;

        if (!aeNeuroList) return;
        const reasonae = aeList[aeIdx];
        const selectedAENeuro = aeNeuroList[aeNeuroIdx];

        selectedAENeuro.isSelected = !selectedAENeuro.isSelected;

        if (
          !selectedAENeuro.isSelected &&
          selectedAENeuro.reasonName?.includes("Other")
        ) {
          selectedAENeuro.reasonText = "";
        }

        // Keep parent reason selected
        reasonae.isSelected = true;

        break;
      }
      case `discont_${agentName}_${reasonName}txt_${itemidx}_${aeNeuroIdx}`: {
        const aeNeuroList =
          updatedArray[parentIdx]
            .adverseNeurologicalEventsDiscontinuationreason;
        aeNeuroList.isSelected = true;
        aeNeuroList.reasonText =
          value.length <= 300 ? value : value.slice(0, 300);

        if (!aeNeuroList) return;
        const selectedAENeuro = aeNeuroList[aeNeuroIdx];

        selectedAENeuro.isSelected = true;
        selectedAENeuro.reasonText = aeNeuroList.reasonText;

        break;
      }

      default:
        break;
    }
    setbispecificTreatment(updatedArray);
  };

  const HandleQ26OneRepeaterFieldChange = (
    e,
    agentName,
    reasonName,
    parentIdx,
    itemidx,
    aeIdx = null,
    aeNeuroIdx = null,
  ) => {
    const { name, id, value } = e.target;
    const storedData = GetLocalStorageData("CohortTreatment");
    const updatedArray = [...bispecificAgent];
    const cohortIndex = parentIdx ?? Number(id.split("_").pop());

    // find agent index inside agentLists
    const agentIndex = updatedArray[cohortIndex].agentLists.findIndex(
      (a) => a.agentName === agentName,
    );

    if (agentIndex === -1) return;

    const agent = updatedArray[cohortIndex].agentLists[agentIndex];

    switch (name) {
      /* ---------- Last date of administration ---------- */
      case `q26_one_date_last_admin_radio_${agentName}_${cohortIndex}`: {
        agent.lastDateRadio = 1;
        agent.lastDateUnk = "";
        agent.showColDError = false;
        agent.q261ChainErr = false;
        agent.q261ChainErrMsg = null;
        agent.q261ChainErrField = null;
        agent.agentDateError = false;
        agent.agentSortedDateError = false;
        break;
      }

      case `q26_one_${agentName}_LUnk_${cohortIndex}`: {
        agent.lastDateRadio = null;
        agent.lastDate = null;
        agent.lastDateUnk = Number(value);
        agent.showColDError = false;
        agent.q261ChainErr = false;
        agent.q261ChainErrMsg = null;
        agent.q261ChainErrField = null;
        agent.agentDateError = false;
        agent.agentSortedDateError = false;
        break;
      }

      case `q26_one_${agentName}_FirstSiteCare_${cohortIndex}`: {
        agent.firstSiteCareC = Number(value);
        agent.showFirstSiteCareError = false;
        break;
      }

      case `q26_one_second_admin_date_radio_${agentName}_${cohortIndex}`: {
        agent.secondDateRadio = 1;
        agent.secondDate = null;
        agent.secondDateUnk = "";
        agent.secondNotReceived = null;
        agent.showSecondDateError = false;
        agent.showSecondDateRangeError = false;
        break;
      }

      case `q26_one_${agentName}_SecondDateUnk_${cohortIndex}`: {
        agent.secondDateRadio = null;
        agent.secondDate = null;
        agent.secondDateUnk = Number(value);
        agent.secondNotReceived = null;
        agent.showSecondDateError = false;
        agent.showSecondDateRangeError = false;
        break;
      }

      case `q26_one_${agentName}_SecondNotReceived_${cohortIndex}`: {
        agent.secondNotReceived = Number(value);
        agent.secondDateRadio = null;
        agent.secondDate = null;
        agent.secondDateUnk = "";
        agent.secondSiteCareC = null;
        agent.showSecondDateError = false;
        agent.showSecondDateRangeError = false;
        agent.showSecondSiteCareError = false;
        break;
      }

      case `q26_one_${agentName}_SecondSiteCare_${cohortIndex}`: {
        agent.secondSiteCareC = Number(value);
        agent.showSecondSiteCareError = false;
        break;
      }

      /* ---------- Number of administrations ---------- */
      case `q26_one_${agentName}_No_Admin_${cohortIndex}`: {
        agent.noOfAdmissionRadio = 1;
        agent.noOfAdmission = null;
        agent.noOfAdmissionUnk = null;
        agent.noOfAdmissionUnkTxt = "";
        agent.showColEError = false;
        agent.showColEUkTxtError = false;
        break;
      }

      case `q26_one_${agentName}_No_Admintxt_${cohortIndex}`: {
        agent.noOfAdmissionRadio = 1;
        agent.noOfAdmission = value ? Number(value) : "";
        agent.noOfAdmissionUnk = "";
        agent.noOfAdmissionUnkTxt = "";
        agent.showColEError = false;
        agent.showColEUkTxtError = false;
        break;
      }

      case `q26_one_${agentName}_No_Admin_Unk_${cohortIndex}`: {
        agent.noOfAdmissionRadio = null;
        agent.noOfAdmission = "";
        agent.noOfAdmissionUnk = 1;
        agent.noOfAdmissionUnkTxt = "";
        agent.showColEError = false;
        agent.showColEUkTxtError = false;
        break;
      }

      case `q26_one_${agentName}_No_Admin_Unktxt_${cohortIndex}`: {
        agent.noOfAdmissionRadio = "";
        agent.noOfAdmission = "";
        agent.noOfAdmissionUnk = 1;
        agent.noOfAdmissionUnkTxt = value;
        agent.showColEError = false;
        agent.showColEUkTxtError = false;
        break;
      }

      /* ---------- Dose administration ---------- */
      case `q26_one_${agentName}_mg_${cohortIndex}`: {
        agent.doseAdministrationRadiomg = 1;
        //  agent.doseAdministrationmg = "";
        agent.doseAdministrationRadiokg = null;
        agent.doseAdministrationRadiomgm = null;
        agent.doseAdministrationRadioUnknown = null;
        agent.doseAdministrationkg = "";
        agent.doseAdministrationmgm = "";
        agent.showColHError = false;
        break;
      }

      case `q26_one_${agentName}_mgtxt_${cohortIndex}`: {
        agent.doseAdministrationRadiomg = 1;
        agent.doseAdministrationmg = value;
        agent.doseAdministrationkg = "";
        agent.doseAdministrationmgm = "";
        agent.doseAdministrationRadiokg = null;
        agent.doseAdministrationRadiomgm = null;
        agent.doseAdministrationRadioUnknown = null;
        agent.showColHError = false;
        break;
      }

      case `q26_one_${agentName}_kg_${cohortIndex}`: {
        agent.doseAdministrationRadiokg = 1;
        // agent.doseAdministrationkg = "";
        agent.doseAdministrationRadiomg = null;
        agent.doseAdministrationRadiomgm = null;
        agent.doseAdministrationRadioUnknown = null;
        agent.doseAdministrationmg = "";
        agent.doseAdministrationmgm = "";
        agent.showColHError = false;
        break;
      }

      case `q26_one_${agentName}_kgtxt_${cohortIndex}`: {
        agent.doseAdministrationRadiokg = 1;
        agent.doseAdministrationkg = value;
        agent.doseAdministrationmg = "";
        agent.doseAdministrationmgm = "";
        agent.doseAdministrationRadiomg = null;
        agent.doseAdministrationRadiomgm = null;
        agent.doseAdministrationRadioUnknown = null;
        agent.showColHError = false;
        break;
      }

      case `q26_one_${agentName}_m_${cohortIndex}`: {
        agent.doseAdministrationRadiomgm = 1;
        //agent.doseAdministrationmgm = "";
        agent.doseAdministrationRadiomg = null;
        agent.doseAdministrationRadiokg = null;
        agent.doseAdministrationRadioUnknown = null;
        agent.doseAdministrationmg = "";
        agent.doseAdministrationkg = "";
        agent.showColHError = false;
        break;
      }

      case `q26_one_${agentName}_mtxt_${cohortIndex}`: {
        agent.doseAdministrationRadiomgm = 1;
        agent.doseAdministrationmgm = value;
        agent.doseAdministrationmg = "";
        agent.doseAdministrationkg = "";
        agent.doseAdministrationRadiomg = null;
        agent.doseAdministrationRadiokg = null;
        agent.doseAdministrationRadioUnknown = null;
        agent.showColHError = false;
        break;
      }

      case `q26_one_${agentName}_doseUnk_${cohortIndex}`: {
        agent.doseAdministrationRadioUnknown = 99;
        agent.doseAdministrationRadiomg = null;
        agent.doseAdministrationRadiokg = null;
        agent.doseAdministrationRadiomgm = null;
        agent.doseAdministrationmg = "";
        agent.doseAdministrationkg = "";
        agent.doseAdministrationmgm = "";
        agent.showColHError = false;
        break;
      }

      /* ---------- Discontinue agent ---------- */
      case `q26_1_${agentName}_PdaYes_${cohortIndex}`:
      case `q26_1_${agentName}_PdaNo_${cohortIndex}`:
      case `q26_one_${agentName}_PdaUnk_${cohortIndex}`: {
        agent.discontinueAgent = Number(value);
        agent.showColG = Number(value) === 1;
        agent.showColFError = false;

        if (Number(value) !== 1) {
          agent.reasonForDiscontinuingMedications =
            agent.reasonForDiscontinuingMedications.map((r) => ({
              ...r,
              isSelected: false,
              reasonUnk: false,
              reasonText: "",
            }));
        }

        if (agent.lastDateUnk && agent.discontinueAgent == 2) {
          agent.lastAdministrationSoftError = true;
        } else {
          agent.lastAdministrationSoftError = false;
        }

        if (agent.discontinueAgent == 99) {
          agent.discontinuationUnkSoftError = true;
        } else {
          agent.discontinuationUnkSoftError = false;
        }

        break;
      }

      /* ---------- Reasons for discontinuation ---------- */
      case `discont_${agentName}_${reasonName}_${itemidx}`: {
        const reason = agent.reasonForDiscontinuingMedications[itemidx];
        reason.isSelected = !reason.isSelected;
        agent.showColGError = false;
        agent.showColGUnknownError = false;
        agent.showColGOthError = false;

        if (
          agent.reasonForDiscontinuingMedications[0].reasonName ===
            DiscontinuationReason.PatientDeath &&
          agent.reasonForDiscontinuingMedications[0].isSelected &&
          !deathDeath // <-- adjust to your actual Q20 field
        ) {
          // show validation error (example)
          agent.discontinuationSoftError = true;
        } else {
          agent.discontinuationSoftError = false;
        }

        // 🔹 CLEAR adverse events when unselected
        if (
          reason.reasonName === DiscontinuationReason.AdverseEvent &&
          !reason.isSelected
        ) {
          const aeList = agent.adverseEventsDiscontinuationreason;
          if (aeList?.length) {
            aeList.forEach((ae) => {
              ae.isSelected = false;
            });
          }
          const aeNeuroList =
            agent.adverseNeurologicalEventsDiscontinuationreason;
          if (aeNeuroList?.length) {
            aeNeuroList.forEach((ae) => {
              ae.isSelected = false;
              if (ae.reasonName?.includes("Other")) {
                ae.reasonText = "";
              }
            });
          }
        }

        agent.reasonForDiscontinuingMedications[0].reasonUnk = false;
        if (reason.reasonName.includes("Other") && !reason.isSelected) {
          reason.reasonText = "";
        }

        break;
      }

      case `discont_unk_${agentName}_${cohortIndex}`: {
        agent.showColGError = false;
        agent.showColGOthError = false;
        agent.showColGUnknownError = false;
        agent.reasonForDiscontinuingMedications =
          agent.reasonForDiscontinuingMedications.map((r) => ({
            ...r,
            isSelected: false,
            reasonUnk: true,
            reasonText: "",
          }));

        agent.adverseEventsDiscontinuationreason =
          agent.adverseEventsDiscontinuationreason.map((r) => ({
            ...r,
            isSelected: false,
          }));

        agent.adverseNeurologicalEventsDiscontinuationreason =
          agent.adverseNeurologicalEventsDiscontinuationreason.map((r) => ({
            ...r,
            isSelected: false,
            reasonUnk: true,
            reasonText: "",
          }));

        break;
      }

      case `discont_${agentName}_${reasonName}txt_${itemidx}`: {
        const reason = agent.reasonForDiscontinuingMedications[itemidx];
        reason.isSelected = true;
        reason.reasonText = value.length <= 300 ? value : value.slice(0, 300);
        agent.reasonForDiscontinuingMedications[0].reasonUnk = false;
        agent.showColGError = false;
        agent.showColGOthError = false;
        break;
      }

      case `adverse_${agentName}_${itemidx}_${aeIdx}`: {
        const aeList = agent.adverseEventsDiscontinuationreason;

        if (!aeList) return;
        const reason = agent.reasonForDiscontinuingMedications[itemidx];
        const selectedAE = aeList[aeIdx];

        const isAEUnknown = selectedAE.reasonName === "AE type unknown";

        if (isAEUnknown) {
          // Radio behavior
          aeList.forEach((ae) => (ae.isSelected = false));
          selectedAE.isSelected = true;
        } else {
          // Checkbox behavior
          aeList.forEach((ae) => {
            if (ae.reasonName === "AE type unknown") {
              ae.isSelected = false;
            }
          });
          selectedAE.isSelected = !selectedAE.isSelected;
        }

        if (
          selectedAE.reasonName === DiscontinuationReason.NeurologicalEvent &&
          !selectedAE.isSelected
        ) {
          const aeNeuroList =
            agent.adverseNeurologicalEventsDiscontinuationreason;
          if (aeNeuroList?.length) {
            aeNeuroList.forEach((ae) => {
              ae.isSelected = false;
              if (ae.reasonName?.includes("Other")) {
                ae.reasonText = "";
              }
            });
          }
        }

        // Keep parent reason selected
        reason.isSelected = true;
        agent.reasonForDiscontinuingMedications[0].reasonUnk = false;
        agent.discontinuationSoftError = false;
        agent.showAdverseEventError = false;

        break;
      }

      case `adverse_${agentName}_${itemidx}_${aeIdx}_${aeNeuroIdx}`: {
        const aeNeuroList =
          agent.adverseNeurologicalEventsDiscontinuationreason;
        const aeList = agent.adverseEventsDiscontinuationreason;

        if (!aeNeuroList) return;
        const reasonae = aeList[aeIdx];
        const selectedAENeuro = aeNeuroList[aeNeuroIdx];

        selectedAENeuro.isSelected = !selectedAENeuro.isSelected;

        if (
          !selectedAENeuro.isSelected &&
          selectedAENeuro.reasonName?.includes("Other")
        ) {
          selectedAENeuro.reasonText = "";
        }

        // Keep parent reason selected
        reasonae.isSelected = true;
        agent.discontinuationSoftError = false;
        agent.showAdverseEventError = false;
        agent.showAdverseNeuroEventError = false;
        agent.showAdverseNeuroEventOtherTextError = false;

        break;
      }

      case `discont_${agentName}_${reasonName}txt_${itemidx}_${aeNeuroIdx}`: {
        const aeNeuroList =
          agent.adverseNeurologicalEventsDiscontinuationreason;
        aeNeuroList.isSelected = true;
        aeNeuroList.reasonText =
          value.length <= 300 ? value : value.slice(0, 300);

        if (!aeNeuroList) return;
        const selectedAENeuro = aeNeuroList[aeNeuroIdx];

        selectedAENeuro.isSelected = true;
        selectedAENeuro.reasonText = aeNeuroList.reasonText;

        agent.discontinuationSoftError = false;
        agent.showAdverseNeuroEventError = false;
        agent.showAdverseNeuroEventOtherTextError = false;
        break;
      }
      default:
        break;
    }
    setbispecificAgent(updatedArray);
  };

  const HandleQ26OneDateChange = (name, date, agentName) => {
    const updatedArray = [...bispecificAgent];
    const cohortIndex = Number(name.split("_").pop());
    // find agent index inside agentLists
    const agentIndex = updatedArray[cohortIndex].agentLists.findIndex(
      (a) => a.agentName === agentName,
    );

    if (agentIndex === -1) return;

    const agent = updatedArray[cohortIndex].agentLists[agentIndex];

    switch (name) {
      case `q26_one_last_admin_date_${cohortIndex}`:
        agent.lastDateRadio = 1;
        agent.lastDate = date;
        agent.lastDateUnk = "";
        agent.showColDError = false;
        agent.showColD_SEFDateError = false;
        agent.showColD_LEFDateError = false;
        agent.showColD_DateError = false;
        agent.showColD_EFDateError = false;
        agent.showColD_InvalidDate = false;
        agent.q261ChainErr = false;
        agent.q261ChainErrMsg = null;
        agent.q261ChainErrField = null;
        agent.agentDateError = false;
        agent.agentSortedDateError = false;
        break;
      case `q26_one_second_admin_date_${cohortIndex}`:
        agent.secondDateRadio = 1;
        agent.secondDate = date;
        agent.secondDateUnk = "";
        agent.secondNotReceived = null;
        agent.showSecondDateError = false;
        agent.showSecondDateRangeError = false;
        break;

      default:
        break;
    }
    setbispecificAgent(updatedArray);
  };

  const HandleDateChange = (name, date, optionId, monthOrYearSelect) => {
    let updatedArray = [...bispecificTreatment];
    const idx = name.split("_").pop();

    switch (name) {
      case `q26d_LDate_${idx}`:
        updatedArray[idx].lastDateRadio = 1;
        updatedArray[idx].lastDate = date;
        updatedArray[idx].lastDateUnk = "";
        updatedArray[idx].showColDError = false;
        updatedArray[idx].showColD_SEFDateError = false;
        updatedArray[idx].showColD_LEFDateError = false;
        updatedArray[idx].showColD_DateError = false;
        updatedArray[idx].showColD_SortedDateError = false;

        updatedArray[idx].showColD_EFDateError = false;
        updatedArray[idx].showColD_InvalidDate = false;
        updatedArray[idx].q26ChainErr = false;
        updatedArray[idx].q26ChainErrMsg = null;
        break;

      default:
        break;
    }
    setbispecificTreatment(updatedArray);
  };

  const SavePage = async (validate, showSucessMsg = true) => {
    try {
      if (isSaving) return;
      setIsSaving(true);

      let isValid = true;
      if (validate) {
        const { isValid: isChainValid, updatedRepeater: chainCheckedRepeater } =
          CheckQ26FullDateChain(bispecificTreatment);
        const { isValid: isLotSequenceValid, updatedRepeater } =
          CheckQ26LotSequenceChain(chainCheckedRepeater);
        const {
          isValid: isChain261Valid,
          updatedBispecificAgent: chainCheckedAgent,
        } = CheckQ261FullDateChain(bispecificAgent);
        const { isValid: isLotSequence261Valid, updatedBispecificAgent } =
          CheckQ261LotSequenceChain(chainCheckedAgent);
        const {
          isValid: isChain262Valid,
          updatedRepeater: chainCheckedHighestLotList,
        } = CheckQ262FullDateChain(
          bispecificHighestLotList,
          subsequentLotStartDate,
        );
        const {
          isValid: isRowChain262Valid,
          updatedRepeater: rowChainCheckedHighestLotList,
        } = CheckQ262RowLevelDateChain(chainCheckedHighestLotList);
        const isRepeaterValid = ValidateRepeaterData(
          updatedRepeater,
          updatedBispecificAgent,
          rowChainCheckedHighestLotList,
        );
        isValid =
          isChainValid &&
          isLotSequenceValid &&
          isChain261Valid &&
          isLotSequence261Valid &&
          isChain262Valid &&
          isRowChain262Valid &&
          isRepeaterValid;
      }
      // Wait for user confirmation if changes detected
      const canContinue = await handleCheckChanges(bispecificTreatment);
      if (!canContinue) {
        ToggleLoader(false);
        return; // user clicked No, stop execution
      }

      if (isValid) {
        ToggleLoader(true);
        setShowTopErrMsg(false);

        const RRMMData = bispecificTreatment.map((item) => ({
          cohorttreatmentid: item.cohorttreatmentid,
          cohortTreatmentName: item.cohortTreatmentName || null,
          cohortIndexDate: item.cohortInitiationDate || null,
          supscripttext: item.cohortTreatmentNameSuperscript,
          bispecificTreatmentcohortid: item.bispecificTreatmentcohortid,
          lOT: item.lOT,
          firstDate: item.firstDate,
          lastDate: item.lastDate,
          lastDateRadio: item.lastDateRadio,
          lastDateUnk: item.lastDateUnk,
          noOfAdmission: item.noOfAdmission,
          noOfAdmissionRadio: item.noOfAdmissionRadio,
          noOfAdmissionUnk: item.noOfAdmissionUnk,
          noOfAdmissionUnkTxt: item.noOfAdmissionUnkTxt,
          doseAdministrationRadiomg: item.doseAdministrationRadiomg,
          doseAdministrationmg: item.doseAdministrationmg,
          doseAdministrationRadiokg: item.doseAdministrationRadiokg,
          doseAdministrationkg: item.doseAdministrationkg,
          doseAdministrationRadiomgm: item.doseAdministrationRadiomgm,
          doseAdministrationmgm: item.doseAdministrationmgm,
          doseAdministrationRadiocell: item.doseAdministrationRadiocell,
          doseAdministrationcell: item.doseAdministrationcell,
          doseAdministrationRadioUnknown: item.doseAdministrationRadioUnknown,
          discontinueAgent: item.discontinueAgent,
          firstSiteCareC: item.firstSiteCareC,
          secondDate: item.secondDate,
          secondDateRadio: item.secondDateRadio,
          secondDateUnk: item.secondDateUnk,
          secondSiteCareC: item.secondSiteCareC,
          reasonForDiscontinuingMedications:
            item.reasonForDiscontinuingMedications,
          adverseEventsDiscontinuationreason:
            item.adverseEventsDiscontinuationreason,
          adverseNeurologicalEventsDiscontinuationreason:
            item.adverseNeurologicalEventsDiscontinuationreason,
        }));

        let bispecificHighestLotListData = [];
        if (bispecificHighestLotList && bispecificHighestLotList.length > 0) {
          bispecificHighestLotListData = bispecificHighestLotList.map((a) => ({
            Cohorttreatmentid: a.cohorttreatmentid,
            // LOT DETAILS
            Lotnumber: a.q262_rbl_A,
            LotStartdateUnk: a.q262_rbl_B === 99,
            LotStartdate:
              (a.q262_rbl_B === 1 && a.q262_date_B != "Invalid Date") ||
              !isStringEmpty(a.q262_autodate_B)
                ? a.q262_date_B
                : null,
            LotEnddateUnk: a.q262_rbl_C === 99,
            LotEnddate:
              (a.q262_rbl_C === 1 && a.q262_date_C != "Invalid Date") ||
              !isStringEmpty(a.q262_autodate_C)
                ? a.q262_date_C
                : null,
            ReceivedLot: a.q262_rbl_E,
            RefractoryTreatment: a.q262_rbl_F,

            // AGENTS REFRACTORY (Element C)
            AgentRefractoryLena: a.q262_agentRefractoryLena,
            AgentRefractoryDara: a.q262_agentRefractoryDara,
            AgentRefractoryDarafaspro: a.q262_agentRefractoryDarafaspro,
            AgentRefractoryIsatu: a.q262_agentRefractoryIsatu,
            AgentRefractoryNone: a.q262_agentRefractoryNone,

            // RECEIVED TREATMENT FLAGS
            //a.chk_q262_received_tmt,
            TreatmentReceivedUnknown: a.q262_rb_received_tmt_unk,

            SelectedPrescribedTreatmentList: a.q262_selectedReceivedTmtList.map(
              (x) => ({
                ...x,
                prescribedTreatmentId: x.prescribedTreatmentId,
                prescribedTreatmentOthTxt: x.prescribedTreatmentOthTxt,
              }),
            ),
          }));
        }

        // Q26.3.C - Date of daratumumab discontinuation on the eligible prior LOT (highest daratumumab LOT within 1L to max LOT - 1)
        let bispecificDaratumumabDiscontinuationLot = [];
        if (isNewEcrfC) {
          const q263EligibleRow = GetQ263EligibleRow(bispecificHighestLotList);

          bispecificDaratumumabDiscontinuationLot = (
            q263EligibleRow ? [q263EligibleRow] : []
          )
            .map((q263Row) => ({
              q263Row,
              discInfo: GetQ263DiscontinuationInfo(q263Row),
            }))
            .filter(
              ({ discInfo }) =>
                !isStringEmpty(discInfo.date) || discInfo.isUnknown,
            )
            .map(({ q263Row, discInfo }) => ({
              Cohorttreatmentid: q263Row.cohorttreatmentid,
              Lotnumber: q263Row.q262_rbl_A,
              LotStartdateUnk: q263Row.q262_rbl_B === 99,
              LotStartdate: !isStringEmpty(q263Row.q262_autodate_B)
                ? q263Row.q262_autodate_B
                : q263Row.q262_rbl_B === 1 &&
                    q263Row.q262_date_B != "Invalid Date"
                  ? q263Row.q262_date_B
                  : null,
              LotEnddateUnk: q263Row.q262_rbl_C === 99,
              LotEnddate: !isStringEmpty(q263Row.q262_autodate_C)
                ? q263Row.q262_autodate_C
                : q263Row.q262_rbl_C === 1 &&
                    q263Row.q262_date_C != "Invalid Date"
                  ? q263Row.q262_date_C
                  : null,
              DaraDiscontinuationUnk: discInfo.isUnknown,
              DaraDiscontinuationDate:
                !isStringEmpty(discInfo.date) && discInfo.date != "Invalid Date"
                  ? discInfo.date
                  : null,
            }));
        }

        const RRMMModel = {
          Patientid: pid,
          loggedInUserId: GetLoggedInUserID(),
          isValidated: validate,
          medicationTreatmentLists: RRMMData,
          bispecificCartTreatmentAgentList: bispecificAgent,
          bispecificHighestLot: bispecificHighestLotListData,
          bispecificDaratumumabDiscontinuationLot,
          IsAdmin: IsAdmin(),
        };
        if (pid > 0) {
          let response =
            await BispecificsCartTreatmentCohortService.SaveBispecificCartTreatmentCohortData(
              RRMMModel,
            );

          if (response.status !== HTTPResponse.OK) {
            if (response?.status === HTTPResponse.Unauthorized) {
              HandleSessionTimeout();
            } else throw response.error;
          } else {
            if (showSucessMsg)
              ShowToast(ToastMessages.Save_Success, ToastMessageType.Success);

            await LoadData(pid);

            //const Data = GetLocalStorageData("CohortTreatment");
            //let cohortTreatmentModelListtndmm = [];
            //if (Data) {
            //    cohortTreatmentModelListtndmm = cohortTreatmentModelListt.filter(c => c.isEligible == true && c.ndmm == true);
            //}
            //navigatePaths.prevPage = cohortTreatmentModelListtndmm.length > 0 ? "/NDMMTreatmentCohort" : "/Comorbidities";
          }

          ToggleLoader(false);
        }
        return true;
      } else {
        ToggleLoader(false);
        setShowTopErrMsg(true);
        return false;
      }
    } catch (error) {
      ToggleLoader(false);
      ShowToast(CommonError_Msgs.SAVE_ERR, ToastMessageType.Failed);
    } finally {
      setIsSaving(false);
    }
  };

  // Function to get lots above the matching index for a given cohorttreatmentid
  const getLotsAboveMatchingIndex = (row, bispecifictreatment) => {
    return bispecifictreatment
      .filter(
        (item) =>
          item.cohorttreatmentid === row.cohorttreatmentid && item !== row,
      )
      .map((item) => item.lOT);
  };

  const DateInRange = (date, minDate, maxDate) => {
    return dayjs(date).isAfter(minDate) && dayjs(date).isBefore(maxDate);
  };

  const getLatestLastAdminDate = (agents) =>
    agents
      ?.map((a) => parseDate(a.lastDate))
      ?.filter(Boolean)
      ?.sort((a, b) => b - a)[0] || null;

  const getEarliestStartDate = (agents) =>
    agents
      ?.map((a) => parseDate(a.cohortIndexDate))
      ?.filter(Boolean)
      ?.sort((a, b) => a - b)[0] || null;

  const highestLot = Math.max(
    ...bispecificTreatment.map((item) => Number(item.lOT)),
  );

  const ValidateRepeaterData = (
    bispecifictreatment,
    agentListOverride,
    highestLotListOverride,
  ) => {
    let result = true;

    const sortedLots = [...bispecifictreatment].sort(
      (a, b) => Number(a.lOT) - Number(b.lOT),
    );

    const updatedRepeater = bispecifictreatment.map((row, idx, arr) => {
      let updatedRow = { ...row };

      const currentLotNumber = Number(updatedRow.lOT);
      const nextLotRow = sortedLots.find(
        (item) => Number(item.lOT) > currentLotNumber,
      );

      let nextLotStartDate = null;

      if (nextLotRow) {
        nextLotStartDate =
          nextLotRow.firstDate === null || nextLotRow.firstDate === ""
            ? null
            : parseDate(nextLotRow.firstDate);
      }
      //Q26b
      if (
        isStringEmpty(row.lOT) ||
        parseInt(row.lOT) < 2 ||
        parseInt(row.lOT) > 40
      ) {
        result = false;
        updatedRow.showColBError = true;
      } else {
        updatedRow.showColBError = false;

        const lotsAbove = getLotsAboveMatchingIndex(row, bispecifictreatment);
        if (lotsAbove.includes(row.lOT)) {
          result = false;
          updatedRow.showColBDuplicateLotError = true;
        } else {
          updatedRow.showColBDuplicateLotError = false;
        }
      }

      if (
        row.cohorttreatmentid != RRMMCohortTreatment.CARVYKTI &&
        row.cohorttreatmentid != RRMMCohortTreatment.ABECMA
      ) {
        //Q26d
        if (
          isStringEmpty(row.lastDate) &&
          isStringEmpty(row.lastDateRadio) &&
          isStringEmpty(row.lastDateUnk)
        ) {
          result = false;
          updatedRow.showColDError = true;
        } else {
          if (row.lastDateRadio === 1 && isStringEmpty(row.lastDate)) {
            result = false;
            updatedRow.showColDError = true;
          } else updatedRow.showColDError = false;
        }

        //Q26e
        if (
          (isStringEmpty(row.noOfAdmission) &&
            isStringEmpty(row.noOfAdmissionRadio) &&
            isStringEmpty(row.noOfAdmissionUnk) &&
            isStringEmpty(row.noOfAdmissionUnkTxt)) ||
          parseInt(row.noOfAdmission) < 1 ||
          parseInt(row.noOfAdmission) > 4000 ||
          (row.noOfAdmissionRadio === 1 && isStringEmpty(row.noOfAdmission))
        ) {
          // if (isStringEmpty(row.noOfAdmission) && isStringEmpty(row.noOfAdmissionRadio) && isStringEmpty(row.noOfAdmissionUnk)) {
          result = false;
          updatedRow.showColEError = true;
        } else {
          if (
            row.noOfAdmissionRadio === 1 &&
            isStringEmpty(row.noOfAdmission)
          ) {
            result = false;
            updatedRow.showColEError = true;
          } else updatedRow.showColEError = false;

          if (
            row.noOfAdmissionUnk === 1 &&
            isStringEmpty(row.noOfAdmissionUnkTxt)
          ) {
            result = false;
            updatedRow.showColEUkTxtError = true;
          } else updatedRow.showColEUkTxtError = false;
        }

        //Q26h
        if (
          isStringEmpty(row.doseAdministrationmg) &&
          isStringEmpty(row.doseAdministrationRadiomg) &&
          isStringEmpty(row.doseAdministrationkg) &&
          isStringEmpty(row.doseAdministrationRadiokg) &&
          isStringEmpty(row.doseAdministrationmgm) &&
          isStringEmpty(row.doseAdministrationRadiomgm) &&
          isStringEmpty(row.doseAdministrationRadioUnknown)
        ) {
          result = false;
          updatedRow.showColHError = true;
        } else {
          if (
            (row.doseAdministrationRadiomg === 1 &&
              (isStringEmpty(row.doseAdministrationmg) ||
                parseFloat(row.doseAdministrationmg) < 0.01 ||
                parseFloat(row.doseAdministrationmg) > 4000)) ||
            (row.doseAdministrationRadiokg === 1 &&
              isStringEmpty(row.doseAdministrationkg)) ||
            parseFloat(row.doseAdministrationkg) < 0.01 ||
            parseFloat(row.doseAdministrationkg) > 4000 ||
            (row.doseAdministrationRadiomgm === 1 &&
              isStringEmpty(row.doseAdministrationmgm)) ||
            parseFloat(row.doseAdministrationmgm) < 0.01 ||
            parseFloat(row.doseAdministrationmgm) > 4000
          ) {
            result = false;
            updatedRow.showColHError = true;
          } else updatedRow.showColHError = false;
        }

        //Q26f
        if (isStringEmpty(row.discontinueAgent)) {
          result = false;
          updatedRow.showColFError = true;
        } else {
          updatedRow.showColFError = false;
        }

        //Q26g
        if (row.discontinueAgent === 1) {
          const isAnySelected = row.reasonForDiscontinuingMedications.some(
            (item) => item.isSelected,
          );
          if (
            isAnySelected ||
            row.reasonForDiscontinuingMedications[0].reasonUnk === true ||
            row.reasonForDiscontinuingMedications[0].reasonUnk === 1
          ) {
            updatedRow.showColGError = false;

            if (row.reasonForDiscontinuingMedications[0].reasonUnk === true)
              updatedRow.showColGUnknownError = true;
            else updatedRow.showColGUnknownError = false;

            const isReasonOtherSelected =
              row.reasonForDiscontinuingMedications.some(
                (item) =>
                  item.isSelected &&
                  item.reasonName.includes("Other") &&
                  (item.reasonText === null || item.reasonText === ""),
              );
            if (isReasonOtherSelected) {
              result = false;
              updatedRow.showColGOthError = true;
            } else updatedRow.showColGOthError = false;
          } else {
            result = false;
            updatedRow.showColGError = true;
          }

          //Q26g - Patient death reason requires a known date of death (Q20)
          const isDeathReasonSelected =
            row.reasonForDiscontinuingMedications.some(
              (item) =>
                item.isSelected &&
                item.reasonName === DiscontinuationReason.PatientDeath,
            );
          if (isDeathReasonSelected && isStringEmpty(deathDeath)) {
            result = false;
            updatedRow.discontinuationSoftError = true;
          } else {
            updatedRow.discontinuationSoftError = false;
          }
        }

        if (isNewEcrfA) {
          const adverseEventSelected =
            row.reasonForDiscontinuingMedications?.some(
              (r) =>
                r.isSelected &&
                r.reasonName === DiscontinuationReason.AdverseEvent,
            );

          if (adverseEventSelected) {
            const aeList = row.adverseEventsDiscontinuationreason || [];
            const anyAESelected = aeList.some((ae) => ae.isSelected);

            if (!anyAESelected) {
              result = false;
              updatedRow.showAdverseEventError = true;
            } else {
              updatedRow.showAdverseEventError = false;
            }
          } else {
            updatedRow.showAdverseEventError = false;
          }

          const adverseNeurologicalEventSelected =
            row.adverseEventsDiscontinuationreason?.some(
              (r) =>
                r.isSelected &&
                r.reasonName === DiscontinuationReason.NeurologicalEvent,
            );

          if (adverseNeurologicalEventSelected) {
            const aeList =
              row.adverseNeurologicalEventsDiscontinuationreason || [];
            const anyAESelected = aeList.some((ae) => ae.isSelected);

            if (!anyAESelected) {
              result = false;
              updatedRow.showAdverseNeuroEventError = true;
            } else {
              updatedRow.showAdverseNeuroEventError = false;

              const otherSelected =
                row.adverseNeurologicalEventsDiscontinuationreason?.some(
                  (r) =>
                    r.isSelected &&
                    r.reasonName.includes("Other") &&
                    !r.reasonText,
                );
              if (otherSelected) {
                result = false;
                updatedRow.showAdverseNeuroEventOtherTextError = true;
              } else {
                updatedRow.showAdverseNeuroEventOtherTextError = false;
              }
            }
          } else {
            updatedRow.showAdverseNeuroEventError = false;
          }
        }

        if (row.lastDateRadio === 1 && row.lastDate === "Invalid Date") {
          result = false;
          updatedRow.showColD_InvalidDate = true;
        } else if (
          row.lastDateRadio === 1 &&
          row.lastDate &&
          !DateInRange(row.lastDate, dayjs("01-01-1920"), dayjs())
        ) {
          result = false;
          updatedRow.showColD_InvalidDate = true;
        } else {
          updatedRow.showColD_InvalidDate = false;

          const startDt =
            row.firstDate === null || row.firstDate === ""
              ? null
              : parseDate(row.firstDate);
          const endDt =
            row.lastDate === null || row.lastDate === ""
              ? null
              : parseDate(row.lastDate);
          const endOfFollowUpDt =
            row.endOfFollowUpDate === null || row.endOfFollowUpDate === ""
              ? null
              : parseDate(row.endOfFollowUpDate);

          // Validate the parsed dates
          if (row.lastDateUnk !== 1) {
            if (startDt != null && endDt != null) {
              // Check if the last administration date is within the range.
              // Sort-based LOT sequence check (kept alongside the non-sort-based
              // CheckQ26LotSequenceChain, per explicit instruction to run both).
              if (nextLotStartDate != null && endDt > nextLotStartDate) {
                result = false;
                updatedRow.showColD_SortedDateError =
                  row.lastDate === "" || row.lastDate === null ? false : true; //in-valid
              } else {
                updatedRow.showColD_SortedDateError = false;
                updatedRow.showColD_LEFDateError = false;
              }
            }
          }

          if (startDt != null && endDt === null && endOfFollowUpDt != null) {
            // Check if the last radiotherapy date is within the range
            if (startDt <= endOfFollowUpDt) {
              updatedRow.showColD_EFDateError = false; //valid
            } else {
              result = false;
              updatedRow.showColD_EFDateError =
                row.firstDate === "" || row.firstDate === null ? false : true; //in-valid
            }
          }

          if (startDt != null && endDt !== null && endOfFollowUpDt == null) {
            // Check if the last radiotherapy date is within the range
            if (startDt <= endDt) {
              updatedRow.showColD_SEFDateError = false; //valid
            } else {
              result = false;
              updatedRow.showColD_SEFDateError = true; //in-valid
            }
          }
        }
      }

      if (
        row.cohorttreatmentid == RRMMCohortTreatment.CARVYKTI ||
        row.cohorttreatmentid == RRMMCohortTreatment.ABECMA
      ) {
        //Q26h

        if (
          isStringEmpty(row.doseAdministrationcell) &&
          isStringEmpty(row.doseAdministrationRadiocell) &&
          isStringEmpty(row.doseAdministrationRadioUnknown)
        ) {
          result = false;
          updatedRow.showColHError = true;
        } else {
          if (
            (row.doseAdministrationRadiocell === 1 &&
              isStringEmpty(row.doseAdministrationcell)) ||
            parseFloat(row.doseAdministrationcell) < 0.01 ||
            parseFloat(row.doseAdministrationcell) > 4000
          ) {
            result = false;
            updatedRow.showColHError = true;
          } else updatedRow.showColHError = false;
        }
      }
      return updatedRow;
    });
    setbispecificTreatment(updatedRepeater);

    const agentListToValidate = agentListOverride ?? bispecificAgent;
    if (isNewEcrfA && agentListToValidate?.length > 0) {
      let agentRepeaterValid = ValidateAgentRepeaterData(agentListToValidate);
      if (!agentRepeaterValid) result = false;
    }

    //Q26.2
    const highestLotListToValidate =
      highestLotListOverride ?? bispecificHighestLotList;
    if (
      isNewEcrfA &&
      highestLotListToValidate &&
      highestLotListToValidate.length > 0
    ) {
      const q263EligibleRow = GetQ263EligibleRow(highestLotListToValidate);

      const updatedArr = highestLotListToValidate.map((row, index) => {
        let q262_B_empty_err = false;
        let q262_B_invalid_date = false;
        let q262_B_before_err = false;
        let q262_B_before_next_lot_err = false;
        let q262_B_beyond_eof_err = false;
        let q262_B_after_end_err = false;
        let q262_C_empty_err = false;
        let q262_C_invalid_date = false;
        let q262_C_before_err = false;
        let q262_C_citaabecm_err = false;
        let q262_C_before_next_lot_err = false;
        let q262_C_beyond_eof_err = false;
        let q262_D_empty_err = false;
        let q262_D_txt_empty_err = false;
        let q262_E_empty_err = false;
        let q262_F_empty_err = false;
        let q262_DaraNotSelected_err = false;

        //Q33.1.A
        if (
          row.q262_rbl_B === null &&
          isStringEmpty(row.q262_date_B) &&
          isStringEmpty(row.q262_autodate_B)
        ) {
          q262_B_empty_err = true;
        } else if (row.q262_rbl_B === 1) {
          if (
            isStringEmpty(row.q262_date_B) &&
            isStringEmpty(row.q262_autodate_B)
          ) {
            q262_B_empty_err = true;
          } else if (
            !IsDateValid(row.q262_date_B) &&
            isStringEmpty(row.q262_autodate_B)
          ) {
            q262_B_invalid_date = true;
          } else {
            const nxtLotRowData =
              index > 0 ? highestLotListToValidate[index + 1] : null;
            const nxtLotStartDt = nxtLotRowData?.q262_date_B;
            const prevLotRowData =
              index > 0 ? highestLotListToValidate[index - 1] : null;
            const prevLotEndDt = prevLotRowData?.q262_date_C ?? null;
            //Date to be after prev lot end date
            if (!isStringEmpty(prevLotEndDt)) {
              q262_B_before_err = IsDateAfter(prevLotEndDt, row.q262_date_B);
            }
            //Date to be before next lot start date
            if (!isStringEmpty(nxtLotStartDt)) {
              q262_B_before_next_lot_err = IsDateAfter(
                row.q262_date_B,
                nxtLotStartDt,
              );
            }
            //Date selected to be before end of follow up
            if (!isStringEmpty(endOfFollowUpDate)) {
              q262_B_beyond_eof_err = IsDateAfter(
                row.q262_date_B,
                endOfFollowUpDate,
              );
            }
            //Start date to be before this row's own end date
            const ownEndDt = !isStringEmpty(row.q262_autodate_C)
              ? row.q262_autodate_C
              : row.q262_date_C;
            if (!isStringEmpty(ownEndDt)) {
              q262_B_after_end_err = IsDateAfter(row.q262_date_B, ownEndDt);
            }
          }
        }

        if (
          row.q262_rbl_C === null &&
          isStringEmpty(row.q262_date_C) &&
          isStringEmpty(row.q262_autodate_C)
        ) {
          q262_C_empty_err = true;
        } else if (row.q262_rbl_C === 1) {
          if (
            isStringEmpty(row.q262_date_C) &&
            isStringEmpty(row.q262_autodate_C)
          ) {
            q262_C_empty_err = true;
          } else if (
            !IsDateValid(row.q262_date_C) &&
            isStringEmpty(row.q262_autodate_C)
          ) {
            q262_C_invalid_date = true;
          } else {
            const nxtLotRowData =
              index > 0 ? highestLotListToValidate[index + 1] : null;
            const nxtLotStartDt = nxtLotRowData?.q262_date_B;
            const lotStartDt = row?.q262_date_B ?? null;

            const lotNumber = row?.q262_rbl_A;
            let Q26ListCarvAbcm = bispecifictreatment.filter(
              (x) =>
                x.cohorttreatmentid === RRMMCohortTreatment.CARVYKTI ||
                x.cohorttreatmentid === RRMMCohortTreatment.ABECMA,
            );

            const lotNumberExists = Q26ListCarvAbcm.some(
              (x) => x.lOT === lotNumber,
            );

            if (lotNumberExists) {
              q262_C_citaabecm_err = IsDateEqual(lotStartDt, row.q262_date_C);
            }

            //End date >= Start date of same row
            if (!isStringEmpty(lotStartDt)) {
              q262_C_before_err = IsDateAfter(lotStartDt, row.q262_date_C);
            }
            //End date <= Start date of next Lot
            if (!isStringEmpty(nxtLotStartDt)) {
              q262_C_before_next_lot_err = IsDateAfter(
                row.q262_date_C,
                nxtLotStartDt,
              );
            }
            if (!isStringEmpty(endOfFollowUpDate)) {
              q262_C_beyond_eof_err = IsDateAfter(
                row.q262_date_C,
                endOfFollowUpDate,
              );
            }
          }
        }

        if (row.q262_rbl_E === null) {
          q262_E_empty_err = true;
        }
        if (row.q262_rbl_F === null) {
          q262_F_empty_err = true;
        }
        if (
          !row.q262_rb_received_tmt_unk &&
          row.q262_selectedReceivedTmtList.length === 0
        ) {
          q262_D_empty_err = true;
        } else if (row.q262_selectedReceivedTmtList.length > 0) {
          const otherItem = row.q262_selectedReceivedTmtList?.find(
            (t) => t.prescribedTreatmentId === row.prescribedTmtOtherID,
          );

          if (otherItem && !otherItem.prescribedTreatmentOthTxt?.trim()) {
            q262_D_txt_empty_err = true;
          }
        }

        //DR & DRd
        if (row.bindedCohorttreatmentid == 1) {
          const list = row.q262_selectedReceivedTmtList ?? [];

          const has2 = list.some((r) => r.prescribedTreatmentId === 2);
          const has7or8 = list.some(
            (r) =>
              r.prescribedTreatmentId === 7 || r.prescribedTreatmentId === 8,
          );

          const DaraExist = has2 && has7or8;

          if (!DaraExist) q262_DaraNotSelected_err = true;
        }

        //DVR & DVRd
        if (
          row.bindedCohorttreatmentid == 2 ||
          row.bindedCohorttreatmentid == 3
        ) {
          const list = row.q262_selectedReceivedTmtList ?? [];

          const has2 = list.some((r) => r.prescribedTreatmentId === 2);
          const has4 = list.some((r) => r.prescribedTreatmentId === 4);
          const has7or8 = list.some(
            (r) =>
              r.prescribedTreatmentId === 7 || r.prescribedTreatmentId === 8,
          );

          const DaraExist = has2 && has4 && has7or8;

          if (!DaraExist) q262_DaraNotSelected_err = true;
        }

        //DKR & DKRd
        if (row.bindedCohorttreatmentid == 4) {
          const list = row.q262_selectedReceivedTmtList ?? [];

          const has2 = list.some((r) => r.prescribedTreatmentId === 2);
          const has5 = list.some((r) => r.prescribedTreatmentId === 5);
          const has7or8 = list.some(
            (r) =>
              r.prescribedTreatmentId === 7 || r.prescribedTreatmentId === 8,
          );

          const DaraExist = has2 && has5 && has7or8;

          if (!DaraExist) q262_DaraNotSelected_err = true;
        }

        //VR & VRd
        if (
          row.bindedCohorttreatmentid == 5 ||
          row.bindedCohorttreatmentid == 6
        ) {
          const list = row.q262_selectedReceivedTmtList ?? [];

          const has2 = list.some((r) => r.prescribedTreatmentId === 2);
          const has4 = list.some((r) => r.prescribedTreatmentId === 4);
          const DaraExist = has2 && has4;

          if (!DaraExist) q262_DaraNotSelected_err = true;
        }

        //IsaVR & IsaVRd
        if (
          row.bindedCohorttreatmentid == 7 ||
          row.bindedCohorttreatmentid == 8
        ) {
          const list = row.q262_selectedReceivedTmtList ?? [];

          const has2 = list.some((r) => r.prescribedTreatmentId === 2);
          const has4 = list.some((r) => r.prescribedTreatmentId === 4);
          const has9 = list.some((r) => r.prescribedTreatmentId === 9);
          const DaraExist = has2 && has4 && has9;

          if (!DaraExist) q262_DaraNotSelected_err = true;
        }

        //Agents Refractory (Element C)
        let q262_G_empty_err = false;
        if (isNewEcrfC && row.q262_rbl_F === 1) {
          const qualifyingOptions = getQualifyingRefractoryAgentOptions(row);
          if (qualifyingOptions.length > 0) {
            const anySelected =
              row.q262_agentRefractoryLena ||
              row.q262_agentRefractoryDara ||
              row.q262_agentRefractoryDarafaspro ||
              row.q262_agentRefractoryIsatu ||
              row.q262_agentRefractoryNone;

            if (!anySelected) q262_G_empty_err = true;
          }
        }

        //Q26.3 (Element C)
        let q263_C_empty_err = false;
        let q263_C_invalid_date = false;
        let q263_C_chain_err = false;
        if (isNewEcrfC && q263EligibleRow && row === q263EligibleRow) {
          const discInfo = GetQ263DiscontinuationInfo(row);
          if (discInfo.isAuto) {
            q263_C_chain_err = !ValidateQ263DateChain(row, discInfo.date);
          } else if (
            row.q263_rbl_D === null &&
            isStringEmpty(row.q263_date_D)
          ) {
            q263_C_empty_err = true;
          } else if (row.q263_rbl_D === 1) {
            if (isStringEmpty(row.q263_date_D)) {
              q263_C_empty_err = true;
            } else if (!IsDateValid(row.q263_date_D)) {
              q263_C_invalid_date = true;
            } else {
              q263_C_chain_err = !ValidateQ263DateChain(row, row.q263_date_D);
            }
          }
        }

        if (
          q262_B_empty_err ||
          q262_B_invalid_date ||
          q262_C_empty_err ||
          q262_C_invalid_date ||
          q262_DaraNotSelected_err ||
          q262_D_empty_err ||
          q262_D_txt_empty_err ||
          q262_E_empty_err ||
          q262_F_empty_err ||
          q262_G_empty_err ||
          q262_B_before_err ||
          q262_B_before_next_lot_err ||
          q262_B_beyond_eof_err ||
          q262_B_after_end_err ||
          q262_C_before_err ||
          q262_C_citaabecm_err ||
          q262_C_before_next_lot_err ||
          q262_C_beyond_eof_err ||
          q263_C_empty_err ||
          q263_C_invalid_date ||
          q263_C_chain_err
        ) {
          result = false;
        }

        return {
          ...row,
          q262_B_empty_err,
          q262_B_invalid_date,
          q262_B_before_err,
          q262_B_before_next_lot_err,
          q262_B_beyond_eof_err,
          q262_B_after_end_err,
          q262_C_empty_err,
          q262_C_invalid_date,
          q262_C_before_err,
          q262_C_citaabecm_err,
          q262_C_before_next_lot_err,
          q262_C_beyond_eof_err,
          q262_D_empty_err,
          q262_D_txt_empty_err,
          q262_DaraNotSelected_err,
          q262_E_empty_err,
          q262_F_empty_err,
          q262_G_empty_err,
          q263_C_empty_err,
          q263_C_invalid_date,
          q263_C_chain_err,
        };
      });
      setBispecificHighestLotList(updatedArr);
    }

    return result;
  };

  const BuildChainViolationMessage = (steps) => {
    const present = steps.filter((s) => !isStringEmpty(s.date));
    for (let i = 0; i < present.length - 1; i++) {
      if (IsDateAfter(present[i].date, present[i + 1].date)) {
        return `The ${present[i].label} cannot be after the ${present[i + 1].label}. Please review and revise as needed.`;
      }
    }
    return null;
  };

  // When the end date breaks both the "initiation <= end" bound and the deeper "index <= end"
  // bound at once, the ordered chain walk above only ever reports the closer initiation-vs-end
  // pair, since index-vs-initiation itself is still fine. Check the index-date bound directly
  // first so that case is reported against the index date instead - when only the initiation
  // bound is actually broken (index date is fine), this falls through to the normal chain walk
  // and the initiation-date message is shown exactly as before.
  const BuildChainViolationMessagePreferringIndexDate = (
    steps,
    indexLabel,
    endLabel,
  ) => {
    const indexStep = steps.find((s) => s.label === indexLabel);
    const endStep = steps.find((s) => s.label === endLabel);

    if (
      indexStep &&
      endStep &&
      !isStringEmpty(indexStep.date) &&
      !isStringEmpty(endStep.date) &&
      IsDateAfter(indexStep.date, endStep.date)
    ) {
      return `The ${indexStep.label} cannot be after the ${endStep.label}. Please review and revise as needed.`;
    }

    return BuildChainViolationMessage(steps);
  };

  // Q26.1 only - whenever the violated pair is entirely within the "Bispecifics/CAR-T LOT index
  // date <= all first-admin <= all last-admin <= next-highest LOT's first-admin" bounds (i.e. both
  // sides of the pair are the index/initiation/end steps), show the single combined
  // q26_lotDateRangeError message instead of the pinpointed per-pair text - those two conditions
  // share one error message per instruction. Diagnosis/NDMM-related pairs and the end-of-follow-up
  // pair are outside that scope and keep their own pinpointed message.
  // Returns { message, field } where field is "initiation" (first-admin column) or
  // "end" (last-admin column) - whichever side of the index/initiation/end trio is
  // actually broken - so the caller can point the shared q26_lotDateRangeError text
  // at the right field instead of always defaulting to last admin.
  const BuildQ261ChainMessage = (
    steps,
    indexLabel,
    initiationLabel,
    endLabel,
  ) => {
    const lotRangeLabels = new Set([indexLabel, initiationLabel, endLabel]);

    const indexStep = steps.find((s) => s.label === indexLabel);
    const initiationStep = steps.find((s) => s.label === initiationLabel);
    const endStep = steps.find((s) => s.label === endLabel);

    const initiationBroken =
      indexStep &&
      initiationStep &&
      !isStringEmpty(indexStep.date) &&
      !isStringEmpty(initiationStep.date) &&
      IsDateAfter(indexStep.date, initiationStep.date);

    if (
      indexStep &&
      endStep &&
      !isStringEmpty(indexStep.date) &&
      !isStringEmpty(endStep.date) &&
      IsDateAfter(indexStep.date, endStep.date)
    ) {
      return {
        message: BispecificCartTreatmentCohort_Msgs.q26_lotDateRangeError,
        field: initiationBroken ? "initiation" : "end",
      };
    }

    const present = steps.filter((s) => !isStringEmpty(s.date));
    for (let i = 0; i < present.length - 1; i++) {
      if (IsDateAfter(present[i].date, present[i + 1].date)) {
        if (
          lotRangeLabels.has(present[i].label) &&
          lotRangeLabels.has(present[i + 1].label)
        ) {
          return {
            message: BispecificCartTreatmentCohort_Msgs.q26_lotDateRangeError,
            field:
              present[i + 1].label === initiationLabel ? "initiation" : "end",
          };
        }
        return {
          message: `The ${present[i].label} cannot be after the ${present[i + 1].label}. Please review and revise as needed.`,
          field: null,
        };
      }
    }
    return null;
  };

  // Q26 - Date of initial MM diagnosis ≤ NDMM index date (if applicable) ≤ Bispecifics/CAR-T index date ≤
  // Bispecifics/CAR-T initiation date ≤ Bispecifics/CAR-T end date (for non-CARVYKTI® and non-ABECMA®) ≤ end of follow up
  // Returns the annotated row list (with q26ChainErr/q26ChainErrMsg set) plus overall validity, without
  // committing state itself - the caller merges these flags in alongside the rest of ValidateRepeaterData's row-level checks.
  const CheckQ26FullDateChain = (bispecifictreatment) => {
    let result = true;

    const updatedRepeater = bispecifictreatment.map((row) => {
      const updatedRow = { ...row };

      const isCarvyktiOrAbecma =
        row.cohorttreatmentid === RRMMCohortTreatment.CARVYKTI ||
        row.cohorttreatmentid === RRMMCohortTreatment.ABECMA;

      const steps = [
        { label: "date of initial MM diagnosis", date: intialMMDiagnosisDate },
        { label: "NDMM index date", date: ndmmIndexDate },
        {
          label: "Bispecifics/CAR-T index date",
          date: row.earliestCohortIndexDate,
        },
        {
          label: "Bispecifics/CAR-T initiation date",
          date: row.cohortInitiationDate,
        },
        ...(isCarvyktiOrAbecma
          ? []
          : [{ label: "Bispecifics/CAR-T end date", date: row.lastDate }]),
        { label: "end of follow-up date", date: endFollowUpDate },
      ];

      const violationMessage = BuildChainViolationMessagePreferringIndexDate(
        steps,
        "Bispecifics/CAR-T index date",
        "Bispecifics/CAR-T end date",
      );

      if (violationMessage) {
        result = false;
        updatedRow.q26ChainErr = true;
        updatedRow.q26ChainErrMsg = violationMessage;
      } else {
        updatedRow.q26ChainErr = false;
        updatedRow.q26ChainErrMsg = null;
      }

      return updatedRow;
    });

    return { isValid: result, updatedRepeater };
  };

  const CheckQ26LotSequenceChain = (bispecifictreatment) => {
    let result = true;
    const list = bispecifictreatment || [];

    const orderable = list
      .map((row, index) => ({ row, index }))
      .filter(({ row }) => !isStringEmpty(row.lOT) && !isNaN(Number(row.lOT)));

    const orderedRows = [...orderable].sort((a, b) => {
      const lotDiff = Number(a.row.lOT) - Number(b.row.lOT);
      if (lotDiff !== 0) return lotDiff;
      const aStart = parseDate(a.row.firstDate);
      const bStart = parseDate(b.row.firstDate);
      if (!aStart || !bStart) return 0;
      return aStart - bStart;
    });

    const violatingIndexes = new Set();

    for (let i = 0; i < orderedRows.length; i++) {
      const current = orderedRows[i].row;
      if (isStringEmpty(current.lastDate)) continue;

      // this row's own start <= this row's own end
      if (
        !isStringEmpty(current.firstDate) &&
        IsDateAfter(current.firstDate, current.lastDate)
      ) {
        violatingIndexes.add(orderedRows[i].index);
        continue;
      }

      // this row's end <= the next row's start (LOT, then start-date order)
      if (i < orderedRows.length - 1) {
        const next = orderedRows[i + 1].row;
        if (
          !isStringEmpty(next.firstDate) &&
          IsDateAfter(current.lastDate, next.firstDate)
        ) {
          violatingIndexes.add(orderedRows[i].index);
        }
      }
    }

    const updatedRepeater = list.map((row, index) => {
      const updatedRow = { ...row };
      const violates = violatingIndexes.has(index);
      if (violates) result = false;
      updatedRow.showColD_DateError = violates;
      return updatedRow;
    });

    return { isValid: result, updatedRepeater };
  };

  // Q26.2 - full date chain across the whole prior-LOT grid:
  // date of initial MM diagnosis <= LOT 1 start date <= LOT 1 end date <= LOT 2 start date <= LOT 2 end date <= ...
  // <= latest LOT start date <= latest LOT end date <= start date of the subsequent LOT (max of Q27 and Q31, if reported)
  // <= end of follow-up date.
  // Several of these pairwise comparisons are already reported by existing per-field checks
  // (q262_C_before_err for a row's own start-vs-end, q262_B/C_beyond_eof_err for a row's date
  // vs end of follow-up, q262_B_before_err for a row's start vs the previous row's end) - those
  // pairs are skipped here to avoid a duplicate message; this only reports what isn't already
  // covered (the MM diagnosis lower bound, and the subsequent-LOT upper bound), plus the
  // start-vs-start fallback when a row's own end date is unknown (not covered by q262_B_before_err,
  // which requires the previous row's end date to compare against).
  // MM diagnosis is checked directly against every row (not just the nearest one in sequence) and
  // every row-to-row/subsequent-LOT/EOF pair is evaluated independently (not stopped at the first
  // hit), so multiple distinct violations on different rows are all reported, not just whichever
  // one happens to come first.
  // Returns the annotated row list (with q262ChainErrStart/EndMsg set independently, so a row can
  // carry a distinct violation on both its start and end date without one hiding the other)
  // plus overall validity, without committing state itself.
  const CheckQ262FullDateChain = (highestLotList, nextLotStartDate) => {
    let result = true;
    const list = highestLotList || [];

    const orderedRows = list
      .map((row, index) => ({ row, index }))
      .filter(
        ({ row }) =>
          !isStringEmpty(row.q262_rbl_A) && !isNaN(Number(row.q262_rbl_A)),
      )
      .sort((a, b) => Number(a.row.q262_rbl_A) - Number(b.row.q262_rbl_A));

    const steps = [];

    orderedRows.forEach(({ row, index }) => {
      const lotNum = row.q262_rbl_A;
      const startDate = !isStringEmpty(row.q262_autodate_B)
        ? row.q262_autodate_B
        : row.q262_date_B;
      const endDate = !isStringEmpty(row.q262_autodate_C)
        ? row.q262_autodate_C
        : row.q262_date_C;
      steps.push({
        label: `LOT ${lotNum} start date`,
        date: startDate,
        rowIndex: index,
        field: "start",
      });
      steps.push({
        label: `LOT ${lotNum} end date`,
        date: endDate,
        rowIndex: index,
        field: "end",
      });
    });

    steps.push({
      label: "start date of the subsequent LOT",
      date: nextLotStartDate,
      rowIndex: null,
    });
    steps.push({
      label: "end of follow-up date",
      date: endOfFollowUpDate,
      rowIndex: null,
      isEof: true,
    });

    const present = steps.filter((s) => !isStringEmpty(s.date));

    // rowIndex -> { start: message|undefined, end: message|undefined }. A row can carry one
    // violation per column - previously only a single message per row was kept, which could
    // silently drop a genuine, distinct violation (e.g. a subsequent-LOT/EOF problem on a row
    // that already had an unrelated diagnosis violation).
    const violations = {};
    const addViolation = (rowIndex, field, message) => {
      if (rowIndex === null || rowIndex === undefined) return;
      if (!violations[rowIndex]) violations[rowIndex] = {};
      if (!violations[rowIndex][field]) violations[rowIndex][field] = message;
    };

    // MM diagnosis is checked directly against every row's own earliest
    // available date (start, or end if start is unknown/missing) rather than
    // only the nearest row in sequence. Otherwise an out-of-order LOT earlier
    // in the grid (e.g. LOT 1 start after LOT 2 start) breaks the chain's
    // transitivity and silently hides a genuine diagnosis violation on a
    // later row.
    if (!isStringEmpty(intialMMDiagnosisDate)) {
      orderedRows.forEach(({ row, index }) => {
        const startDate = !isStringEmpty(row.q262_autodate_B)
          ? row.q262_autodate_B
          : row.q262_date_B;
        const endDate = !isStringEmpty(row.q262_autodate_C)
          ? row.q262_autodate_C
          : row.q262_date_C;
        const earliestDate = !isStringEmpty(startDate) ? startDate : endDate;
        const earliestField = !isStringEmpty(startDate) ? "start" : "end";
        const earliestLabel = `LOT ${row.q262_rbl_A} ${earliestField} date`;
        if (
          !isStringEmpty(earliestDate) &&
          IsDateAfter(intialMMDiagnosisDate, earliestDate)
        ) {
          addViolation(
            index,
            earliestField,
            `The date of initial MM diagnosis cannot be after the ${earliestLabel}. Please review and revise as needed.`,
          );
        }
      });
    }

    // The subsequent-LOT start date is likewise checked directly against
    // every row's own start and end date, rather than relying on it landing
    // next to the right item in the sorted sequence below. Otherwise a row
    // that's already invalid on its own (e.g. its start date is after its
    // own end date) can hide a genuine subsequent-LOT violation on whichever
    // of its two dates happens to be later in the array.
    if (!isStringEmpty(nextLotStartDate)) {
      orderedRows.forEach(({ row, index }) => {
        const startDate = !isStringEmpty(row.q262_autodate_B)
          ? row.q262_autodate_B
          : row.q262_date_B;
        const endDate = !isStringEmpty(row.q262_autodate_C)
          ? row.q262_autodate_C
          : row.q262_date_C;
        [
          { date: startDate, field: "start" },
          { date: endDate, field: "end" },
        ].forEach(({ date, field }) => {
          if (!isStringEmpty(date) && IsDateAfter(date, nextLotStartDate)) {
            addViolation(
              index,
              field,
              BispecificCartTreatmentCohort_Msgs.q262_BeyondSubsequentLot,
            );
          }
        });
      });
    }

    // Row-to-row / subsequent-LOT / end of follow-up chain - every distinct
    // violation is reported (not just the first one found), so multiple
    // unrelated problems on different rows (or different columns of the same
    // row) are all surfaced rather than only whichever happens to come first.
    for (let i = 0; i < present.length - 1; i++) {
      // Same row's own start-vs-end is already reported by q262_C_before_err.
      if (
        present[i].rowIndex !== null &&
        present[i].rowIndex === present[i + 1].rowIndex
      ) {
        continue;
      }

      // A row's own start/end date vs end of follow-up is already reported by
      // q262_B_beyond_eof_err/q262_C_beyond_eof_err.
      if (present[i].rowIndex !== null && present[i + 1].isEof) {
        continue;
      }

      // One row's end date vs the next row's start date is already reported
      // by q262_B_before_err on the later row.
      if (present[i].field === "end" && present[i + 1].field === "start") {
        continue;
      }

      if (IsDateAfter(present[i].date, present[i + 1].date)) {
        // When comparing two different rows' start dates (the row between
        // them was skipped, e.g. because its own end date is unknown), the
        // earlier LOT's start date is the one that's actually out of place -
        // attribute the error there instead of the later LOT.
        const rowIndex =
          present[i].field === "start" && present[i + 1].field === "start"
            ? (present[i].rowIndex ?? present[i + 1].rowIndex)
            : (present[i + 1].rowIndex ??
              present[i].rowIndex ??
              (orderedRows.length > 0
                ? orderedRows[orderedRows.length - 1].index
                : null));
        // Show the message under whichever of the two compared dates is an
        // actual grid column (start/end) belonging to the row it's attached
        // to - preferring the earlier step, since that's the one described
        // as being "too late" in the message text.
        const field =
          present[i].rowIndex === rowIndex
            ? (present[i].field ?? present[i + 1].field ?? "end")
            : (present[i + 1].field ?? present[i].field ?? "end");
        addViolation(
          rowIndex,
          field,
          `The ${present[i].label} cannot be after the ${present[i + 1].label}. Please review and revise as needed.`,
        );
      }
    }

    if (Object.keys(violations).length > 0) result = false;

    const updatedRepeater = list.map((row, index) => {
      const updatedRow = { ...row };
      updatedRow.q262ChainErrStart = !!violations[index]?.start;
      updatedRow.q262ChainErrStartMsg = violations[index]?.start ?? null;
      updatedRow.q262ChainErrEnd = !!violations[index]?.end;
      updatedRow.q262ChainErrEndMsg = violations[index]?.end ?? null;
      return updatedRow;
    });

    return { isValid: result, updatedRepeater };
  };

  // Q26.2 - per-row date chain, assessed separately for each row. MM diagnosis and end of
  // follow-up are intentionally not re-checked here for any row - CheckQ262FullDateChain already
  // carries the diagnosis lower bound transitively through the whole grid, and every row's
  // start/end vs end of follow-up is already reported by q262_B_beyond_eof_err/q262_C_beyond_eof_err.
  // The 1L end vs 2L start boundary is likewise left out - q262_B_before_err on 2L's own start
  // already covers it. What's genuinely new here:
  // 1L:      NDMM index date <= 1L start date [B] <=
  //          maximum(first/last administration date across Q22, Q23, Q24, Q25) <= 1L end date [C]
  // RRMM LOT (2L+): NDMM index date <= LOT start date [B] <=
  //          maximum(date of last administration in Q26/Q26.1) <= LOT end date [C]
  // Returns the annotated row list (with q262RowChainErrStart/EndMsg set independently) plus overall
  // validity, without committing state itself.
  const CheckQ262RowLevelDateChain = (highestLotList) => {
    let result = true;
    const list = highestLotList || [];

    const orderedRows = list
      .map((row, index) => ({ row, index }))
      .filter(
        ({ row }) =>
          !isStringEmpty(row.q262_rbl_A) && !isNaN(Number(row.q262_rbl_A)),
      )
      .sort((a, b) => Number(a.row.q262_rbl_A) - Number(b.row.q262_rbl_A));

    //Max date of last administration in Q26 (bispecificTreatment) and Q26.1 (bispecificAgent),
    //restricted to the cohort(s) received at the given RRMM LOT (2L+) - used as that LOT's
    //middle bound. Adjust LotOf/CohortOf if the field names on these objects differ.
    const LotOf = (item) => Number(item?.lineOfTherapy);
    const CohortOf = (item) => item?.cohortTreatmentId;

    const GetMaxLastAdminDateForLot = (lotNum) => {
      const q26ForLot = (bispecificTreatment || []).filter(
        (t) => LotOf(t) === lotNum,
      );
      const cohortIdsForLot = q26ForLot.map(CohortOf);

      //Q26.1 groups: match on their own LOT if present, otherwise on the cohort(s) at this LOT
      const q261ForLot = (bispecificAgent || []).filter((c) =>
        !isNaN(LotOf(c))
          ? LotOf(c) === lotNum
          : cohortIdsForLot.includes(CohortOf(c)),
      );

      const dates = [
        ...q26ForLot.map((t) => t.lastDate),
        ...q261ForLot.flatMap((c) =>
          (c.agentLists || []).map((a) => a.lastDate),
        ),
      ].filter((d) => !isStringEmpty(d));

      return dates.length
        ? dates.reduce((max, d) => (IsDateAfter(d, max) ? d : max))
        : null;
    };

    // rowIndex -> { start: message|undefined, end: message|undefined }
    const violations = {};
    const addViolation = (rowIndex, field, message) => {
      if (rowIndex === null || rowIndex === undefined) return;
      if (!violations[rowIndex]) violations[rowIndex] = {};
      if (!violations[rowIndex][field]) violations[rowIndex][field] = message;
    };

    orderedRows.forEach(({ row, index }) => {
      const lotNum = Number(row.q262_rbl_A);
      const startDate = !isStringEmpty(row.q262_autodate_B)
        ? row.q262_autodate_B
        : row.q262_date_B;
      const endDate = !isStringEmpty(row.q262_autodate_C)
        ? row.q262_autodate_C
        : row.q262_date_C;

      let steps;
      if (lotNum === 1) {
        steps = [
          { label: "NDMM index date", date: ndmmIndexDate },
          { label: "1L start date", date: startDate, key: "start" },
          {
            label: "maximum first/last administration date across Q22-Q25",
            date: ndmm1LMaxAdminDate,
            key: "admin",
          },
          { label: "1L end date", date: endDate, key: "end" },
        ];
      } else {
        steps = [
          { label: "NDMM index date", date: ndmmIndexDate },
          { label: `LOT ${lotNum} start date`, date: startDate, key: "start" },
          {
            label: `maximum date of last administration in Q26/Q26.1 for LOT ${lotNum}`,
            date: GetMaxLastAdminDateForLot(lotNum),
            key: "admin",
          },
          { label: `LOT ${lotNum} end date`, date: endDate, key: "end" },
        ];
      }

      //Same row's own start-vs-end is already reported by q262_C_before_err
      //(if the intermediate admin-date bound is empty, start/end become
      //adjacent here too, so skip that specific pair to avoid a duplicate).
      //Every distinct pair is checked (not just the first violation found),
      //so e.g. an NDMM-index-date problem and an admin-date problem on the
      //same row don't hide one another.
      const presentSteps = steps.filter((s) => !isStringEmpty(s.date));
      for (let j = 0; j < presentSteps.length - 1; j++) {
        if (
          presentSteps[j].key === "start" &&
          presentSteps[j + 1].key === "end"
        ) {
          continue;
        }
        if (IsDateAfter(presentSteps[j].date, presentSteps[j + 1].date)) {
          // Show the message under whichever of the two compared steps is an
          // actual grid column (start/end) - "admin" isn't a real column, so
          // it's skipped in favor of whichever side actually is start/end,
          // preferring the earlier step since that's the one described as
          // being "too late" in the message text.
          const isGridField = (key) => key === "start" || key === "end";
          const field = isGridField(presentSteps[j].key)
            ? presentSteps[j].key
            : isGridField(presentSteps[j + 1].key)
              ? presentSteps[j + 1].key
              : "end";
          // Curate a specific message when the admin-date bound is the
          // other side of the violated pair, instead of the generic
          // "X cannot be after Y" phrasing.
          let message;
          if (presentSteps[j + 1].key === "admin") {
            message =
              lotNum === 1
                ? BispecificCartTreatmentCohort_Msgs.q262_StartBeyondAdminQ2225
                : BispecificCartTreatmentCohort_Msgs.q262_StartBeyondAdminQ26;
          } else if (presentSteps[j].key === "admin") {
            message =
              lotNum === 1
                ? BispecificCartTreatmentCohort_Msgs.q262_EndBeforeAdminQ2225
                : BispecificCartTreatmentCohort_Msgs.q262_EndBeforeAdminQ26;
          } else {
            message = `The ${presentSteps[j].label} cannot be after the ${presentSteps[j + 1].label}. Please review and revise as needed.`;
          }
          addViolation(index, field, message);
        }
      }
    });

    if (Object.keys(violations).length > 0) result = false;

    const updatedRepeater = list.map((row, index) => {
      const updatedRow = { ...row };
      updatedRow.q262RowChainErrStart = !!violations[index]?.start;
      updatedRow.q262RowChainErrStartMsg = violations[index]?.start ?? null;
      updatedRow.q262RowChainErrEnd = !!violations[index]?.end;
      updatedRow.q262RowChainErrEndMsg = violations[index]?.end ?? null;
      return updatedRow;
    });

    return { isValid: result, updatedRepeater };
  };

  const CheckQ261FullDateChain = (bispecificAgentList) => {
    let result = true;

    const updatedBispecificAgent = (bispecificAgentList || []).map(
      (cohortItem) => {
        const cohortMatch = bispecificTreatment.find(
          (t) => t.cohorttreatmentid === cohortItem.cohortTreatmentId,
        );
        const bispecificIndexDate =
          cohortMatch?.earliestCohortIndexDate || null;

        const updatedAgentLists = (cohortItem.agentLists || []).map((agent) => {
          const steps = [
            {
              label: "date of initial MM diagnosis",
              date: intialMMDiagnosisDate,
            },
            { label: "NDMM index date", date: ndmmIndexDate },
            {
              label: "Bispecifics/CAR-T index date",
              date: bispecificIndexDate,
            },
            {
              label: "Bispecifics/CAR-T agent initiation date",
              date: agent.cohortIndexDate,
            },
            {
              label: "Bispecifics/CAR-T agent end date",
              date: agent.lastDate,
            },
            { label: "end of follow-up date", date: endFollowUpDate },
          ];

          const violation = BuildQ261ChainMessage(
            steps,
            "Bispecifics/CAR-T index date",
            "Bispecifics/CAR-T agent initiation date",
            "Bispecifics/CAR-T agent end date",
          );
          if (violation) result = false;

          return {
            ...agent,
            q261ChainErr: !!violation,
            q261ChainErrMsg: violation?.message ?? null,
            q261ChainErrField: violation?.field ?? null,
          };
        });

        return { ...cohortItem, agentLists: updatedAgentLists };
      },
    );

    return { isValid: result, updatedBispecificAgent };
  };

  const formatDate = (date) => {
    if (!date) return null;
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const yyyy = date.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  };

  const CheckQ261LotSequenceChain = (bispecificAgentList) => {
    let result = true;
    const list = bispecificAgentList || [];

    const updatedBispecificAgent = list.map((cohort) => {
      if (!cohort.agentLists || cohort.agentLists.length === 0) {
        return cohort;
      }

      const orderedAgents = cohort.agentLists
        .map((agent, agentIndex) => ({ agent, agentIndex }))
        .sort((a, b) => {
          const aStart = parseDate(a.agent.cohortIndexDate);
          const bStart = parseDate(b.agent.cohortIndexDate);
          if (!aStart || !bStart) return 0;
          return aStart - bStart;
        });

      const violatingAgentIndexes = new Set();

      for (let i = 0; i < orderedAgents.length; i++) {
        const current = orderedAgents[i].agent;
        if (isStringEmpty(current.lastDate)) continue;

        // this agent's own start <= this agent's own end
        if (
          !isStringEmpty(current.cohortIndexDate) &&
          IsDateAfter(current.cohortIndexDate, current.lastDate)
        ) {
          violatingAgentIndexes.add(orderedAgents[i].agentIndex);
          continue;
        }

        // this agent's end <= the next agent's start, within this same cohort only
        if (i < orderedAgents.length - 1) {
          const next = orderedAgents[i + 1].agent;
          if (
            !isStringEmpty(next.cohortIndexDate) &&
            IsDateAfter(current.lastDate, next.cohortIndexDate)
          ) {
            violatingAgentIndexes.add(orderedAgents[i].agentIndex);
          }
        }
      }

      const updatedAgentLists = cohort.agentLists.map((agent, agentIndex) => {
        const violates = violatingAgentIndexes.has(agentIndex);
        if (violates) result = false;
        return { ...agent, agentSortedDateError: violates };
      });

      return { ...cohort, agentLists: updatedAgentLists };
    });

    return { isValid: result, updatedBispecificAgent };
  };

  const ValidateAgentRepeaterData = (bispecificAgent) => {
    let result = true;
    let errors = {};

    // Start date of the next subsequent LOT after lotNum, taken directly from Q26.1;
    // null (bound skipped) if there is no subsequent LOT or its date is missing.
    const GetNextLotStartDate = (lotNum) => {
      if (isNaN(lotNum)) return null;

      const nextCohort = bispecificAgent
        .filter((c) => Number(c.lineOfTherapy ?? c.lOT) > lotNum)
        .sort(
          (a, b) =>
            Number(a.lineOfTherapy ?? a.lOT) - Number(b.lineOfTherapy ?? b.lOT),
        )[0];

      const date = nextCohort?.cohortIndexDate;
      return !isStringEmpty(date) && IsDateValid(date) ? date : null;
    };

    // Loop through each cohort
    const updatedCohortData = bispecificAgent.map((cohort, idx) => {
      const updatedCohort = { ...cohort };

      if (updatedCohort.agentLists.length === 0) {
        errors[idx] = true;
        return;
      }

      if (!cohort.agentLists || cohort.agentLists.length === 0)
        return updatedCohort;

      // ✅ Latest LAST admin date across agents of CURRENT LOT
      //const latestLastAdminDate = getLatestLastAdminDate(cohort.agentLists);

      // Loop through each agent in the cohort
      const updatedAgents = cohort.agentLists.map((agent) => {
        const updatedAgent = { ...agent };

        // ---- Validate Site of Care / Date of Second Administration (Element C - Daratumumab only) ----
        const isDaratumumabAgent =
          agent.agentName === "Daratumumab (Darzalex)" ||
          agent.agentName === "Daratumumab (Darzalex Faspro)";

        if (isNewEcrfC && isDaratumumabAgent) {
          if (!agent.firstSiteCareC) {
            result = false;
            updatedAgent.showFirstSiteCareError = true;
          } else {
            updatedAgent.showFirstSiteCareError = false;
          }

          if (agent.secondNotReceived === 1) {
            updatedAgent.showSecondDateError = false;
            updatedAgent.showSecondDateRangeError = false;
            updatedAgent.showSecondSiteCareError = false;
          } else {
            if (!agent.secondDate && agent.secondDateUnk !== 1) {
              result = false;
              updatedAgent.showSecondDateError = true;
              updatedAgent.showSecondDateRangeError = false;
            } else {
              updatedAgent.showSecondDateError = false;

              // Initiation date < Date of second administration <=
              // MIN(agent end date, next LOT start date, end of follow-up)
              const cohortLot = Number(cohort.lineOfTherapy ?? cohort.lOT);
              const nextLotStart = GetNextLotStartDate(cohortLot);
              const upperBounds = [
                agent.lastDate,
                nextLotStart,
                endOfFollowUpDate,
              ].filter((d) => !isStringEmpty(d) && IsDateValid(d));
              const upperBound = upperBounds.length
                ? upperBounds.reduce((min, d) =>
                    IsDateAfter(min, d) ? d : min,
                  )
                : null;

              if (
                agent.secondDate &&
                (IsDateEqualOrAfter(agent.cohortIndexDate, agent.secondDate) ||
                  (upperBound && IsDateAfter(agent.secondDate, upperBound)))
              ) {
                result = false;
                updatedAgent.showSecondDateRangeError = true;
              } else {
                updatedAgent.showSecondDateRangeError = false;
              }
            }

            if (!agent.secondSiteCareC) {
              result = false;
              updatedAgent.showSecondSiteCareError = true;
            } else {
              updatedAgent.showSecondSiteCareError = false;
            }
          }
        } else {
          updatedAgent.showFirstSiteCareError = false;
          updatedAgent.showSecondDateError = false;
          updatedAgent.showSecondDateRangeError = false;
          updatedAgent.showSecondSiteCareError = false;
        }

        // ---- Validate Last Administration Date ----
        if (
          !agent.lastDate &&
          agent.lastDateRadio !== 0 &&
          agent.lastDateUnk !== 1
        ) {
          result = false;
          updatedAgent.showColDError = true;
        } else {
          updatedAgent.agentDateRangeError = false;
          updatedAgent.agentDateError = false;

          updatedAgent.showColDError = false;
        }

        // ---- Validate Number of Administrations ----
        if (
          (!agent.noOfAdmission &&
            !agent.noOfAdmissionRadio &&
            !agent.noOfAdmissionUnk &&
            !agent.noOfAdmissionUnkTxt) ||
          (agent.noOfAdmissionRadio &&
            (parseInt(agent.noOfAdmission ?? 0) <= 0 ||
              parseInt(agent.noOfAdmission ?? 0) > 4000))
        ) {
          result = false;
          updatedAgent.showColEError = true;
        } else if (agent.noOfAdmissionRadio === 1 && !agent.noOfAdmission) {
          result = false;
          updatedAgent.showColEError = true;
        } else {
          updatedAgent.showColEError = false;
        }

        if (agent.noOfAdmissionUnk === 1 && !agent.noOfAdmissionUnkTxt) {
          result = false;
          updatedAgent.showColEUkTxtError = true;
        } else {
          updatedAgent.showColEUkTxtError = false;
        }
        // ---- Validate Dose ----
        if (
          !agent.doseAdministrationmg &&
          agent.doseAdministrationmg != "" &&
          !agent.doseAdministrationkg &&
          agent.doseAdministrationkg != "" &&
          !agent.doseAdministrationmgm &&
          agent.doseAdministrationmgm != "" &&
          !agent.doseAdministrationRadioUnknown
        ) {
          result = false;
          updatedAgent.showColHError = true;
        } else if (
          (agent.doseAdministrationRadiomg === 1 &&
            (isStringEmpty(agent.doseAdministrationmg) ||
              parseFloat(agent.doseAdministrationmg) <= 0.0 ||
              parseFloat(agent.doseAdministrationmg) > 4000)) ||
          (agent.doseAdministrationRadiokg === 1 &&
            (isStringEmpty(agent.doseAdministrationkg) ||
              parseFloat(agent.doseAdministrationkg) <= 0.0 ||
              parseFloat(agent.doseAdministrationkg) > 4000)) ||
          (agent.doseAdministrationRadiomgm === 1 &&
            (isStringEmpty(agent.doseAdministrationmgm) ||
              parseFloat(agent.doseAdministrationmgm) <= 0.0 ||
              parseFloat(agent.doseAdministrationmgm) > 4000))
        ) {
          result = false;
          updatedAgent.showColHError = true;
        } else {
          updatedAgent.showColHError = false;
        }

        // ---- Validate Discontinue Agent ----
        if (agent.discontinueAgent == null) {
          result = false;
          updatedAgent.showColFError = true;
        } else {
          updatedAgent.showColFError = false;
        }

        // ---- Validate Reason for Discontinuing ----
        if (agent.discontinueAgent === 1) {
          const anySelected = agent.reasonForDiscontinuingMedications?.some(
            (r) => r.isSelected,
          );
          if (
            !anySelected &&
            !agent.reasonForDiscontinuingMedications[0].reasonUnk
          ) {
            result = false;
            updatedAgent.showColGError = true;
          } else {
            updatedAgent.showColGError = false;

            const otherSelected = agent.reasonForDiscontinuingMedications?.some(
              (r) =>
                r.isSelected && r.reasonName.includes("Other") && !r.reasonText,
            );
            if (otherSelected) {
              result = false;
              updatedAgent.showColGOthError = true;
            } else {
              updatedAgent.showColGOthError = false;
            }
          }

          // Patient death reason requires a known date of death (Q20)
          const isDeathReasonSelected =
            agent.reasonForDiscontinuingMedications?.some(
              (r) =>
                r.isSelected &&
                r.reasonName === DiscontinuationReason.PatientDeath,
            );
          if (isDeathReasonSelected && isStringEmpty(deathDeath)) {
            result = false;
            updatedAgent.discontinuationSoftError = true;
          } else {
            updatedAgent.discontinuationSoftError = false;
          }

          if (isNewEcrfA) {
            const adverseEventSelected =
              agent.reasonForDiscontinuingMedications?.some(
                (r) =>
                  r.isSelected &&
                  r.reasonName === DiscontinuationReason.AdverseEvent,
              );

            if (adverseEventSelected) {
              const aeList = agent.adverseEventsDiscontinuationreason || [];
              const anyAESelected = aeList.some((ae) => ae.isSelected);

              if (!anyAESelected) {
                result = false;
                updatedAgent.showAdverseEventError = true;
              } else {
                updatedAgent.showAdverseEventError = false;
              }
            } else {
              updatedAgent.showAdverseEventError = false;
            }

            const adverseNeurologicalEventSelected =
              agent.adverseEventsDiscontinuationreason?.some(
                (r) =>
                  r.isSelected &&
                  r.reasonName === DiscontinuationReason.NeurologicalEvent,
              );

            if (adverseNeurologicalEventSelected) {
              const aeList =
                agent.adverseNeurologicalEventsDiscontinuationreason || [];
              const anyAESelected = aeList.some((ae) => ae.isSelected);

              if (!anyAESelected) {
                result = false;
                updatedAgent.showAdverseNeuroEventError = true;
              } else {
                updatedAgent.showAdverseNeuroEventError = false;

                const otherSelected =
                  agent.adverseNeurologicalEventsDiscontinuationreason?.some(
                    (r) =>
                      r.isSelected &&
                      r.reasonName.includes("Other") &&
                      !r.reasonText,
                  );
                if (otherSelected) {
                  result = false;
                  updatedAgent.showAdverseNeuroEventOtherTextError = true;
                } else {
                  updatedAgent.showAdverseNeuroEventOtherTextError = false;
                }
              }
            } else {
              updatedAgent.showAdverseNeuroEventError = false;
            }
          }
        }

        return updatedAgent;
      });

      updatedCohort.agentLists = updatedAgents;
      return updatedCohort;
    });

    setTreatmentErrors(errors);
    setbispecificAgent(updatedCohortData);
    return result;
  };

  function parseDate(dateString) {
    if (!dateString || typeof dateString !== "string" || !dateString.trim()) {
      return undefined; // or null, depending on what your app expects
    }

    const [month, day, year] = dateString.split("/");

    if (!month || !day || !year) {
      return undefined;
    }

    return new Date(year, month - 1, day);
  }

  const sidebar = document.getElementById("mySidebar");
  const main = document.getElementById("main");

  const toggleNav = () => {
    if (isSideMenuActive === true) {
      sidebar.style.width = "0";
      main.style.marginLeft = "0";
      setIsSideMenuActive(false);
    } else if (isSideMenuActive === false) {
      sidebar.style.width = "350px";
      main.style.marginLeft = "350px";
      setIsSideMenuActive(true);
    }
  };

  useEffect(() => {
    const sidebar = document.getElementById("mySidebar");
    const main = document.getElementById("main");

    if (isSideMenuActive === true) {
      sidebar.style.width = "350px";
      main.style.marginLeft = "350px";
    } else {
      sidebar.style.width = "0";
      main.style.marginLeft = "0";
    }
  });

  const ShowAlertBox = async () => {
    await ShowActionPopUp(
      "Alert", //title
      CommonError_Msgs.DateChangeAlert, //message
      "Ok", //Confirm button text
      true,
    );
  };

  const Handle262FieldChange = (e) => {
    const { name, id, value } = e.target;
    const value_int = Number(value);

    let updatedArray = [...bispecificHighestLotList];

    if (isNewEcrfA) {
      switch (name) {
        //Q26.2
        case "q262_rbl_B" + id:
          {
            updatedArray[id] = {
              ...updatedArray[id],
              q262_date_B: null,
              q262_rbl_B: value_int,
              q262_B_unk_err: value_int === 99 ? true : false,
              q262_B_empty_err: false,
              q262_B_invalid_date: false,
              q262_B_before_err: false,
              q262_B_before_next_lot_err: false,
              q262_B_beyond_eof_err: false,
              q262_B_after_end_err: false,
              q262ChainErrStart: false,
              q262ChainErrStartMsg: null,
              q262ChainErrEnd: false,
              q262ChainErrEndMsg: null,
              q262RowChainErrStart: false,
              q262RowChainErrStartMsg: null,
              q262RowChainErrEnd: false,
              q262RowChainErrEndMsg: null,
            };
          }
          break;
        case "q262_rbl_C" + id:
          {
            updatedArray[id] = {
              ...updatedArray[id],
              q262_date_C: null,
              q262_rbl_C: value_int,
              q262_C_unk_err: value_int === 99 ? true : false,
              q262_C_empty_err: false,
              q262_C_invalid_date: false,
              q262_C_before_err: false,
              q262_C_citaabecm_err: false,
              q262_C_before_next_lot_err: false,
              q262_C_beyond_eof_err: false,
              q262_B_after_end_err: false,
              q262ChainErrStart: false,
              q262ChainErrStartMsg: null,
              q262ChainErrEnd: false,
              q262ChainErrEndMsg: null,
              q262RowChainErrStart: false,
              q262RowChainErrStartMsg: null,
              q262RowChainErrEnd: false,
              q262RowChainErrEndMsg: null,
            };
          }
          break;
        case "q262_rb_received_tmt_unk" + id:
          {
            updatedArray[id] = {
              ...updatedArray[id],
              q262_rb_received_tmt_unk:
                !updatedArray[id].q262_rb_received_tmt_unk,
              q262_selectedReceivedTmtList: [],
              q262_D_empty_err: false,
              q262_D_txt_empty_err: false,
              q262_DaraNotSelected_err: false,
            };
          }
          break;
        case "chk_q262_received_tmt" + id:
          {
            const index = id.split("_")[0];
            const tmtID = id.split("_").pop(); // Extract the selected received tmt id
            const selTmtList = updatedArray[index].q262_selectedReceivedTmtList;
            const tmtIndex = selTmtList.findIndex(
              (item) => item.prescribedTreatmentId === Number(tmtID),
            );

            if (tmtIndex >= 0) {
              // Checkbox unselect
              selTmtList.splice(tmtIndex, 1);
            } else {
              // Checkbox select
              selTmtList.push({ prescribedTreatmentId: Number(tmtID) });
            }
            updatedArray[index] = {
              ...updatedArray[index],
              q262_selectedReceivedTmtList: selTmtList,
              q262_rb_received_tmt_unk: false,

              q262_D_empty_err: false,
              q262_D_txt_empty_err: false,
              q262_DaraNotSelected_err: false,
            };
          }
          break;
        case "q262_txt_received_tmt_oth":
          {
            const index = id.split("_")[0];
            const tmtID = id.split("_").pop();
            const selTmtList = updatedArray[index].q262_selectedReceivedTmtList;

            // Check if the item with the same prescribedTreatmentId already exists
            const existingItemIndex = selTmtList.findIndex(
              (item) => item.prescribedTreatmentId === Number(tmtID),
            );

            if (existingItemIndex >= 0) {
              selTmtList[existingItemIndex] = {
                ...selTmtList[existingItemIndex],
                prescribedTreatmentOthTxt: value,
              };
            } else {
              selTmtList.push({
                prescribedTreatmentId: Number(tmtID),
                prescribedTreatmentOthTxt: value,
              });
            }

            updatedArray[index] = {
              ...updatedArray[index],
              q262_selectedReceivedTmtList: selTmtList,
              q262_rb_received_tmt_unk: false,

              q262_D_empty_err: false,
              q262_D_txt_empty_err: false,
              q262_DaraNotSelected_err: false,
            };
          }
          break;
        case "q262_rbl_E" + id:
          {
            updatedArray[id] = {
              ...updatedArray[id],
              q262_rbl_E: value_int,
              q262_E_empty_err: false,
            };
          }
          break;
        case "q262_rbl_F" + id:
          {
            const clearAgentsRefractory = value_int !== 1;
            updatedArray[id] = {
              ...updatedArray[id],
              q262_rbl_F: value_int,
              q262_F_empty_err: false,
              q262_agentRefractoryLena: clearAgentsRefractory
                ? false
                : updatedArray[id].q262_agentRefractoryLena,
              q262_agentRefractoryDara: clearAgentsRefractory
                ? false
                : updatedArray[id].q262_agentRefractoryDara,
              q262_agentRefractoryDarafaspro: clearAgentsRefractory
                ? false
                : updatedArray[id].q262_agentRefractoryDarafaspro,
              q262_agentRefractoryIsatu: clearAgentsRefractory
                ? false
                : updatedArray[id].q262_agentRefractoryIsatu,
              q262_agentRefractoryNone: clearAgentsRefractory
                ? false
                : updatedArray[id].q262_agentRefractoryNone,
              q262_G_empty_err: false,
            };
          }
          break;
        case "chk_q262_agentRefractoryLena" + id:
          {
            updatedArray[id] = {
              ...updatedArray[id],
              q262_agentRefractoryLena:
                !updatedArray[id].q262_agentRefractoryLena,
              q262_agentRefractoryNone: false,
              q262_G_empty_err: false,
            };
          }
          break;
        case "chk_q262_agentRefractoryDara" + id:
          {
            updatedArray[id] = {
              ...updatedArray[id],
              q262_agentRefractoryDara:
                !updatedArray[id].q262_agentRefractoryDara,
              q262_agentRefractoryNone: false,
              q262_G_empty_err: false,
            };
          }
          break;
        case "chk_q262_agentRefractoryDarafaspro" + id:
          {
            updatedArray[id] = {
              ...updatedArray[id],
              q262_agentRefractoryDarafaspro:
                !updatedArray[id].q262_agentRefractoryDarafaspro,
              q262_agentRefractoryNone: false,
              q262_G_empty_err: false,
            };
          }
          break;
        case "chk_q262_agentRefractoryIsatu" + id:
          {
            updatedArray[id] = {
              ...updatedArray[id],
              q262_agentRefractoryIsatu:
                !updatedArray[id].q262_agentRefractoryIsatu,
              q262_agentRefractoryNone: false,
              q262_G_empty_err: false,
            };
          }
          break;
        case "q262_rb_agentRefractoryNone" + id:
          {
            updatedArray[id] = {
              ...updatedArray[id],
              q262_agentRefractoryLena: false,
              q262_agentRefractoryDara: false,
              q262_agentRefractoryDarafaspro: false,
              q262_agentRefractoryIsatu: false,
              q262_agentRefractoryNone: true,
              q262_G_empty_err: false,
            };
          }
          break;
        default:
          break;
      }
    }

    //Q26.3 (Element C)
    if (isNewEcrfC && name === "q263_rbl_D" + id) {
      updatedArray[id] = {
        ...updatedArray[id],
        q263_date_D: null,
        q263_rbl_D: value_int,
        q263_C_empty_err: false,
        q263_C_invalid_date: false,
        q263_C_chain_err: false,
      };
    }

    setBispecificHighestLotList(updatedArray);
  };

  const Handle262DateChange = (name, date, id) => {
    let updatedArray = [...bispecificHighestLotList];

    if (isNewEcrfA) {
      switch (name) {
        case "q262_date_B" + id:
          updatedArray[id].q262_date_B = date;
          updatedArray[id].q262_rbl_B = 1;

          updatedArray[id].q262_B_empty_err = false;
          updatedArray[id].q262_B_unk_err = false;
          updatedArray[id].q262_B_invalid_date = false;
          updatedArray[id].q262_B_before_err = false;
          updatedArray[id].q262_B_before_next_lot_err = false;
          updatedArray[id].q262_B_beyond_eof_err = false;
          updatedArray[id].q262_B_after_end_err = false;
          updatedArray[id].q262ChainErrStart = false;
          updatedArray[id].q262ChainErrStartMsg = null;
          updatedArray[id].q262ChainErrEnd = false;
          updatedArray[id].q262ChainErrEndMsg = null;
          updatedArray[id].q262RowChainErrStart = false;
          updatedArray[id].q262RowChainErrStartMsg = null;
          updatedArray[id].q262RowChainErrEnd = false;
          updatedArray[id].q262RowChainErrEndMsg = null;

          break;
        case "q262_date_C" + id:
          updatedArray[id].q262_date_C = date;
          updatedArray[id].q262_rbl_C = 1;

          updatedArray[id].q262_C_empty_err = false;
          updatedArray[id].q262_C_unk_err = false;
          updatedArray[id].q262_C_invalid_date = false;
          updatedArray[id].q262_C_before_err = false;
          updatedArray[id].q262_C_citaabecm_err = false;
          updatedArray[id].q262_C_before_next_lot_err = false;
          updatedArray[id].q262_C_beyond_eof_err = false;
          updatedArray[id].q262_B_after_end_err = false;
          updatedArray[id].q262ChainErrStart = false;
          updatedArray[id].q262ChainErrStartMsg = null;
          updatedArray[id].q262ChainErrEnd = false;
          updatedArray[id].q262ChainErrEndMsg = null;
          updatedArray[id].q262RowChainErrStart = false;
          updatedArray[id].q262RowChainErrStartMsg = null;
          updatedArray[id].q262RowChainErrEnd = false;
          updatedArray[id].q262RowChainErrEndMsg = null;

          break;

        default:
          break;
      }
    }

    //Q26.3 (Element C)
    if (isNewEcrfC && name === "q263_date_D" + id) {
      updatedArray[id].q263_date_D = date;
      updatedArray[id].q263_rbl_D = 1;

      updatedArray[id].q263_C_empty_err = false;
      updatedArray[id].q263_C_invalid_date = false;
      updatedArray[id].q263_C_chain_err = false;
    }

    setBispecificHighestLotList(updatedArray);
  };

  return (
    <>
      <section className="survey-patient-details-section">
        <div className="row">
          <PatientDetails />
          <div className="col-12 col-sm-5 col-md-5 col-lg-6 col-content-alignment">
            <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
          </div>
        </div>
      </section>
      <section className="main-survey-section">
        <div>
          <SideBarMenu
            activePageId={SideMenuItems.BispecificsCartTreatmentCohort}
          />
          <>
            <button
              className={isSideMenuActive ? "openbtn" : "openbtn active"}
              // onclick="toggleNav()"
              onClick={() => toggleNav()}
            >
              <i
                id="arrowNavigation"
                className="fa fa-arrow-left"
                aria-hidden="true"
              ></i>
            </button>
          </>
          <div className="col-pad-left" id="main">
            <div className="survey-section-content">
              <div className="survey-section-content-header">
                <h4>BISPECIFIC/CAR-T TREATMENT COHORT</h4>
              </div>
              {showTopErrMsg && (
                <div className="clean-error ">
                  <ErrorField
                    show={showTopErrMsg}
                    message={CommonError_Msgs.Hard_Empty}
                  />
                </div>
              )}
              <div className="survey-question-section">
                <div className="survey-question-content calender-datefix-survey">
                  <div className="question-answer">
                    {/* Q26 */}
                    <div className="question-bot-sapce">
                      <div className="question question-weight">
                        <span>Q26.</span>
                        <span className="quest-text-pad">
                          Describe the prescribed dosing information for each
                          bispecific and/or CAR-T therapy that the patient has
                          received. <br />
                          <b>Please note the following: </b>
                          <br />
                          <b>
                            (a) Date of first administration of Bispecific/CAR-T
                            treatment must be no later than the date of last
                            administration of the same treatment
                          </b>
                          <br />
                          <b>
                            (b) None of the dates of first administration or
                            last administration should be later than the end of
                            follow up on{" "}
                            <span
                              style={{ color: PageDesignConstants.fontColor }}
                            >
                              {endFollowUpDate
                                ? endFollowUpDate
                                : "[end of follow up]"}
                            </span>
                            .
                          </b>
                          <br />
                          <b>
                            (c) None of the dates of first administration should
                            be before the index date on{" "}
                            {bispecificTreatment &&
                            bispecificTreatment.length > 0 ? (
                              bispecificTreatment.map((data, idx) => (
                                <React.Fragment key={idx}>
                                  {idx > 0 && ", "}
                                  <span
                                    style={{
                                      color: PageDesignConstants.fontColor,
                                    }}
                                  >
                                    {data.cohortTreatmentName}
                                    {data.supscripttext == null ? (
                                      ""
                                    ) : (
                                      <>
                                        <sup className="supscript">
                                          {data.supscripttext.slice(0, 2)}
                                        </sup>{" "}
                                        {data.lOT}L -{" "}
                                        {data.supscripttext.slice(2)}
                                      </>
                                    )}
                                    {" ["}
                                    {data.earliestCohortIndexDate
                                      ? data.earliestCohortIndexDate
                                      : "Bispecific/CAR-T index date"}
                                    {"]"}
                                  </span>
                                </React.Fragment>
                              ))
                            ) : (
                              <span
                                style={{
                                  color: PageDesignConstants.fontColor,
                                }}
                              >
                                [Bispecific/CAR-T index date]
                              </span>
                            )}
                            .
                          </b>
                          <br />
                          <b>
                            (d) If the LOT is ongoing at the time of chart
                            abstraction/refreshing, enter the date of the last
                            known administration received by the patient.
                          </b>
                          <br />
                          <b>
                            (e) If a medication agent’s discontinuation status
                            is “No, medication ongoing at time of last
                            encounter” below, please enter the “Date of the last
                            administration” as the last known administration
                            date on or prior to the patient’s last encounter
                            date on{" "}
                            <span
                              style={{ color: PageDesignConstants.fontColor }}
                            >
                              {lastEncounterDate
                                ? lastEncounterDate
                                : "[date of last encounter]"}
                            </span>
                            .
                          </b>{" "}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="question-answer">
                    <div className="question-bot-sapce">
                      <div className=" double-dig-answer">
                        <div className="" style={{ overflowX: "auto" }}>
                          <table
                            style={{
                              border: "1px solid black",
                              borderCollapse: "collapse",
                              width: "100%",
                            }}
                          >
                            <thead>
                              <tr>
                                <th
                                  style={{
                                    border: "1px solid black",
                                    padding: "8px",
                                    textAlign: "center",
                                  }}
                                >
                                  Medication
                                </th>
                                <th
                                  style={{
                                    border: "1px solid black",
                                    padding: "8px",
                                    textAlign: "center",
                                    minWidth: "135px",
                                  }}
                                >
                                  {" "}
                                  <span
                                    data-tooltip-id="encounterTip"
                                    className="modal-popup"
                                    onClick={() =>
                                      setShowHideHyperlinkModal(true)
                                    }
                                  >
                                    Line Of Therapy
                                  </span>
                                  {showHideHyperlinkModal && (
                                    <InfoPopUp
                                      description={hyperlinkTextLineOfTherapy}
                                      OkClick={() =>
                                        setShowHideHyperlinkModal(false)
                                      }
                                    />
                                  )}{" "}
                                </th>
                                <th
                                  style={{
                                    border: "1px solid black",
                                    padding: "8px",
                                    textAlign: "center",
                                  }}
                                >
                                  Date of first administration
                                </th>
                                <th
                                  style={{
                                    border: "1px solid black",
                                    padding: "8px",
                                    textAlign: "center",
                                  }}
                                >
                                  Date of last or most recent administration
                                </th>
                                <th
                                  style={{
                                    border: "1px solid black",
                                    padding: "8px",
                                    textAlign: "center",
                                    minWidth: "195px",
                                  }}
                                >
                                  Number of administrations
                                </th>
                                <th
                                  style={{
                                    border: "1px solid black",
                                    padding: "8px",
                                    textAlign: "center",
                                    minWidth: "305px",
                                  }}
                                >
                                  Dose at first administration
                                </th>
                                <th
                                  style={{
                                    border: "1px solid black",
                                    padding: "8px",
                                    textAlign: "center",
                                    minWidth: "250px",
                                  }}
                                >
                                  Did patient discontinue agent?
                                </th>
                                <th
                                  style={{
                                    border: "1px solid black",
                                    padding: "8px",
                                    textAlign: "center",
                                    minWidth: "300px",
                                  }}
                                >
                                  Reason for discontinuing
                                </th>
                              </tr>
                            </thead>

                            <tbody>
                              {/* Populate static rows */}
                              {bispecificTreatment.length > 0 &&
                                bispecificTreatment?.map((data, idx) => (
                                  <tr key={idx}>
                                    <td
                                      style={{
                                        border: "1px solid black",
                                        alignContent: "start",
                                        textAlign: "center",
                                        padding: "8px",
                                      }}
                                    >
                                      {}
                                      <div>
                                        {data.cohortTreatmentName}
                                        {data.supscripttext == null ? (
                                          ""
                                        ) : (
                                          <>
                                            <sup className="supscript">
                                              {data.supscripttext.slice(0, 2)}
                                            </sup>
                                            {data.supscripttext.slice(2)}
                                          </>
                                        )}
                                      </div>
                                    </td>

                                    <td
                                      style={{
                                        border: "1px solid black",
                                        alignContent: "flex-start",
                                        textAlign: "center",
                                        padding: "10px",
                                      }}
                                    >
                                      <div className="">
                                        <label
                                          htmlFor={`q26b_${data.cohortTreatmentName}_lottxt_${idx}`}
                                        >
                                          <span className="">
                                            {data.lOT}
                                            {/* <input
                                              className="input-dash"
                                              id={`q26b_${data.cohortTreatmentName}_lottxt_${idx}`}
                                              name={`q26b_${data.cohortTreatmentName}_lottxt_${idx}`}
                                              type="text"
                                              disabled={true}
                                              value={data.lOT}
                                              // min={2}
                                              // max={40}
                                              //maxLength={2}
                                              // onKeyDown={(e) => {
                                              //   // Prevent entering '.', 'e', '+', '-', and any non-numeric characters
                                              //   if (
                                              //     [
                                              //       ".",
                                              //       "e",
                                              //       "+",
                                              //       "-",
                                              //       "E",
                                              //     ].includes(e.key) ||
                                              //     (e.key.length === 1 &&
                                              //       !/[0-9]/.test(e.key))
                                              //   ) {
                                              //     e.preventDefault();
                                              //   }
                                              // }}
                                              // onChange={(e) =>
                                              //   HandleRepeaterFieldChange(
                                              //     e,
                                              //     data.cohortTreatmentName,
                                              //     null,
                                              //     null,
                                              //     null,
                                              //   )
                                              // }
                                            /> */}
                                          </span>
                                        </label>
                                        {/*<label><span className="" style={{ textAlign: 'start' }}>(Range: 1 to 40)</span></label>*/}
                                      </div>

                                      <ErrorField
                                        style={{ padding: "0px" }}
                                        show={
                                          bispecificTreatment[idx].showColBError
                                        }
                                        message={
                                          BispecificCartTreatmentCohort_Msgs.q26b
                                        }
                                      />
                                      <ErrorField
                                        style={{ padding: "0px" }}
                                        show={
                                          bispecificTreatment[idx]
                                            .showColBDuplicateLotError
                                        }
                                        message={
                                          BispecificCartTreatmentCohort_Msgs.q26duplicateb
                                        }
                                      />
                                    </td>

                                    <td
                                      style={{
                                        border: "1px solid black",
                                        alignContent: "start",
                                        textAlign: "center",
                                        padding: "8px",
                                      }}
                                    >
                                      {}
                                      <div
                                        className="radio-text-padding"
                                        style={{ display: "flex" }}
                                      >
                                        <div>{data.cohortInitiationDate}</div>
                                      </div>
                                    </td>

                                    {bispecificTreatment[idx]
                                      .cohorttreatmentid !=
                                      RRMMCohortTreatment.CARVYKTI &&
                                    bispecificTreatment[idx]
                                      .cohorttreatmentid !=
                                      RRMMCohortTreatment.ABECMA ? (
                                      <td
                                        style={{
                                          border: "1px solid black",
                                          alignContent: "flex-start",
                                          textAlign: "center",
                                          padding: "8px",
                                        }}
                                      >
                                        <div className="">
                                          <div
                                            className="option-without-input"
                                            style={{
                                              display: "flex",
                                              alignItems: "flex-start",
                                            }}
                                          >
                                            <input
                                              type="radio"
                                              id={`q26d_LRadio_${data.cohortTreatmentName}_${idx}`}
                                              name={`q26d_LRadio_${data.cohortTreatmentName}_${idx}`}
                                              style={{ marginTop: "6px" }}
                                              value={1}
                                              checked={data.lastDateRadio === 1}
                                              onChange={(e) =>
                                                HandleRepeaterFieldChange(
                                                  e,
                                                  data.cohortTreatmentName,
                                                  null,
                                                  null,
                                                  null,
                                                )
                                              }
                                            />
                                            <span
                                              className="radio-text-padding datepicker-dependence calender-datefix"
                                              style={{ paddingLeft: "5px" }}
                                            >
                                              <DatePickerComponent
                                                ctrlId={`q26d_LDate_${idx}`}
                                                HandleDateChange={
                                                  HandleDateChange
                                                }
                                                minDate={dayjs("01-01-1920")}
                                                maxDate={dayjs()}
                                                locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                date={data.lastDate}
                                              />
                                            </span>
                                          </div>
                                          <div
                                            className="option-without-input"
                                            style={{
                                              display: "flex",
                                              alignItems: "flex-start",
                                            }}
                                          >
                                            <label
                                              style={{
                                                textAlign: "start",
                                                display: "flex",
                                                alignItems: "flex-start",
                                              }}
                                            >
                                              <input
                                                type="radio"
                                                id={`q26d_${data.cohortTreatmentName}_LUnk_${idx}`}
                                                name={`q26d_${data.cohortTreatmentName}_LUnk_${idx}`}
                                                style={{ marginTop: "6px" }}
                                                value={1}
                                                checked={data.lastDateUnk === 1}
                                                onChange={(e) =>
                                                  HandleRepeaterFieldChange(
                                                    e,
                                                    data.cohortTreatmentName,
                                                    null,
                                                    null,
                                                    null,
                                                  )
                                                }
                                              />
                                              <span className="radio-text-padding">
                                                Date of last administration
                                                unknown
                                              </span>
                                            </label>
                                          </div>
                                        </div>
                                        <ErrorField
                                          style={{ padding: "0px" }}
                                          show={
                                            bispecificTreatment[idx]
                                              .showColDError
                                          }
                                          message={
                                            BispecificCartTreatmentCohort_Msgs.q26d
                                          }
                                        />
                                        <ErrorField
                                          style={{ padding: "0px" }}
                                          show={
                                            bispecificTreatment[idx].q26ChainErr
                                          }
                                          message={
                                            bispecificTreatment[idx]
                                              .q26ChainErrMsg ||
                                            BispecificCartTreatmentCohort_Msgs.q26_chain
                                          }
                                        />

                                        <ErrorField
                                          style={{ padding: "0px" }}
                                          show={
                                            bispecificTreatment[idx]
                                              .showColD_SEFDateError
                                          }
                                          message={
                                            BispecificCartTreatmentCohort_Msgs.q26d_sef
                                          }
                                        />
                                        <ErrorField
                                          style={{ padding: "0px" }}
                                          show={
                                            bispecificTreatment[idx]
                                              .showColD_DateError ||
                                            bispecificTreatment[idx]
                                              .showColD_SortedDateError
                                          }
                                          message={
                                            BispecificCartTreatmentCohort_Msgs.q26d_date
                                          }
                                        />
                                        <ErrorField
                                          style={{ padding: "0px" }}
                                          show={
                                            bispecificTreatment[idx]
                                              .showColD_EFDateError
                                          }
                                          message={
                                            BispecificCartTreatmentCohort_Msgs.q26d_sef
                                          }
                                        />
                                        <ErrorField
                                          style={{ padding: "0px" }}
                                          show={
                                            bispecificTreatment[idx]
                                              .showColD_InvalidDate
                                          }
                                          message={CommonError_Msgs.InvalidDate}
                                        />
                                      </td>
                                    ) : (
                                      <td
                                        style={{
                                          border: "1px solid black",
                                          alignContent: "flex-start",
                                          textAlign: "center",
                                          padding: "8px",
                                          textAlign: "start",
                                        }}
                                      >
                                        <span
                                          style={{ textAlign: "center" }}
                                          className="not-applicable"
                                        >
                                          <b>Not applicable</b>
                                        </span>
                                      </td>
                                    )}

                                    {bispecificTreatment[idx]
                                      .cohorttreatmentid !=
                                      RRMMCohortTreatment.CARVYKTI &&
                                    bispecificTreatment[idx]
                                      .cohorttreatmentid !=
                                      RRMMCohortTreatment.ABECMA ? (
                                      <td
                                        style={{
                                          border: "1px solid black",
                                          alignContent: "flex-start",

                                          padding: "8px",
                                        }}
                                      >
                                        <div
                                          className="option-fbox"
                                          style={{ width: "216px" }}
                                        >
                                          <label
                                            htmlFor={`q26e_${data.cohortTreatmentName}_Noa_${idx}`}
                                          >
                                            <input
                                              type="radio"
                                              id={`q26e_${data.cohortTreatmentName}_Noa_${idx}`}
                                              name={`q26e_${data.cohortTreatmentName}_Noa_${idx}`}
                                              value={1}
                                              checked={
                                                data.noOfAdmissionRadio === 1
                                              }
                                              onChange={(e) =>
                                                HandleRepeaterFieldChange(
                                                  e,
                                                  data.cohortTreatmentName,
                                                  null,
                                                  null,
                                                  null,
                                                )
                                              }
                                            />
                                          </label>
                                          <label
                                            htmlFor={`q26e_${data.cohortTreatmentName}_Noatxt_${idx}`}
                                          >
                                            <span className="radio-text-padding">
                                              <input
                                                className="input-dash"
                                                id={`q26e_${data.cohortTreatmentName}_Noatxt_${idx}`}
                                                name={`q26e_${data.cohortTreatmentName}_Noatxt_${idx}`}
                                                type="text"
                                                value={data.noOfAdmission}
                                                min={1}
                                                max={4000}
                                                // maxLength={3}
                                                onKeyDown={(e) => {
                                                  // Prevent entering '.', 'e', '+', '-', and any non-numeric characters
                                                  if (
                                                    [
                                                      ".",
                                                      "e",
                                                      "+",
                                                      "-",
                                                      "E",
                                                    ].includes(e.key) ||
                                                    (e.key.length === 1 &&
                                                      !/[0-9]/.test(e.key))
                                                  ) {
                                                    e.preventDefault();
                                                  }
                                                }}
                                                onChange={(e) =>
                                                  HandleRepeaterFieldChange(
                                                    e,
                                                    data.cohortTreatmentName,
                                                    null,
                                                    null,
                                                    null,
                                                  )
                                                }
                                              />
                                            </span>
                                          </label>
                                          {/*<label><span className="" style={{ marginLeft: '12px', textAlign: 'start' }}>(Range: 1 to 550)</span></label>*/}
                                        </div>
                                        <div
                                          className="option-without-input"
                                          style={{ width: "216px" }}
                                        >
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={`q26e_${data.cohortTreatmentName}_NoaUnk_${idx}`}
                                              name={`q26e_${data.cohortTreatmentName}_NoaUnk_${idx}`}
                                              value={1}
                                              checked={
                                                data.noOfAdmissionUnk === 1
                                              }
                                              onChange={(e) =>
                                                HandleRepeaterFieldChange(
                                                  e,
                                                  data.cohortTreatmentName,
                                                  null,
                                                  null,
                                                  null,
                                                )
                                              }
                                            />
                                            <span
                                              className="radio-text-padding"
                                              style={{ textAlign: "left" }}
                                            >
                                              Unknown, please specify dosing
                                              schedule:
                                              <textarea
                                                className="input-dash"
                                                id={`q26e_${data.cohortTreatmentName}_NoaUnktxt_${idx}`}
                                                name={`q26e_${data.cohortTreatmentName}_NoaUnktxt_${idx}`}
                                                type="text"
                                                value={data.noOfAdmissionUnkTxt}
                                                onChange={(e) =>
                                                  HandleRepeaterFieldChange(
                                                    e,
                                                    data.cohortTreatmentName,
                                                    null,
                                                    null,
                                                    null,
                                                  )
                                                }
                                              />
                                            </span>
                                          </label>
                                        </div>
                                        <ErrorField
                                          style={{ padding: "0px" }}
                                          show={
                                            bispecificTreatment[idx]
                                              .showColEError
                                          }
                                          message={
                                            BispecificCartTreatmentCohort_Msgs.q26e
                                          }
                                        />
                                        <ErrorField
                                          style={{ padding: "0px" }}
                                          show={
                                            bispecificTreatment[idx]
                                              .showColEUkTxtError
                                          }
                                          message={
                                            BispecificCartTreatmentCohort_Msgs.q26eTxt
                                          }
                                        />
                                      </td>
                                    ) : (
                                      <td
                                        style={{
                                          border: "1px solid black",
                                          alignContent: "flex-start",
                                          textAlign: "center",
                                          padding: "8px",
                                          textAlign: "start",
                                        }}
                                      >
                                        <span
                                          style={{ textAlign: "center" }}
                                          className="not-applicable"
                                        >
                                          <b>Not applicable</b>
                                        </span>
                                      </td>
                                    )}

                                    {bispecificTreatment[idx]
                                      .cohorttreatmentid !=
                                      RRMMCohortTreatment.CARVYKTI &&
                                    bispecificTreatment[idx]
                                      .cohorttreatmentid !=
                                      RRMMCohortTreatment.ABECMA ? (
                                      <td
                                        style={{
                                          border: "1px solid black",
                                          alignContent: "flex-start",

                                          padding: "8px",
                                        }}
                                      >
                                        <div className="option-fbox">
                                          <label
                                            htmlFor={`q26h1_${data.cohortTreatmentName}_mg_${idx}`}
                                          >
                                            <input
                                              type="radio"
                                              id={`q26h1_${data.cohortTreatmentName}_mg_${idx}`}
                                              name={`q26h1_${data.cohortTreatmentName}_mg_${idx}`}
                                              value={1}
                                              checked={
                                                data.doseAdministrationRadiomg ===
                                                1
                                              }
                                              onChange={(e) =>
                                                HandleRepeaterFieldChange(
                                                  e,
                                                  data.cohortTreatmentName,
                                                  null,
                                                  null,
                                                  null,
                                                )
                                              }
                                            />
                                          </label>
                                          <label
                                            htmlFor={`q26h1_${data.cohortTreatmentName}_mgtxt_${idx}`}
                                          >
                                            <span className="radio-text-padding">
                                              <input
                                                className="input-dash-custom"
                                                id={`q26h1_${data.cohortTreatmentName}_mgtxt_${idx}`}
                                                name={`q26h1_${data.cohortTreatmentName}_mgtxt_${idx}`}
                                                type="text"
                                                value={
                                                  data.doseAdministrationmg
                                                }
                                                min={0}
                                                max={4000}
                                                // maxLength={3}
                                                onKeyDown={(e) => {
                                                  // Allow backspace, arrow keys, delete, and tab
                                                  if (
                                                    [
                                                      "Backspace",
                                                      "ArrowLeft",
                                                      "ArrowRight",
                                                      "Delete",
                                                      "Tab",
                                                    ].includes(e.key)
                                                  ) {
                                                    return;
                                                  }
                                                  // Prevent non-numeric characters, except '.' (and only allow one decimal point)
                                                  if (
                                                    !/[0-9.]/.test(e.key) ||
                                                    (e.key === "." &&
                                                      e.target.value.includes(
                                                        ".",
                                                      ))
                                                  ) {
                                                    e.preventDefault();
                                                    return;
                                                  }
                                                  const value = e.target.value;
                                                  const selectionStart =
                                                    e.target.selectionStart;
                                                  const newValue =
                                                    value.slice(
                                                      0,
                                                      selectionStart,
                                                    ) +
                                                    e.key +
                                                    value.slice(
                                                      e.target.selectionEnd,
                                                    );
                                                  // Prevent '.' as the first character
                                                  if (
                                                    e.key === "." &&
                                                    value === ""
                                                  ) {
                                                    e.preventDefault();
                                                    return;
                                                  }
                                                  // Allow only one digit after decimal point
                                                  if (
                                                    newValue.includes(".") &&
                                                    newValue.split(".")[1]
                                                      .length > 2
                                                  ) {
                                                    e.preventDefault();
                                                  }
                                                }}
                                                onChange={(e) =>
                                                  HandleRepeaterFieldChange(
                                                    e,
                                                    data.cohortTreatmentName,
                                                    null,
                                                    null,
                                                    null,
                                                  )
                                                }
                                              />{" "}
                                              &nbsp; mg
                                            </span>
                                          </label>
                                          {/*<label><span className="" style={{ marginLeft: '12px', textAlign: 'start' }}>(Range: 1 to 550)</span></label>*/}
                                        </div>
                                        <br />
                                        <div className="option-fbox">
                                          <label
                                            htmlFor={`q26h2_${data.cohortTreatmentName}_kg_${idx}`}
                                          >
                                            <input
                                              type="radio"
                                              id={`q26h2_${data.cohortTreatmentName}_kg_${idx}`}
                                              name={`q26h2_${data.cohortTreatmentName}_kg_${idx}`}
                                              value={1}
                                              checked={
                                                data.doseAdministrationRadiokg ===
                                                1
                                              }
                                              onChange={(e) =>
                                                HandleRepeaterFieldChange(
                                                  e,
                                                  data.cohortTreatmentName,
                                                  null,
                                                  null,
                                                  null,
                                                )
                                              }
                                            />
                                          </label>
                                          <label
                                            htmlFor={`q26h2_${data.cohortTreatmentName}_kgtxt_${idx}`}
                                          >
                                            <span className="radio-text-padding">
                                              <input
                                                className="input-dash-custom"
                                                id={`q26h2_${data.cohortTreatmentName}_kgtxt_${idx}`}
                                                name={`q26h2_${data.cohortTreatmentName}_kgtxt_${idx}`}
                                                type="text"
                                                value={
                                                  data.doseAdministrationkg
                                                }
                                                min={0}
                                                max={4000}
                                                // maxLength={3}
                                                onKeyDown={(e) => {
                                                  // Allow backspace, arrow keys, delete, and tab
                                                  if (
                                                    [
                                                      "Backspace",
                                                      "ArrowLeft",
                                                      "ArrowRight",
                                                      "Delete",
                                                      "Tab",
                                                    ].includes(e.key)
                                                  ) {
                                                    return;
                                                  }
                                                  // Prevent non-numeric characters, except '.' (and only allow one decimal point)
                                                  if (
                                                    !/[0-9.]/.test(e.key) ||
                                                    (e.key === "." &&
                                                      e.target.value.includes(
                                                        ".",
                                                      ))
                                                  ) {
                                                    e.preventDefault();
                                                    return;
                                                  }
                                                  const value = e.target.value;
                                                  const selectionStart =
                                                    e.target.selectionStart;
                                                  const newValue =
                                                    value.slice(
                                                      0,
                                                      selectionStart,
                                                    ) +
                                                    e.key +
                                                    value.slice(
                                                      e.target.selectionEnd,
                                                    );
                                                  // Prevent '.' as the first character
                                                  if (
                                                    e.key === "." &&
                                                    value === ""
                                                  ) {
                                                    e.preventDefault();
                                                    return;
                                                  }
                                                  // Allow only one digit after decimal point
                                                  if (
                                                    newValue.includes(".") &&
                                                    newValue.split(".")[1]
                                                      .length > 2
                                                  ) {
                                                    e.preventDefault();
                                                  }
                                                }}
                                                onChange={(e) =>
                                                  HandleRepeaterFieldChange(
                                                    e,
                                                    data.cohortTreatmentName,
                                                    null,
                                                    null,
                                                    null,
                                                  )
                                                }
                                              />
                                            </span>{" "}
                                            &nbsp; mg/kg
                                          </label>
                                          {/*<label><span className="" style={{ marginLeft: '12px', textAlign: 'start' }}>(Range: 1 to 550)</span></label>*/}
                                        </div>
                                        <br />
                                        <div className="option-fbox">
                                          <label
                                            htmlFor={`q26h3_${data.cohortTreatmentName}_m_${idx}`}
                                          >
                                            <input
                                              type="radio"
                                              id={`q26h3_${data.cohortTreatmentName}_m_${idx}`}
                                              name={`q26h3_${data.cohortTreatmentName}_m_${idx}`}
                                              value={1}
                                              checked={
                                                data.doseAdministrationRadiomgm ===
                                                1
                                              }
                                              onChange={(e) =>
                                                HandleRepeaterFieldChange(
                                                  e,
                                                  data.cohortTreatmentName,
                                                  null,
                                                  null,
                                                  null,
                                                )
                                              }
                                            />
                                          </label>
                                          <label
                                            htmlFor={`q26h3_${data.cohortTreatmentName}_mtxt_${idx}`}
                                          >
                                            <span className="radio-text-padding">
                                              <input
                                                className="input-dash-custom"
                                                id={`q26h3_${data.cohortTreatmentName}_mtxt_${idx}`}
                                                name={`q26h3_${data.cohortTreatmentName}_mtxt_${idx}`}
                                                type="text"
                                                value={
                                                  data.doseAdministrationmgm
                                                }
                                                min={0}
                                                max={4000}
                                                // maxLength={3}
                                                onKeyDown={(e) => {
                                                  // Allow backspace, arrow keys, delete, and tab
                                                  if (
                                                    [
                                                      "Backspace",
                                                      "ArrowLeft",
                                                      "ArrowRight",
                                                      "Delete",
                                                      "Tab",
                                                    ].includes(e.key)
                                                  ) {
                                                    return;
                                                  }
                                                  // Prevent non-numeric characters, except '.' (and only allow one decimal point)
                                                  if (
                                                    !/[0-9.]/.test(e.key) ||
                                                    (e.key === "." &&
                                                      e.target.value.includes(
                                                        ".",
                                                      ))
                                                  ) {
                                                    e.preventDefault();
                                                    return;
                                                  }
                                                  const value = e.target.value;
                                                  const selectionStart =
                                                    e.target.selectionStart;
                                                  const newValue =
                                                    value.slice(
                                                      0,
                                                      selectionStart,
                                                    ) +
                                                    e.key +
                                                    value.slice(
                                                      e.target.selectionEnd,
                                                    );
                                                  // Prevent '.' as the first character
                                                  if (
                                                    e.key === "." &&
                                                    value === ""
                                                  ) {
                                                    e.preventDefault();
                                                    return;
                                                  }
                                                  // Allow only one digit after decimal point
                                                  if (
                                                    newValue.includes(".") &&
                                                    newValue.split(".")[1]
                                                      .length > 2
                                                  ) {
                                                    e.preventDefault();
                                                  }
                                                }}
                                                onChange={(e) =>
                                                  HandleRepeaterFieldChange(
                                                    e,
                                                    data.cohortTreatmentName,
                                                    null,
                                                    null,
                                                    null,
                                                  )
                                                }
                                              />
                                            </span>{" "}
                                            &nbsp; mg/m<sup>2</sup>
                                          </label>
                                          {/*<label><span className="" style={{ marginLeft: '12px', textAlign: 'start' }}>(Range: 1 to 550)</span></label>*/}
                                        </div>
                                        <br />

                                        <div className="">
                                          <div className="option-without-input">
                                            <label className="option-fbox">
                                              <input
                                                type="radio"
                                                id={`q26h4_${data.cohortTreatmentName}_doseUnk_${idx}`}
                                                name={`q26h4_${data.cohortTreatmentName}_doseUnk_${idx}`}
                                                value={99}
                                                checked={
                                                  data.doseAdministrationRadioUnknown ===
                                                  99
                                                }
                                                onChange={(e) =>
                                                  HandleRepeaterFieldChange(
                                                    e,
                                                    data.cohortTreatmentName,
                                                    null,
                                                    null,
                                                    null,
                                                  )
                                                }
                                              />

                                              <span className="radio-text-padding">
                                                Unknown
                                              </span>
                                            </label>
                                          </div>
                                        </div>

                                        <ErrorField
                                          style={{ padding: "0px" }}
                                          show={
                                            bispecificTreatment[idx]
                                              .showColHError &&
                                            bispecificTreatment[idx]
                                              .cohorttreatmentid !=
                                              RRMMCohortTreatment.CARVYKTI &&
                                            bispecificTreatment[idx]
                                              .cohorttreatmentid !=
                                              RRMMCohortTreatment.ABECMA
                                          }
                                          message={
                                            BispecificCartTreatmentCohort_Msgs.q26h
                                          }
                                        />
                                      </td>
                                    ) : (
                                      <td
                                        style={{
                                          border: "1px solid black",
                                          alignContent: "flex-start",

                                          padding: "8px",
                                        }}
                                      >
                                        <div className="option-fbox">
                                          <label
                                            htmlFor={`q26h4_${data.cohortTreatmentName}_cell_${idx}`}
                                          >
                                            <input
                                              type="radio"
                                              id={`q26h4_${data.cohortTreatmentName}_cell_${idx}`}
                                              name={`q26h4_${data.cohortTreatmentName}_cell_${idx}`}
                                              value={1}
                                              checked={
                                                data.doseAdministrationRadiocell ===
                                                1
                                              }
                                              onChange={(e) =>
                                                HandleRepeaterFieldChange(
                                                  e,
                                                  data.cohortTreatmentName,
                                                  null,
                                                  null,
                                                  null,
                                                )
                                              }
                                            />
                                          </label>
                                          <label
                                            htmlFor={`q26h4_${data.cohortTreatmentName}_celltxt_${idx}`}
                                          >
                                            <span className="radio-text-padding">
                                              <input
                                                className="input-dash-custom"
                                                id={`q26h4_${data.cohortTreatmentName}_celltxt_${idx}`}
                                                name={`q26h4_${data.cohortTreatmentName}_celltxt_${idx}`}
                                                type="text"
                                                value={
                                                  data.doseAdministrationcell
                                                }
                                                min={0}
                                                max={4000}
                                                // maxLength={3}
                                                onKeyDown={(e) => {
                                                  // Allow backspace, arrow keys, delete, and tab
                                                  if (
                                                    [
                                                      "Backspace",
                                                      "ArrowLeft",
                                                      "ArrowRight",
                                                      "Delete",
                                                      "Tab",
                                                    ].includes(e.key)
                                                  ) {
                                                    return;
                                                  }
                                                  // Prevent non-numeric characters, except '.' (and only allow one decimal point)
                                                  if (
                                                    !/[0-9.]/.test(e.key) ||
                                                    (e.key === "." &&
                                                      e.target.value.includes(
                                                        ".",
                                                      ))
                                                  ) {
                                                    e.preventDefault();
                                                    return;
                                                  }
                                                  const value = e.target.value;
                                                  const selectionStart =
                                                    e.target.selectionStart;
                                                  const newValue =
                                                    value.slice(
                                                      0,
                                                      selectionStart,
                                                    ) +
                                                    e.key +
                                                    value.slice(
                                                      e.target.selectionEnd,
                                                    );
                                                  // Prevent '.' as the first character
                                                  if (
                                                    e.key === "." &&
                                                    value === ""
                                                  ) {
                                                    e.preventDefault();
                                                    return;
                                                  }
                                                  // Allow only one digit after decimal point
                                                  if (
                                                    newValue.includes(".") &&
                                                    newValue.split(".")[1]
                                                      .length > 2
                                                  ) {
                                                    e.preventDefault();
                                                  }
                                                }}
                                                onChange={(e) =>
                                                  HandleRepeaterFieldChange(
                                                    e,
                                                    data.cohortTreatmentName,
                                                    null,
                                                    null,
                                                    null,
                                                  )
                                                }
                                              />
                                            </span>{" "}
                                            &nbsp; x 10<sup>6</sup>&nbsp;cells
                                            {bispecificTreatment[idx]
                                              .cohorttreatmentid ==
                                              RRMMCohortTreatment.CARVYKTI && (
                                              <>/kg</>
                                            )}
                                          </label>
                                          {/*<label><span className="" style={{ marginLeft: '12px', textAlign: 'start' }}>(Range: 1 to 550)</span></label>*/}
                                        </div>
                                        <br />
                                        <div className="">
                                          <div className="option-without-input">
                                            <label className="option-fbox">
                                              <input
                                                type="radio"
                                                id={`q26h4_${data.cohortTreatmentName}_doseUnk_${idx}`}
                                                name={`q26h4_${data.cohortTreatmentName}_doseUnk_${idx}`}
                                                value={99}
                                                checked={
                                                  data.doseAdministrationRadioUnknown ===
                                                  99
                                                }
                                                onChange={(e) =>
                                                  HandleRepeaterFieldChange(
                                                    e,
                                                    data.cohortTreatmentName,
                                                    null,
                                                    null,
                                                    null,
                                                  )
                                                }
                                              />

                                              <span className="radio-text-padding">
                                                Unknown
                                              </span>
                                            </label>
                                          </div>
                                        </div>

                                        <ErrorField
                                          style={{ padding: "0px" }}
                                          show={
                                            bispecificTreatment[idx]
                                              .showColHError &&
                                            (bispecificTreatment[idx]
                                              .cohorttreatmentid ==
                                              RRMMCohortTreatment.CARVYKTI ||
                                              bispecificTreatment[idx]
                                                .cohorttreatmentid ==
                                                RRMMCohortTreatment.ABECMA)
                                          }
                                          message={
                                            BispecificCartTreatmentCohort_Msgs.q26h
                                          }
                                        />
                                      </td>
                                    )}

                                    {bispecificTreatment[idx]
                                      .cohorttreatmentid !=
                                      RRMMCohortTreatment.CARVYKTI &&
                                    bispecificTreatment[idx]
                                      .cohorttreatmentid !=
                                      RRMMCohortTreatment.ABECMA ? (
                                      <td
                                        style={{
                                          border: "1px solid black",
                                          alignContent: "flex-start",
                                          padding: "8px",
                                        }}
                                      >
                                        <div className="">
                                          <div
                                            className="option-without-input"
                                            style={{
                                              display: "flex",
                                              alignItems: "flex-start",
                                            }}
                                          >
                                            <input
                                              type="radio"
                                              id={`q26f_${data.cohortTreatmentName}_PdaYes_${idx}`}
                                              name={`q26f_${data.cohortTreatmentName}_PdaYes_${idx}`}
                                              value={1}
                                              checked={
                                                data.discontinueAgent === 1
                                              }
                                              onChange={(e) =>
                                                HandleRepeaterFieldChange(
                                                  e,
                                                  data.cohortTreatmentName,
                                                  null,
                                                  null,
                                                  null,
                                                )
                                              }
                                              style={{ marginTop: "6px" }}
                                            />
                                            <label
                                              htmlFor={`q26f_${data.cohortTreatmentName}_PdaYes_${idx}`}
                                              style={{ textAlign: "start" }}
                                            >
                                              <span className="radio-text-padding">
                                                Yes, agent discontinued
                                              </span>
                                            </label>
                                          </div>
                                        </div>
                                        {data.lOT === highestLot && (
                                          <div className="">
                                            <div
                                              className="option-without-input"
                                              style={{
                                                display: "flex",
                                                alignItems: "flex-start",
                                              }}
                                            >
                                              <input
                                                type="radio"
                                                id={`q26f_${data.cohortTreatmentName}_PdaNo_${idx}`}
                                                name={`q26f_${data.cohortTreatmentName}_PdaNo_${idx}`}
                                                value={2}
                                                checked={
                                                  data.discontinueAgent === 2
                                                }
                                                onChange={(e) =>
                                                  HandleRepeaterFieldChange(
                                                    e,
                                                    data.cohortTreatmentName,
                                                    null,
                                                    null,
                                                    null,
                                                  )
                                                }
                                                style={{ marginTop: "6px" }}
                                              />
                                              <label
                                                htmlFor={`q26f_${data.cohortTreatmentName}_PdaNo_${idx}`}
                                                style={{ textAlign: "start" }}
                                              >
                                                <span className="radio-text-padding">
                                                  No, medication ongoing at time
                                                  of last encounter
                                                </span>
                                              </label>
                                            </div>
                                          </div>
                                        )}

                                        <div className="">
                                          <div className="option-without-input">
                                            <input
                                              type="radio"
                                              id={`q26f_${data.cohortTreatmentName}_PdaUnk_${idx}`}
                                              name={`q26f_${data.cohortTreatmentName}_PdaUnk_${idx}`}
                                              value={99}
                                              checked={
                                                data.discontinueAgent === 99
                                              }
                                              onChange={(e) =>
                                                HandleRepeaterFieldChange(
                                                  e,
                                                  data.cohortTreatmentName,
                                                  null,
                                                  null,
                                                  null,
                                                )
                                              }
                                            />
                                            <label
                                              htmlFor={`q26f_${data.cohortTreatmentName}_PdaUnk_${idx}`}
                                            >
                                              <span className="radio-text-padding">
                                                Unknown
                                              </span>
                                            </label>
                                          </div>
                                        </div>

                                        <ErrorField
                                          style={{ padding: "0px" }}
                                          show={
                                            bispecificTreatment[idx]
                                              .showColFError
                                          }
                                          message={
                                            BispecificCartTreatmentCohort_Msgs.q26f
                                          }
                                        />
                                      </td>
                                    ) : (
                                      <td
                                        style={{
                                          border: "1px solid black",
                                          alignContent: "flex-start",
                                          textAlign: "center",
                                          padding: "8px",
                                          textAlign: "start",
                                        }}
                                      >
                                        <span
                                          style={{ textAlign: "center" }}
                                          className="not-applicable"
                                        >
                                          <b>Not applicable</b>
                                        </span>
                                      </td>
                                    )}

                                    {bispecificTreatment[idx].showColG &&
                                    bispecificTreatment[idx]
                                      .cohorttreatmentid !=
                                      RRMMCohortTreatment.CARVYKTI &&
                                    bispecificTreatment[idx]
                                      .cohorttreatmentid !=
                                      RRMMCohortTreatment.ABECMA ? (
                                      <td
                                        style={{
                                          border: "1px solid black",
                                          alignContent: "flex-start",
                                          textAlign: "center",
                                          padding: "8px",
                                          textAlign: "start",
                                        }}
                                      >
                                        <div className="">
                                          {data.reasonForDiscontinuingMedications?.map(
                                            (item, itemidx) => (
                                              <div className="" key={itemidx}>
                                                <div
                                                  className=""
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <input
                                                    type="checkbox"
                                                    key={item.reasonid}
                                                    id={`discont_${idx}_${data.cohortTreatmentName}_${item.reasonName + item.supscripttext}_${itemidx}`}
                                                    name={`discont_${idx}_${data.cohortTreatmentName}_${item.reasonName + item.supscripttext}_${itemidx}`}
                                                    style={{ marginTop: "6px" }}
                                                    checked={item.isSelected}
                                                    onChange={(e) =>
                                                      HandleRepeaterFieldChange(
                                                        e,
                                                        data.cohortTreatmentName,
                                                        item.reasonName +
                                                          item.supscripttext,
                                                        idx,
                                                        itemidx,
                                                      )
                                                    }
                                                  />
                                                  <label
                                                    htmlFor={`discont_${idx}_${data.cohortTreatmentName}_${item.reasonName + item.supscripttext}_${itemidx}`}
                                                  >
                                                    <span className="radio-text-padding">
                                                      {item.reasonName}
                                                      {item.supscripttext ===
                                                      null ? (
                                                        ""
                                                      ) : (
                                                        <>
                                                          <sup className="supscript">
                                                            {item.supscripttext.slice(
                                                              0,
                                                              2,
                                                            )}
                                                          </sup>
                                                          {item.supscripttext.slice(
                                                            2,
                                                          )}
                                                        </>
                                                      )}
                                                    </span>
                                                  </label>
                                                </div>
                                                {/* AE */}
                                                {item.reasonName ===
                                                  DiscontinuationReason.AdverseEvent &&
                                                  item.isSelected &&
                                                  isNewEcrfA && (
                                                    <div
                                                      style={{
                                                        marginLeft: "24px",
                                                        marginTop: "6px",
                                                      }}
                                                    >
                                                      {data
                                                        .adverseEventsDiscontinuationreason
                                                        ?.length > 0 &&
                                                        data.adverseEventsDiscontinuationreason?.map(
                                                          (ae, aeIdx) => {
                                                            const isAEUnknown =
                                                              ae.reasonName ===
                                                              "AE type unknown";

                                                            return (
                                                              <div key={aeIdx}>
                                                                <label
                                                                  className="d-flex align-items-start"
                                                                  htmlFor={`adverse_${ae.reasonName}_${idx}_${itemidx}_${aeIdx}`}
                                                                >
                                                                  <input
                                                                    type={
                                                                      isAEUnknown
                                                                        ? "radio"
                                                                        : "checkbox"
                                                                    }
                                                                    id={`adverse_${ae.reasonName}_${idx}_${itemidx}_${aeIdx}`}
                                                                    name={`adverse_${ae.reasonName}_${idx}_${itemidx}_${aeIdx}`}
                                                                    checked={
                                                                      ae.isSelected
                                                                    }
                                                                    onChange={(
                                                                      e,
                                                                    ) =>
                                                                      HandleRepeaterFieldChange(
                                                                        e,
                                                                        ae.reasonName,
                                                                        "Adverse Events",
                                                                        idx, // ✅ always correct
                                                                        itemidx,
                                                                        aeIdx,
                                                                        null,
                                                                      )
                                                                    }
                                                                    style={{
                                                                      marginTop:
                                                                        "6px",
                                                                    }}
                                                                  />

                                                                  <span
                                                                    style={{
                                                                      textAlign:
                                                                        "left",
                                                                    }}
                                                                    className="radio-text-padding"
                                                                  >
                                                                    {
                                                                      ae.reasonName
                                                                    }
                                                                  </span>
                                                                </label>
                                                                {ae.reasonName ===
                                                                  DiscontinuationReason.NeurologicalEvent &&
                                                                  ae.isSelected &&
                                                                  isNewEcrfA && (
                                                                    <div
                                                                      style={{
                                                                        marginLeft:
                                                                          "28px",
                                                                        marginTop:
                                                                          "8px",
                                                                      }}
                                                                    >
                                                                      {data
                                                                        .adverseNeurologicalEventsDiscontinuationreason
                                                                        ?.length >
                                                                        0 &&
                                                                        data.adverseNeurologicalEventsDiscontinuationreason.map(
                                                                          (
                                                                            aeNeuro,
                                                                            aeNeuroIdx,
                                                                          ) => {
                                                                            return (
                                                                              <div
                                                                                key={
                                                                                  aeIdx
                                                                                }
                                                                              >
                                                                                <label
                                                                                  className="d-flex align-items-start"
                                                                                  htmlFor={`adverse_${data.agentName}_${itemidx}_${aeIdx}_${aeNeuroIdx}`}
                                                                                >
                                                                                  <input
                                                                                    type="checkbox"
                                                                                    id={`adverse_${data.agentName}_${itemidx}_${aeIdx}_${aeNeuroIdx}`}
                                                                                    name={`adverse_${data.agentName}_${itemidx}_${aeIdx}_${aeNeuroIdx}`}
                                                                                    checked={
                                                                                      aeNeuro.isSelected
                                                                                    }
                                                                                    onChange={(
                                                                                      e,
                                                                                    ) =>
                                                                                      HandleRepeaterFieldChange(
                                                                                        e,
                                                                                        data.agentName,
                                                                                        "Adverse Events",
                                                                                        idx,
                                                                                        itemidx,
                                                                                        aeIdx,
                                                                                        aeNeuroIdx,
                                                                                      )
                                                                                    }
                                                                                    style={{
                                                                                      marginTop:
                                                                                        "6px",
                                                                                    }}
                                                                                  />

                                                                                  <span
                                                                                    style={{
                                                                                      textAlign:
                                                                                        "left",
                                                                                    }}
                                                                                    className="radio-text-padding"
                                                                                  >
                                                                                    {
                                                                                      aeNeuro.reasonName
                                                                                    }
                                                                                  </span>
                                                                                </label>

                                                                                {aeNeuro.reasonName.includes(
                                                                                  "Other",
                                                                                ) && (
                                                                                  <label
                                                                                    htmlFor={`discont_${data.agentName}_${aeNeuro.reasonName}txt_${itemidx}_${aeNeuroIdx}`}
                                                                                  >
                                                                                    <span
                                                                                      style={{
                                                                                        paddingLeft:
                                                                                          "28px",
                                                                                      }}
                                                                                      className="radio-text-padding"
                                                                                    >
                                                                                      <textarea
                                                                                        style={{
                                                                                          width:
                                                                                            "264px",
                                                                                        }}
                                                                                        //className="input-dash"
                                                                                        id={`discont_${data.agentName}_${aeNeuro.reasonName}txt_${itemidx}_${aeNeuroIdx}`}
                                                                                        name={`discont_${data.agentName}_${aeNeuro.reasonName}txt_${itemidx}_${aeNeuroIdx}`}
                                                                                        type="text"
                                                                                        value={
                                                                                          aeNeuro.reasonText
                                                                                        }
                                                                                        onChange={(
                                                                                          e,
                                                                                        ) =>
                                                                                          HandleRepeaterFieldChange(
                                                                                            e,
                                                                                            data.agentName,
                                                                                            aeNeuro.reasonName,
                                                                                            idx,
                                                                                            itemidx,
                                                                                            aeIdx,
                                                                                            aeNeuroIdx,
                                                                                          )
                                                                                        }
                                                                                        maxLength={
                                                                                          300
                                                                                        }
                                                                                      />
                                                                                    </span>
                                                                                  </label>
                                                                                )}
                                                                              </div>
                                                                            );
                                                                          },
                                                                        )}
                                                                    </div>
                                                                  )}
                                                              </div>
                                                            );
                                                          },
                                                        )}
                                                    </div>
                                                  )}

                                                {item.reasonName.includes(
                                                  "Other",
                                                ) && (
                                                  <label
                                                    htmlFor={`discont_${data.cohortTreatmentName}_${item.reasonName}txt_${itemidx}`}
                                                  >
                                                    <span className="radio-text-padding">
                                                      <textarea
                                                        style={{
                                                          width: "264px",
                                                        }}
                                                        //className="input-dash"
                                                        id={`discont_${data.cohortTreatmentName}_${item.reasonName}txt_${itemidx}`}
                                                        name={`discont_${data.cohortTreatmentName}_${item.reasonName}txt_${itemidx}`}
                                                        type="text"
                                                        value={item.reasonText}
                                                        onChange={(e) =>
                                                          HandleRepeaterFieldChange(
                                                            e,
                                                            data.cohortTreatmentName,
                                                            item.reasonName +
                                                              item.supscripttext,
                                                            idx,
                                                            itemidx,
                                                          )
                                                        }
                                                        maxLength={300}
                                                      />
                                                    </span>
                                                  </label>
                                                )}
                                              </div>
                                            ),
                                          )}
                                          <div className="">
                                            <input
                                              type="radio"
                                              id={`discont_unk_${data.cohortTreatmentName}_${idx}`}
                                              name={`discont_unk_${data.cohortTreatmentName}_${idx}`}
                                              value={1}
                                              checked={
                                                data
                                                  .reasonForDiscontinuingMedications?.[0]
                                                  ?.reasonUnk
                                                  ? 1
                                                  : ""
                                              }
                                              onChange={(e) =>
                                                HandleRepeaterFieldChange(
                                                  e,
                                                  data.cohortTreatmentName,
                                                  null,
                                                  idx,
                                                  null,
                                                )
                                              }
                                            />
                                            <label
                                              htmlFor={`discont_unk_${data.cohortTreatmentName}_${idx}`}
                                            >
                                              <span className="radio-text-padding">
                                                Unknown
                                              </span>
                                            </label>
                                          </div>
                                        </div>
                                        <ErrorField
                                          style={{ padding: "0px" }}
                                          show={
                                            bispecificTreatment[idx]
                                              .showColGError
                                          }
                                          message={
                                            BispecificCartTreatmentCohort_Msgs.q26g
                                          }
                                        />
                                        <ErrorField
                                          style={{ padding: "0px" }}
                                          show={
                                            bispecificTreatment[idx]
                                              .showColGUnknownError
                                          }
                                          message={
                                            BispecificCartTreatmentCohort_Msgs.q26g_unk
                                          }
                                          html
                                        />
                                        <ErrorField
                                          style={{ padding: "0px" }}
                                          show={
                                            bispecificTreatment[idx]
                                              .showColGOthError
                                          }
                                          message={
                                            BispecificCartTreatmentCohort_Msgs.q26ga
                                          }
                                        />

                                        <ErrorField
                                          style={{ padding: "0px" }}
                                          show={
                                            data.showAdverseEventError == true
                                          }
                                          message={
                                            BispecificCartTreatmentCohort_Msgs.q26ae
                                          }
                                        />
                                        <ErrorField
                                          style={{ padding: "0px" }}
                                          show={
                                            data.showAdverseNeuroEventError ==
                                            true
                                          }
                                          message={
                                            BispecificCartTreatmentCohort_Msgs.q26aeNeuro
                                          }
                                        />
                                        <ErrorField
                                          style={{ padding: "0px" }}
                                          show={
                                            data.showAdverseNeuroEventOtherTextError ==
                                            true
                                          }
                                          message={
                                            BispecificCartTreatmentCohort_Msgs.q26aeNeuroOther
                                          }
                                        />
                                        <ErrorField
                                          style={{ padding: "0px" }}
                                          show={
                                            data.discontinuationSoftError ==
                                            true
                                          }
                                          message={
                                            "WARNING: you have indicated that at least 1 reason for treatment discontinuation was death however no date of death is reported in Q20. Please revise the reason for medication discontinuation to a reason besides death or otherwise add a date of death in Q20."
                                          }
                                        />
                                      </td>
                                    ) : (
                                      <td
                                        style={{
                                          border: "1px solid black",
                                          alignContent: "flex-start",
                                          textAlign: "center",
                                          padding: "8px",
                                          //textAlign: 'start'
                                        }}
                                      >
                                        <span
                                          style={{ textAlign: "center" }}
                                          className="not-applicable"
                                        >
                                          <b>Not applicable</b>
                                        </span>
                                      </td>
                                    )}
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Q26.1 */}
                {bispecificAgent?.length > 0 && isNewEcrfA && (
                  <div className="survey-question-content calender-datefix-survey">
                    <div className="question-answer">
                      {/* Q26 */}
                      <div className="question-bot-sapce">
                        <div className="question question-weight">
                          <span>Q26.1.</span>
                          <span className="quest-text-pad">
                            Please describe the prescribed dosing information
                            for each additional agent used in combination with a
                            Bispecific/CAR-T treatment. Like above, please note
                            the following:{" "}
                          </span>
                        </div>{" "}
                        <div className="question question-weight">
                          <div className="quest-text-pad">
                            <p>
                              <b>
                                (a) Date of first administration of each agent
                                must be no later than the date of last
                                administration of the same agent.
                              </b>
                            </p>

                            <p>
                              <b>
                                (b) None of the dates of first administration or
                                last administration should be later than the end
                                of follow up on{" "}
                                <span
                                  style={{
                                    color: PageDesignConstants.fontColor,
                                  }}
                                >
                                  {endFollowUpDate
                                    ? endFollowUpDate
                                    : "[end of follow up]"}
                                </span>
                                .
                              </b>
                            </p>

                            <p>
                              <b>
                                (c) None of the dates of first administration
                                should be before the index date on{" "}
                                {bispecificTreatment &&
                                bispecificTreatment.length > 0 ? (
                                  bispecificTreatment.map((cohortRow, cIdx) => (
                                    <React.Fragment key={cIdx}>
                                      {cIdx > 0 && ", "}
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                        }}
                                      >
                                        {cohortRow.cohortTreatmentName}
                                        {cohortRow.supscripttext == null ? (
                                          ""
                                        ) : (
                                          <>
                                            <sup className="supscript">
                                              {cohortRow.supscripttext.slice(
                                                0,
                                                2,
                                              )}
                                            </sup>
                                            {cohortRow.supscripttext.slice(2)}
                                          </>
                                        )}
                                        {" ["}
                                        {cohortRow.earliestCohortIndexDate
                                          ? cohortRow.earliestCohortIndexDate
                                          : "Bispecific/CAR-T index date"}
                                        {"]"}
                                      </span>
                                    </React.Fragment>
                                  ))
                                ) : (
                                  <span
                                    style={{
                                      color: PageDesignConstants.fontColor,
                                    }}
                                  >
                                    [Bispecific/CAR-T index date]
                                  </span>
                                )}
                                .
                              </b>
                            </p>

                            <p>
                              <b>
                                (d) If the LOT is ongoing at the time of chart
                                abstraction/refreshing, enter the date of the
                                last known administration received by the
                                patient.
                              </b>
                            </p>

                            <p>
                              <b>
                                (e) If a medication agent’s discontinuation
                                status is “No, medication ongoing at time of
                                last encounter” below, please enter the “Date of
                                the last administration” as the last known
                                administration date on or prior to the patient’s
                                last encounter date on{" "}
                                <span
                                  style={{
                                    color: PageDesignConstants.fontColor,
                                  }}
                                >
                                  {lastEncounterDate
                                    ? lastEncounterDate
                                    : "[date of last encounter]"}
                                </span>
                                .
                              </b>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="question-answer">
                      <div className="question-bot-sapce">
                        <div className=" double-dig-answer">
                          <div className="" style={{ overflowX: "auto" }}>
                            {bispecificAgent?.length > 0 &&
                              bispecificAgent.map((mainData, idx) => (
                                <div key={idx} style={{ marginBottom: "20px" }}>
                                  <CollapsibleSectionHeader
                                    title={
                                      <>
                                        {mainData.lineOfTherapy > 0 &&
                                          `${mainData.lineOfTherapy}L – `}
                                        {mainData.cohortTreatmentName}
                                        {mainData.cohortTreatmentNameSuperscript && (
                                          <sup className="superscript">
                                            {mainData.cohortTreatmentNameSuperscript.slice(
                                              0,
                                              2,
                                            )}
                                          </sup>
                                        )}
                                        {mainData.cohortTreatmentNameSuperscript &&
                                          mainData.cohortTreatmentNameSuperscript.slice(
                                            2,
                                          )}
                                      </>
                                    }
                                    isExpanded={!isCohortCollapsed(idx)}
                                    onToggle={() => toggleCohortCollapse(idx)}
                                    hasError={
                                      !!treatmentErrors[idx] ||
                                      mainData?.agentLists?.some(
                                        (agent) =>
                                          agent.agentDateError ||
                                          agent.agentDateRangeError ||
                                          agent.agentSortedDateError ||
                                          agent.showFirstSiteCareError ||
                                          agent.showSecondDateError ||
                                          agent.showSecondDateRangeError ||
                                          agent.showSecondSiteCareError ||
                                          agent.showColBError ||
                                          agent.showColDError ||
                                          agent.showColEError ||
                                          agent.showColEUkTxtError ||
                                          agent.showColFError ||
                                          agent.showColGError ||
                                          agent.showColGOthError ||
                                          agent.showColHError ||
                                          agent.showAdverseEventError ||
                                          agent.showAdverseNeuroEventError ||
                                          agent.discontinuationSoftError ||
                                          agent.lastAdministrationSoftError ||
                                          agent.q261ChainErr,
                                      )
                                    }
                                  />
                                  <Collapse in={!isCohortCollapsed(idx)}>
                                    {/* Cohort Name */}
                                    <div>
                                      <table
                                        style={{
                                          border: "1px solid black",
                                          borderCollapse: "collapse",
                                          width: "100%",
                                        }}
                                      >
                                        <thead>
                                          <tr>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Medication
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                                minWidth: "135px",
                                              }}
                                            >
                                              <span
                                                data-tooltip-id="encounterTip"
                                                className="modal-popup"
                                                onClick={() =>
                                                  setShowHideHyperlinkModal(
                                                    true,
                                                  )
                                                }
                                              >
                                                Line Of Therapy
                                              </span>
                                              {showHideHyperlinkModal && (
                                                <InfoPopUp
                                                  description={
                                                    hyperlinkTextLineOfTherapy
                                                  }
                                                  OkClick={() =>
                                                    setShowHideHyperlinkModal(
                                                      false,
                                                    )
                                                  }
                                                />
                                              )}
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Date of first administration
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Date of second administration
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Date of last or most recent
                                              administration
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                                minWidth: "195px",
                                              }}
                                            >
                                              Number of administrations
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                                minWidth: "305px",
                                              }}
                                            >
                                              Dose at first administration
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                                minWidth: "250px",
                                              }}
                                            >
                                              Did patient discontinue agent?
                                            </th>
                                            <th
                                              style={{
                                                border: "1px solid black",
                                                padding: "8px",
                                                textAlign: "center",
                                                minWidth: "300px",
                                              }}
                                            >
                                              Reason for discontinuing
                                            </th>
                                          </tr>
                                        </thead>

                                        <tbody>
                                          {mainData?.agentLists?.length > 0 ? (
                                            mainData.agentLists.map(
                                              (data, agentIdx) => (
                                                <tr key={agentIdx}>
                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    {data.agentName}
                                                  </td>

                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    {data.lot}
                                                  </td>

                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    <div>
                                                      {data.cohortIndexDate}
                                                    </div>
                                                    <ErrorField
                                                      style={{ padding: "0px" }}
                                                      show={
                                                        data.q261ChainErr &&
                                                        !!data.q261ChainErrMsg &&
                                                        (data.q261ChainErrMsg.includes(
                                                          "cannot be after the Bispecifics/CAR-T agent initiation date.",
                                                        ) ||
                                                          (data.q261ChainErrMsg ===
                                                            BispecificCartTreatmentCohort_Msgs.q26_lotDateRangeError &&
                                                            data.q261ChainErrField ===
                                                              "initiation"))
                                                      }
                                                      message={
                                                        data.q261ChainErrMsg
                                                      }
                                                    />
                                                    {isNewEcrfC &&
                                                      (data.agentName ===
                                                        "Daratumumab (Darzalex)" ||
                                                        data.agentName ===
                                                          "Daratumumab (Darzalex Faspro)") && (
                                                        <div
                                                          className=""
                                                          style={{
                                                            marginTop: "16px",
                                                            padding: "0px",
                                                            textAlign: "left",
                                                          }}
                                                        >
                                                          <div
                                                            style={{
                                                              padding: "0px",
                                                            }}
                                                          >
                                                            <span
                                                              className="radio-text-padding"
                                                              style={{
                                                                fontWeight: 600,
                                                                padding: "0px",
                                                              }}
                                                            >
                                                              Site of care for
                                                              first daratumumab
                                                              administration
                                                            </span>
                                                          </div>
                                                          <div
                                                            className="option-without-input"
                                                            style={{
                                                              display: "flex",
                                                              alignItems:
                                                                "flex-start",
                                                              paddingLeft:
                                                                "6px",
                                                              marginTop: "4px",
                                                            }}
                                                          >
                                                            <input
                                                              type="radio"
                                                              id={`q26_one_${data.agentName}_FirstSiteCare_${idx}`}
                                                              name={`q26_one_${data.agentName}_FirstSiteCare_${idx}`}
                                                              value={1}
                                                              checked={
                                                                data.firstSiteCareC ===
                                                                1
                                                              }
                                                              onChange={(e) =>
                                                                HandleQ26OneRepeaterFieldChange(
                                                                  e,
                                                                  data.agentName,
                                                                  null,
                                                                  idx,
                                                                  null,
                                                                )
                                                              }
                                                            />
                                                            <label
                                                              htmlFor={`q26_one_${data.agentName}_FirstSiteCare_${idx}`}
                                                            >
                                                              <span className="radio-text-padding">
                                                                Inpatient
                                                              </span>
                                                            </label>
                                                          </div>
                                                          <div
                                                            className="option-without-input"
                                                            style={{
                                                              display: "flex",
                                                              alignItems:
                                                                "flex-start",
                                                              paddingLeft:
                                                                "6px",
                                                            }}
                                                          >
                                                            <input
                                                              type="radio"
                                                              id={`q26_one_${data.agentName}_FirstSiteCare_${idx}_out`}
                                                              name={`q26_one_${data.agentName}_FirstSiteCare_${idx}`}
                                                              value={2}
                                                              checked={
                                                                data.firstSiteCareC ===
                                                                2
                                                              }
                                                              onChange={(e) =>
                                                                HandleQ26OneRepeaterFieldChange(
                                                                  e,
                                                                  data.agentName,
                                                                  null,
                                                                  idx,
                                                                  null,
                                                                )
                                                              }
                                                            />
                                                            <label
                                                              htmlFor={`q26_one_${data.agentName}_FirstSiteCare_${idx}_out`}
                                                            >
                                                              <span className="radio-text-padding">
                                                                Outpatient
                                                              </span>
                                                            </label>
                                                          </div>
                                                          <div
                                                            className="option-without-input"
                                                            style={{
                                                              display: "flex",
                                                              alignItems:
                                                                "flex-start",
                                                              paddingLeft:
                                                                "6px",
                                                            }}
                                                          >
                                                            <input
                                                              type="radio"
                                                              id={`q26_one_${data.agentName}_FirstSiteCare_${idx}_unk`}
                                                              name={`q26_one_${data.agentName}_FirstSiteCare_${idx}`}
                                                              value={99}
                                                              checked={
                                                                data.firstSiteCareC ===
                                                                99
                                                              }
                                                              onChange={(e) =>
                                                                HandleQ26OneRepeaterFieldChange(
                                                                  e,
                                                                  data.agentName,
                                                                  null,
                                                                  idx,
                                                                  null,
                                                                )
                                                              }
                                                            />
                                                            <label
                                                              htmlFor={`q26_one_${data.agentName}_FirstSiteCare_${idx}_unk`}
                                                            >
                                                              <span className="radio-text-padding">
                                                                Unknown
                                                              </span>
                                                            </label>
                                                          </div>
                                                          <ErrorField
                                                            style={{
                                                              padding: "0px",
                                                            }}
                                                            show={
                                                              data.showFirstSiteCareError
                                                            }
                                                            message={
                                                              BispecificCartTreatmentCohort_Msgs.q26f
                                                            }
                                                          />
                                                        </div>
                                                      )}
                                                  </td>

                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    {isNewEcrfC &&
                                                    (data.agentName ===
                                                      "Daratumumab (Darzalex)" ||
                                                      data.agentName ===
                                                        "Daratumumab (Darzalex Faspro)") ? (
                                                      <>
                                                        <div
                                                          className="option-without-input"
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "flex-start",
                                                            marginBottom: "6px",
                                                          }}
                                                        >
                                                          <input
                                                            type="radio"
                                                            id={`q26_one_${data.agentName}_SecondNotReceived_${idx}`}
                                                            name={`q26_one_${data.agentName}_SecondNotReceived_${idx}`}
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            value={1}
                                                            checked={
                                                              data.secondNotReceived ===
                                                              1
                                                            }
                                                            onChange={(e) =>
                                                              HandleQ26OneRepeaterFieldChange(
                                                                e,
                                                                data.agentName,
                                                                null,
                                                                idx,
                                                                null,
                                                              )
                                                            }
                                                          />
                                                          <label
                                                            htmlFor={`q26_one_${data.agentName}_SecondNotReceived_${idx}`}
                                                            style={{
                                                              textAlign:
                                                                "start",
                                                            }}
                                                          >
                                                            <span className="radio-text-padding">
                                                              A second
                                                              administration of
                                                              daratumumab was
                                                              not received
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <div
                                                          className="option-without-input"
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "flex-start",
                                                          }}
                                                        >
                                                          <input
                                                            type="radio"
                                                            id={`q26_one_second_admin_date_radio_${data.agentName}_${idx}`}
                                                            name={`q26_one_second_admin_date_radio_${data.agentName}_${idx}`}
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            value={1}
                                                            checked={
                                                              data.secondDateRadio ===
                                                              1
                                                            }
                                                            onChange={(e) =>
                                                              HandleQ26OneRepeaterFieldChange(
                                                                e,
                                                                data.agentName,
                                                                null,
                                                                idx,
                                                                null,
                                                              )
                                                            }
                                                          />
                                                          <span
                                                            className="radio-text-padding datepicker-dependence calender-datefix"
                                                            style={{
                                                              paddingLeft:
                                                                "5px",
                                                            }}
                                                          >
                                                            <DatePickerComponent
                                                              ctrlId={`q26_one_second_admin_date_${idx}`}
                                                              HandleDateChange={(
                                                                name,
                                                                value,
                                                              ) => {
                                                                HandleQ26OneDateChange(
                                                                  name,
                                                                  value,
                                                                  data.agentName,
                                                                );
                                                              }}
                                                              minDate={dayjs(
                                                                "01-01-1920",
                                                              )}
                                                              maxDate={dayjs()}
                                                              locale="en"
                                                              date={
                                                                data.secondDate
                                                              }
                                                            />
                                                          </span>
                                                        </div>
                                                        <ErrorField
                                                          style={{
                                                            padding: "0px",
                                                          }}
                                                          show={
                                                            data.showSecondDateRangeError
                                                          }
                                                          message={
                                                            BispecificCartTreatmentCohort_Msgs.q26_secondDateRange
                                                          }
                                                        />
                                                        <div
                                                          className="option-without-input"
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "flex-start",
                                                          }}
                                                        >
                                                          <input
                                                            type="radio"
                                                            id={`q26_one_${data.agentName}_SecondDateUnk_${idx}`}
                                                            name={`q26_one_${data.agentName}_SecondDateUnk_${idx}`}
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            value={1}
                                                            checked={
                                                              data.secondDateUnk ===
                                                              1
                                                            }
                                                            onChange={(e) =>
                                                              HandleQ26OneRepeaterFieldChange(
                                                                e,
                                                                data.agentName,
                                                                null,
                                                                idx,
                                                                null,
                                                              )
                                                            }
                                                          />
                                                          <label
                                                            htmlFor={`q26_one_${data.agentName}_SecondDateUnk_${idx}`}
                                                            style={{
                                                              textAlign:
                                                                "start",
                                                            }}
                                                          >
                                                            <span className="radio-text-padding">
                                                              Date of second
                                                              administration
                                                              unknown
                                                            </span>
                                                          </label>
                                                        </div>
                                                        <ErrorField
                                                          style={{
                                                            padding: "0px",
                                                          }}
                                                          show={
                                                            data.showSecondDateError
                                                          }
                                                          message={
                                                            BispecificCartTreatmentCohort_Msgs.q26_secondDate
                                                          }
                                                        />
                                                        {data.secondNotReceived !==
                                                          1 && (
                                                          <div
                                                            style={{
                                                              marginTop: "16px",
                                                              padding: "0px",
                                                              textAlign: "left",
                                                            }}
                                                          >
                                                            <div
                                                              style={{
                                                                padding: "0px",
                                                              }}
                                                            >
                                                              <span
                                                                className="radio-text-padding"
                                                                style={{
                                                                  fontWeight: 600,
                                                                  padding:
                                                                    "0px",
                                                                }}
                                                              >
                                                                Site of care for
                                                                second
                                                                daratumumab
                                                                administration
                                                              </span>
                                                            </div>
                                                            <div
                                                              className="option-without-input"
                                                              style={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "flex-start",
                                                                paddingLeft:
                                                                  "6px",
                                                                marginTop:
                                                                  "4px",
                                                              }}
                                                            >
                                                              <input
                                                                type="radio"
                                                                id={`q26_one_${data.agentName}_SecondSiteCare_${idx}`}
                                                                name={`q26_one_${data.agentName}_SecondSiteCare_${idx}`}
                                                                value={1}
                                                                checked={
                                                                  data.secondSiteCareC ===
                                                                  1
                                                                }
                                                                onChange={(e) =>
                                                                  HandleQ26OneRepeaterFieldChange(
                                                                    e,
                                                                    data.agentName,
                                                                    null,
                                                                    idx,
                                                                    null,
                                                                  )
                                                                }
                                                              />
                                                              <label
                                                                htmlFor={`q26_one_${data.agentName}_SecondSiteCare_${idx}`}
                                                              >
                                                                <span className="radio-text-padding">
                                                                  Inpatient
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <div
                                                              className="option-without-input"
                                                              style={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "flex-start",
                                                                paddingLeft:
                                                                  "6px",
                                                              }}
                                                            >
                                                              <input
                                                                type="radio"
                                                                id={`q26_one_${data.agentName}_SecondSiteCare_${idx}_out`}
                                                                name={`q26_one_${data.agentName}_SecondSiteCare_${idx}`}
                                                                value={2}
                                                                checked={
                                                                  data.secondSiteCareC ===
                                                                  2
                                                                }
                                                                onChange={(e) =>
                                                                  HandleQ26OneRepeaterFieldChange(
                                                                    e,
                                                                    data.agentName,
                                                                    null,
                                                                    idx,
                                                                    null,
                                                                  )
                                                                }
                                                              />
                                                              <label
                                                                htmlFor={`q26_one_${data.agentName}_SecondSiteCare_${idx}_out`}
                                                              >
                                                                <span className="radio-text-padding">
                                                                  Outpatient
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <div
                                                              className="option-without-input"
                                                              style={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "flex-start",
                                                                paddingLeft:
                                                                  "6px",
                                                              }}
                                                            >
                                                              <input
                                                                type="radio"
                                                                id={`q26_one_${data.agentName}_SecondSiteCare_${idx}_unk`}
                                                                name={`q26_one_${data.agentName}_SecondSiteCare_${idx}`}
                                                                value={99}
                                                                checked={
                                                                  data.secondSiteCareC ===
                                                                  99
                                                                }
                                                                onChange={(e) =>
                                                                  HandleQ26OneRepeaterFieldChange(
                                                                    e,
                                                                    data.agentName,
                                                                    null,
                                                                    idx,
                                                                    null,
                                                                  )
                                                                }
                                                              />
                                                              <label
                                                                htmlFor={`q26_one_${data.agentName}_SecondSiteCare_${idx}_unk`}
                                                              >
                                                                <span className="radio-text-padding">
                                                                  Unknown
                                                                </span>
                                                              </label>
                                                            </div>
                                                            <ErrorField
                                                              style={{
                                                                padding: "0px",
                                                              }}
                                                              show={
                                                                data.showSecondSiteCareError
                                                              }
                                                              message={
                                                                BispecificCartTreatmentCohort_Msgs.q26f
                                                              }
                                                            />
                                                          </div>
                                                        )}
                                                      </>
                                                    ) : (
                                                      <b>Not applicable</b>
                                                    )}
                                                  </td>

                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    <div className="">
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <input
                                                          type="radio"
                                                          id={`q26_one_date_last_admin_radio_${data.agentName}_${idx}`}
                                                          name={`q26_one_date_last_admin_radio_${data.agentName}_${idx}`}
                                                          style={{
                                                            marginTop: "6px",
                                                          }}
                                                          value={1}
                                                          checked={
                                                            data.lastDateRadio ===
                                                            1
                                                          }
                                                          onChange={(e) =>
                                                            HandleQ26OneRepeaterFieldChange(
                                                              e,
                                                              data.agentName,
                                                              null,
                                                              null,
                                                              null,
                                                            )
                                                          }
                                                        />
                                                        <span
                                                          className="radio-text-padding datepicker-dependence calender-datefix"
                                                          style={{
                                                            paddingLeft: "5px",
                                                          }}
                                                        >
                                                          <DatePickerComponent
                                                            ctrlId={`q26_one_last_admin_date_${idx}`}
                                                            HandleDateChange={(
                                                              name,
                                                              value,
                                                            ) => {
                                                              HandleQ26OneDateChange(
                                                                name,
                                                                value,
                                                                data.agentName,
                                                              );
                                                            }}
                                                            minDate={dayjs(
                                                              "01-01-1920",
                                                            )}
                                                            maxDate={dayjs()}
                                                            locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                                            date={data.lastDate}
                                                          />
                                                        </span>
                                                      </div>
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <label
                                                          style={{
                                                            textAlign: "start",
                                                            display: "flex",
                                                            alignItems:
                                                              "flex-start",
                                                          }}
                                                        >
                                                          <input
                                                            type="radio"
                                                            id={`q26_one_${data.agentName}_LUnk_${idx}`}
                                                            name={`q26_one_${data.agentName}_LUnk_${idx}`}
                                                            style={{
                                                              marginTop: "6px",
                                                            }}
                                                            value={1}
                                                            checked={
                                                              data.lastDateUnk ===
                                                              1
                                                            }
                                                            onChange={(e) =>
                                                              HandleQ26OneRepeaterFieldChange(
                                                                e,
                                                                data.agentName,
                                                                null,
                                                                null,
                                                                null,
                                                              )
                                                            }
                                                          />
                                                          <span className="radio-text-padding">
                                                            Date of last
                                                            administration
                                                            unknown
                                                          </span>
                                                        </label>
                                                      </div>
                                                    </div>
                                                    <ErrorField
                                                      style={{ padding: "0px" }}
                                                      show={data.showColDError}
                                                      message={
                                                        BispecificCartTreatmentCohort_Msgs.q26d
                                                      }
                                                    />
                                                    <ErrorField
                                                      style={{ padding: "0px" }}
                                                      show={
                                                        data.agentSortedDateError ==
                                                          true ||
                                                        (data.q261ChainErr &&
                                                          data.q261ChainErrMsg ===
                                                            BispecificCartTreatmentCohort_Msgs.q26_lotDateRangeError &&
                                                          data.q261ChainErrField !==
                                                            "initiation")
                                                      }
                                                      message={
                                                        BispecificCartTreatmentCohort_Msgs.q26_lotDateRangeError
                                                      }
                                                    />
                                                    <ErrorField
                                                      style={{ padding: "0px" }}
                                                      show={
                                                        data.q261ChainErr &&
                                                        data.q261ChainErrMsg !==
                                                          BispecificCartTreatmentCohort_Msgs.q26_lotDateRangeError &&
                                                        !(
                                                          data.q261ChainErrMsg &&
                                                          data.q261ChainErrMsg.includes(
                                                            "cannot be after the Bispecifics/CAR-T agent initiation date.",
                                                          )
                                                        )
                                                      }
                                                      message={
                                                        data.q261ChainErrMsg ||
                                                        BispecificCartTreatmentCohort_Msgs.q261_chain
                                                      }
                                                    />
                                                    <ErrorField
                                                      style={{ padding: "0px" }}
                                                      show={
                                                        data.lastAdministrationSoftError ===
                                                        true
                                                      }
                                                      message={
                                                        <>
                                                          WARNING: you have
                                                          noted that the
                                                          medication is ongoing
                                                          at the time of last
                                                          encounter and listed
                                                          the date of last
                                                          administration as{" "}
                                                          <i>Unknown</i>. Please
                                                          provide the date of
                                                          the last known
                                                          administration of the
                                                          medication prior to
                                                          the patient’s last
                                                          encounter on{" "}
                                                          {lastEncounterDate ||
                                                            "[date of last encounter]"}{" "}
                                                          or infer the date of
                                                          last known
                                                          administration using
                                                          information provided
                                                          within the patient’s
                                                          chart, if possible.
                                                          Only state that the
                                                          date of last
                                                          administration is
                                                          unknown if there are
                                                          no known
                                                          administrations of the
                                                          medication during this
                                                          line of therapy.
                                                        </>
                                                      }
                                                    />
                                                  </td>

                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    <div
                                                      className="option-fbox"
                                                      style={{ width: "216px" }}
                                                    >
                                                      <label
                                                        htmlFor={`q26_one_${data.agentName}_No_Admin_${idx}`}
                                                      >
                                                        <input
                                                          type="radio"
                                                          id={`q26_one_${data.agentName}_No_Admin_${idx}`}
                                                          name={`q26_one_${data.agentName}_No_Admin_${idx}`}
                                                          value={1}
                                                          checked={
                                                            data.noOfAdmissionRadio ===
                                                            1
                                                          }
                                                          onChange={(e) =>
                                                            HandleQ26OneRepeaterFieldChange(
                                                              e,
                                                              data.agentName,
                                                              null,
                                                              null,
                                                              null,
                                                            )
                                                          }
                                                        />
                                                      </label>
                                                      <label
                                                        htmlFor={`q26e_${data.agentName}_Noatxt_${idx}`}
                                                      >
                                                        <span className="radio-text-padding">
                                                          <input
                                                            className="input-dash"
                                                            id={`q26_one_${data.agentName}_No_Admintxt_${idx}`}
                                                            name={`q26_one_${data.agentName}_No_Admintxt_${idx}`}
                                                            type="text"
                                                            value={
                                                              data.noOfAdmission
                                                            }
                                                            min={1}
                                                            max={4000}
                                                            // maxLength={3}
                                                            onKeyDown={(e) => {
                                                              // Prevent entering '.', 'e', '+', '-', and any non-numeric characters
                                                              if (
                                                                [
                                                                  ".",
                                                                  "e",
                                                                  "+",
                                                                  "-",
                                                                  "E",
                                                                ].includes(
                                                                  e.key,
                                                                ) ||
                                                                (e.key
                                                                  .length ===
                                                                  1 &&
                                                                  !/[0-9]/.test(
                                                                    e.key,
                                                                  ))
                                                              ) {
                                                                e.preventDefault();
                                                              }
                                                            }}
                                                            onChange={(e) =>
                                                              HandleQ26OneRepeaterFieldChange(
                                                                e,
                                                                data.agentName,
                                                                null,
                                                                null,
                                                                null,
                                                              )
                                                            }
                                                          />
                                                        </span>
                                                      </label>
                                                      {/*<label><span className="" style={{ marginLeft: '12px', textAlign: 'start' }}>(Range: 1 to 550)</span></label>*/}
                                                    </div>
                                                    <div
                                                      className="option-without-input"
                                                      style={{ width: "216px" }}
                                                    >
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          id={`q26_one_${data.agentName}_No_Admin_Unk_${idx}`}
                                                          name={`q26_one_${data.agentName}_No_Admin_Unk_${idx}`}
                                                          value={1}
                                                          checked={
                                                            data.noOfAdmissionUnk ===
                                                            1
                                                          }
                                                          onChange={(e) =>
                                                            HandleQ26OneRepeaterFieldChange(
                                                              e,
                                                              data.agentName,
                                                              null,
                                                              null,
                                                              null,
                                                            )
                                                          }
                                                        />
                                                        <span
                                                          className="radio-text-padding"
                                                          style={{
                                                            textAlign: "left",
                                                          }}
                                                        >
                                                          Unknown, please
                                                          specify dosing
                                                          schedule:
                                                          <textarea
                                                            className="input-dash"
                                                            id={`q26_one_${data.agentName}_No_Admin_Unktxt_${idx}`}
                                                            name={`q26_one_${data.agentName}_No_Admin_Unktxt_${idx}`}
                                                            type="text"
                                                            value={
                                                              data.noOfAdmissionUnkTxt
                                                            }
                                                            onChange={(e) =>
                                                              HandleQ26OneRepeaterFieldChange(
                                                                e,
                                                                data.agentName,
                                                                null,
                                                                null,
                                                                null,
                                                              )
                                                            }
                                                          />
                                                        </span>
                                                      </label>
                                                    </div>
                                                    <ErrorField
                                                      style={{ padding: "0px" }}
                                                      show={data.showColEError}
                                                      message={
                                                        BispecificCartTreatmentCohort_Msgs.q26e
                                                      }
                                                    />
                                                    <ErrorField
                                                      style={{ padding: "0px" }}
                                                      show={
                                                        data.showColEUkTxtError
                                                      }
                                                      message={
                                                        BispecificCartTreatmentCohort_Msgs.q26eTxt
                                                      }
                                                    />
                                                  </td>

                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    <div className="option-fbox">
                                                      <label
                                                        htmlFor={`q26_one_${data.agentName}_mg_${idx}`}
                                                      >
                                                        <input
                                                          type="radio"
                                                          id={`q26_one_${data.agentName}_mg_${idx}`}
                                                          name={`q26_one_${data.agentName}_mg_${idx}`}
                                                          value={1}
                                                          checked={
                                                            data.doseAdministrationRadiomg ===
                                                            1
                                                          }
                                                          onChange={(e) =>
                                                            HandleQ26OneRepeaterFieldChange(
                                                              e,
                                                              data.agentName,
                                                              null,
                                                              null,
                                                              null,
                                                            )
                                                          }
                                                        />
                                                      </label>
                                                      <label
                                                        htmlFor={`q26_one_${data.agentName}_mgtxt_${idx}`}
                                                      >
                                                        <span className="radio-text-padding">
                                                          <input
                                                            className="input-dash-custom"
                                                            id={`q26_one_${data.agentName}_mgtxt_${idx}`}
                                                            name={`q26_one_${data.agentName}_mgtxt_${idx}`}
                                                            type="text"
                                                            value={
                                                              data.doseAdministrationmg
                                                            }
                                                            min={0}
                                                            max={4000}
                                                            // maxLength={3}
                                                            onKeyDown={(e) => {
                                                              // Allow backspace, arrow keys, delete, and tab
                                                              if (
                                                                [
                                                                  "Backspace",
                                                                  "ArrowLeft",
                                                                  "ArrowRight",
                                                                  "Delete",
                                                                  "Tab",
                                                                ].includes(
                                                                  e.key,
                                                                )
                                                              ) {
                                                                return;
                                                              }
                                                              // Prevent non-numeric characters, except '.' (and only allow one decimal point)
                                                              if (
                                                                !/[0-9.]/.test(
                                                                  e.key,
                                                                ) ||
                                                                (e.key ===
                                                                  "." &&
                                                                  e.target.value.includes(
                                                                    ".",
                                                                  ))
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }
                                                              const value =
                                                                e.target.value;
                                                              const selectionStart =
                                                                e.target
                                                                  .selectionStart;
                                                              const newValue =
                                                                value.slice(
                                                                  0,
                                                                  selectionStart,
                                                                ) +
                                                                e.key +
                                                                value.slice(
                                                                  e.target
                                                                    .selectionEnd,
                                                                );
                                                              // Prevent '.' as the first character
                                                              if (
                                                                e.key === "." &&
                                                                value === ""
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }
                                                              // Allow only one digit after decimal point
                                                              if (
                                                                newValue.includes(
                                                                  ".",
                                                                ) &&
                                                                newValue.split(
                                                                  ".",
                                                                )[1].length > 2
                                                              ) {
                                                                e.preventDefault();
                                                              }
                                                            }}
                                                            onChange={(e) =>
                                                              HandleQ26OneRepeaterFieldChange(
                                                                e,
                                                                data.agentName,
                                                                null,
                                                                null,
                                                                null,
                                                              )
                                                            }
                                                          />{" "}
                                                          &nbsp; mg
                                                        </span>
                                                      </label>
                                                      {/*<label><span className="" style={{ marginLeft: '12px', textAlign: 'start' }}>(Range: 1 to 550)</span></label>*/}
                                                    </div>
                                                    <br />
                                                    <div className="option-fbox">
                                                      <label
                                                        htmlFor={`q26_one_${data.agentName}_kg_${idx}`}
                                                      >
                                                        <input
                                                          type="radio"
                                                          id={`q26_one_${data.agentName}_kg_${idx}`}
                                                          name={`q26_one_${data.agentName}_kg_${idx}`}
                                                          value={1}
                                                          checked={
                                                            data.doseAdministrationRadiokg ===
                                                            1
                                                          }
                                                          onChange={(e) =>
                                                            HandleQ26OneRepeaterFieldChange(
                                                              e,
                                                              data.agentName,
                                                              null,
                                                              null,
                                                              null,
                                                            )
                                                          }
                                                        />
                                                      </label>
                                                      <label
                                                        htmlFor={`q26_one_${data.agentName}_kgtxt_${idx}`}
                                                      >
                                                        <span className="radio-text-padding">
                                                          <input
                                                            className="input-dash-custom"
                                                            id={`q26_one_${data.agentName}_kgtxt_${idx}`}
                                                            name={`q26_one_${data.agentName}_kgtxt_${idx}`}
                                                            type="text"
                                                            value={
                                                              data.doseAdministrationkg
                                                            }
                                                            min={0}
                                                            max={4000}
                                                            // maxLength={3}
                                                            onKeyDown={(e) => {
                                                              // Allow backspace, arrow keys, delete, and tab
                                                              if (
                                                                [
                                                                  "Backspace",
                                                                  "ArrowLeft",
                                                                  "ArrowRight",
                                                                  "Delete",
                                                                  "Tab",
                                                                ].includes(
                                                                  e.key,
                                                                )
                                                              ) {
                                                                return;
                                                              }
                                                              // Prevent non-numeric characters, except '.' (and only allow one decimal point)
                                                              if (
                                                                !/[0-9.]/.test(
                                                                  e.key,
                                                                ) ||
                                                                (e.key ===
                                                                  "." &&
                                                                  e.target.value.includes(
                                                                    ".",
                                                                  ))
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }
                                                              const value =
                                                                e.target.value;
                                                              const selectionStart =
                                                                e.target
                                                                  .selectionStart;
                                                              const newValue =
                                                                value.slice(
                                                                  0,
                                                                  selectionStart,
                                                                ) +
                                                                e.key +
                                                                value.slice(
                                                                  e.target
                                                                    .selectionEnd,
                                                                );
                                                              // Prevent '.' as the first character
                                                              if (
                                                                e.key === "." &&
                                                                value === ""
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }
                                                              // Allow only one digit after decimal point
                                                              if (
                                                                newValue.includes(
                                                                  ".",
                                                                ) &&
                                                                newValue.split(
                                                                  ".",
                                                                )[1].length > 2
                                                              ) {
                                                                e.preventDefault();
                                                              }
                                                            }}
                                                            onChange={(e) =>
                                                              HandleQ26OneRepeaterFieldChange(
                                                                e,
                                                                data.agentName,
                                                                null,
                                                                null,
                                                                null,
                                                              )
                                                            }
                                                          />
                                                        </span>{" "}
                                                        &nbsp; mg/kg
                                                      </label>
                                                      {/*<label><span className="" style={{ marginLeft: '12px', textAlign: 'start' }}>(Range: 1 to 550)</span></label>*/}
                                                    </div>
                                                    <br />
                                                    <div className="option-fbox">
                                                      <label
                                                        htmlFor={`q26_one_${data.agentName}_m_${idx}`}
                                                      >
                                                        <input
                                                          type="radio"
                                                          id={`q26_one_${data.agentName}_m_${idx}`}
                                                          name={`q26_one_${data.agentName}_m_${idx}`}
                                                          value={1}
                                                          checked={
                                                            data.doseAdministrationRadiomgm ===
                                                            1
                                                          }
                                                          onChange={(e) =>
                                                            HandleQ26OneRepeaterFieldChange(
                                                              e,
                                                              data.agentName,
                                                              null,
                                                              null,
                                                              null,
                                                            )
                                                          }
                                                        />
                                                      </label>
                                                      <label
                                                        htmlFor={`q26_one_${data.agentName}_mtxt_${idx}`}
                                                      >
                                                        <span className="radio-text-padding">
                                                          <input
                                                            className="input-dash-custom"
                                                            id={`q26_one_${data.agentName}_mtxt_${idx}`}
                                                            name={`q26_one_${data.agentName}_mtxt_${idx}`}
                                                            type="text"
                                                            value={
                                                              data.doseAdministrationmgm
                                                            }
                                                            min={0}
                                                            max={4000}
                                                            // maxLength={3}
                                                            onKeyDown={(e) => {
                                                              // Allow backspace, arrow keys, delete, and tab
                                                              if (
                                                                [
                                                                  "Backspace",
                                                                  "ArrowLeft",
                                                                  "ArrowRight",
                                                                  "Delete",
                                                                  "Tab",
                                                                ].includes(
                                                                  e.key,
                                                                )
                                                              ) {
                                                                return;
                                                              }
                                                              // Prevent non-numeric characters, except '.' (and only allow one decimal point)
                                                              if (
                                                                !/[0-9.]/.test(
                                                                  e.key,
                                                                ) ||
                                                                (e.key ===
                                                                  "." &&
                                                                  e.target.value.includes(
                                                                    ".",
                                                                  ))
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }
                                                              const value =
                                                                e.target.value;
                                                              const selectionStart =
                                                                e.target
                                                                  .selectionStart;
                                                              const newValue =
                                                                value.slice(
                                                                  0,
                                                                  selectionStart,
                                                                ) +
                                                                e.key +
                                                                value.slice(
                                                                  e.target
                                                                    .selectionEnd,
                                                                );
                                                              // Prevent '.' as the first character
                                                              if (
                                                                e.key === "." &&
                                                                value === ""
                                                              ) {
                                                                e.preventDefault();
                                                                return;
                                                              }
                                                              // Allow only one digit after decimal point
                                                              if (
                                                                newValue.includes(
                                                                  ".",
                                                                ) &&
                                                                newValue.split(
                                                                  ".",
                                                                )[1].length > 2
                                                              ) {
                                                                e.preventDefault();
                                                              }
                                                            }}
                                                            onChange={(e) =>
                                                              HandleQ26OneRepeaterFieldChange(
                                                                e,
                                                                data.agentName,
                                                                null,
                                                                null,
                                                                null,
                                                              )
                                                            }
                                                          />
                                                        </span>{" "}
                                                        &nbsp; mg/m<sup>2</sup>
                                                      </label>
                                                      {/*<label><span className="" style={{ marginLeft: '12px', textAlign: 'start' }}>(Range: 1 to 550)</span></label>*/}
                                                    </div>
                                                    <br />

                                                    <div className="">
                                                      <div className="option-without-input">
                                                        <label className="option-fbox">
                                                          <input
                                                            type="radio"
                                                            id={`q26_one_${data.agentName}_doseUnk_${idx}`}
                                                            name={`q26_one_${data.agentName}_doseUnk_${idx}`}
                                                            value={99}
                                                            checked={
                                                              data.doseAdministrationRadioUnknown ===
                                                              99
                                                            }
                                                            onChange={(e) =>
                                                              HandleQ26OneRepeaterFieldChange(
                                                                e,
                                                                data.agentName,
                                                                null,
                                                                null,
                                                                null,
                                                              )
                                                            }
                                                          />

                                                          <span className="radio-text-padding">
                                                            Unknown
                                                          </span>
                                                        </label>
                                                      </div>
                                                    </div>
                                                    <ErrorField
                                                      style={{ padding: "0px" }}
                                                      show={data.showColHError}
                                                      message={
                                                        BispecificCartTreatmentCohort_Msgs.q26h
                                                      }
                                                    />
                                                  </td>

                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    <div className="">
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <input
                                                          type="radio"
                                                          id={`q26_1_${data.agentName}_PdaYes_${idx}`}
                                                          name={`q26_1_${data.agentName}_PdaYes_${idx}`}
                                                          value={1}
                                                          checked={
                                                            data.discontinueAgent ===
                                                            1
                                                          }
                                                          onChange={(e) =>
                                                            HandleQ26OneRepeaterFieldChange(
                                                              e,
                                                              data.agentName,
                                                              null,
                                                              null,
                                                              null,
                                                            )
                                                          }
                                                          style={{
                                                            marginTop: "6px",
                                                          }}
                                                        />
                                                        <label
                                                          htmlFor={`q26_1_${data.agentName}_PdaYes_${idx}`}
                                                          style={{
                                                            textAlign: "start",
                                                          }}
                                                        >
                                                          <span className="radio-text-padding">
                                                            Yes, agent
                                                            discontinued
                                                          </span>
                                                        </label>
                                                      </div>
                                                    </div>
                                                    {data.lot ===
                                                      highestLot && (
                                                      <div className="">
                                                        <div
                                                          className="option-without-input"
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "flex-start",
                                                          }}
                                                        >
                                                          <label
                                                            className="d-flex align-items-start"
                                                            htmlFor={`q26_1_${data.agentName}_PdaNo_${idx}`}
                                                            style={{
                                                              textAlign:
                                                                "start",
                                                            }}
                                                          >
                                                            <input
                                                              type="radio"
                                                              id={`q26_1_${data.agentName}_PdaNo_${idx}`}
                                                              name={`q26_1_${data.agentName}_PdaNo_${idx}`}
                                                              value={2}
                                                              checked={
                                                                data.discontinueAgent ===
                                                                2
                                                              }
                                                              onChange={(e) =>
                                                                HandleQ26OneRepeaterFieldChange(
                                                                  e,
                                                                  data.agentName,
                                                                  null,
                                                                  null,
                                                                  null,
                                                                )
                                                              }
                                                              style={{
                                                                marginTop:
                                                                  "6px",
                                                              }}
                                                            />

                                                            <span className="radio-text-padding">
                                                              No, medication
                                                              ongoing at time of
                                                              last encounter
                                                            </span>
                                                          </label>
                                                        </div>
                                                      </div>
                                                    )}
                                                    <div className="">
                                                      <div
                                                        className="option-without-input"
                                                        style={{
                                                          display: "flex",
                                                          alignItems:
                                                            "flex-start",
                                                        }}
                                                      >
                                                        <input
                                                          type="radio"
                                                          id={`q26_one_${data.agentName}_PdaUnk_${idx}`}
                                                          name={`q26_one_${data.agentName}_PdaUnk_${idx}`}
                                                          value={99}
                                                          checked={
                                                            data.discontinueAgent ===
                                                            99
                                                          }
                                                          onChange={(e) =>
                                                            HandleQ26OneRepeaterFieldChange(
                                                              e,
                                                              data.agentName,
                                                              null,
                                                              null,
                                                              null,
                                                            )
                                                          }
                                                        />
                                                        <label
                                                          htmlFor={`q26_one_${data.agentName}_PdaUnk_${idx}`}
                                                        >
                                                          <span className="radio-text-padding">
                                                            Unknown
                                                          </span>
                                                        </label>
                                                      </div>
                                                    </div>
                                                    <ErrorField
                                                      style={{ padding: "0px" }}
                                                      show={data.showColFError}
                                                      message={
                                                        BispecificCartTreatmentCohort_Msgs.q26f
                                                      }
                                                    />{" "}
                                                    <ErrorField
                                                      style={{ padding: "0px" }}
                                                      show={
                                                        data.discontinuationUnkSoftError ==
                                                        true
                                                      }
                                                      message={
                                                        <>
                                                          WARNING: the
                                                          discontinuation status
                                                          for this medication
                                                          has been listed as
                                                          unknown. Please
                                                          attempt to infer the
                                                          discontinuation status
                                                          using information
                                                          provided within the
                                                          patient chart. Only
                                                          use the <i>unknown</i>{" "}
                                                          option if there is
                                                          truly no information
                                                          reported on medication
                                                          discontinuation
                                                          status.
                                                        </>
                                                      }
                                                    />
                                                  </td>

                                                  <td
                                                    style={{
                                                      border: "1px solid black",
                                                      padding: "8px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    {data.discontinueAgent ===
                                                      1 && (
                                                      <div className="">
                                                        {data.reasonForDiscontinuingMedications?.map(
                                                          (item, itemidx) => (
                                                            <div
                                                              className=""
                                                              key={itemidx}
                                                            >
                                                              <div
                                                                className=""
                                                                style={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "flex-start",
                                                                }}
                                                              >
                                                                <label
                                                                  className="d-flex align-items-start"
                                                                  htmlFor={`Q26_one_discont_${idx}_${agentIdx}_${
                                                                    data.agentName
                                                                  }_${
                                                                    item.reasonName +
                                                                    item.supscripttext
                                                                  }_${itemidx}`}
                                                                >
                                                                  <input
                                                                    type="checkbox"
                                                                    key={
                                                                      item.reasonid
                                                                    }
                                                                    id={`Q26_one_discont_${idx}_${agentIdx}_${
                                                                      data.agentName
                                                                    }_${
                                                                      item.reasonName +
                                                                      item.supscripttext
                                                                    }_${itemidx}`}
                                                                    name={`discont_${
                                                                      data.agentName
                                                                    }_${
                                                                      item.reasonName +
                                                                      item.supscripttext
                                                                    }_${itemidx}`}
                                                                    style={{
                                                                      marginTop:
                                                                        "6px",
                                                                    }}
                                                                    checked={
                                                                      item.isSelected
                                                                    }
                                                                    onChange={(
                                                                      e,
                                                                    ) =>
                                                                      HandleQ26OneRepeaterFieldChange(
                                                                        e,
                                                                        data.agentName,
                                                                        item.reasonName +
                                                                          item.supscripttext,
                                                                        idx,
                                                                        itemidx,
                                                                      )
                                                                    }
                                                                  />

                                                                  <span
                                                                    style={{
                                                                      textAlign:
                                                                        "left",
                                                                    }}
                                                                    className="radio-text-padding "
                                                                  >
                                                                    {
                                                                      item.reasonName
                                                                    }
                                                                    {item.supscripttext ===
                                                                    null ? (
                                                                      ""
                                                                    ) : (
                                                                      <>
                                                                        <sup className="supscript">
                                                                          {item.supscripttext.slice(
                                                                            0,
                                                                            2,
                                                                          )}
                                                                        </sup>
                                                                        {item.supscripttext.slice(
                                                                          2,
                                                                        )}
                                                                      </>
                                                                    )}
                                                                  </span>
                                                                </label>
                                                              </div>
                                                              {item.reasonName ===
                                                                DiscontinuationReason.AdverseEvent &&
                                                                item.isSelected && (
                                                                  <div
                                                                    style={{
                                                                      marginLeft:
                                                                        "24px",
                                                                      marginTop:
                                                                        "6px",
                                                                    }}
                                                                  >
                                                                    {data
                                                                      .adverseEventsDiscontinuationreason
                                                                      ?.length >
                                                                      0 &&
                                                                      data.adverseEventsDiscontinuationreason.map(
                                                                        (
                                                                          ae,
                                                                          aeIdx,
                                                                        ) => {
                                                                          const isAEUnknown =
                                                                            ae.reasonName ===
                                                                            "AE type unknown";

                                                                          return (
                                                                            <div
                                                                              key={
                                                                                aeIdx
                                                                              }
                                                                            >
                                                                              <label
                                                                                className="d-flex align-items-start"
                                                                                htmlFor={`adverse_${idx}_${agentIdx}_${data.agentName}_${itemidx}_${aeIdx}`}
                                                                              >
                                                                                <input
                                                                                  type={
                                                                                    isAEUnknown
                                                                                      ? "radio"
                                                                                      : "checkbox"
                                                                                  }
                                                                                  id={`adverse_${idx}_${agentIdx}_${data.agentName}_${itemidx}_${aeIdx}`}
                                                                                  name={`adverse_${data.agentName}_${itemidx}_${aeIdx}`}
                                                                                  checked={
                                                                                    ae.isSelected
                                                                                  }
                                                                                  onChange={(
                                                                                    e,
                                                                                  ) =>
                                                                                    HandleQ26OneRepeaterFieldChange(
                                                                                      e,
                                                                                      data.agentName,
                                                                                      "Adverse Events",
                                                                                      idx,
                                                                                      itemidx,
                                                                                      aeIdx,
                                                                                    )
                                                                                  }
                                                                                  style={{
                                                                                    marginTop:
                                                                                      "6px",
                                                                                  }}
                                                                                />

                                                                                <span
                                                                                  style={{
                                                                                    textAlign:
                                                                                      "left",
                                                                                  }}
                                                                                  className="radio-text-padding"
                                                                                >
                                                                                  {
                                                                                    ae.reasonName
                                                                                  }
                                                                                </span>
                                                                              </label>
                                                                              {ae.reasonName ===
                                                                                DiscontinuationReason.NeurologicalEvent &&
                                                                                ae.isSelected && (
                                                                                  <div
                                                                                    style={{
                                                                                      marginLeft:
                                                                                        "28px",
                                                                                      marginTop:
                                                                                        "8px",
                                                                                    }}
                                                                                  >
                                                                                    {data
                                                                                      .adverseNeurologicalEventsDiscontinuationreason
                                                                                      ?.length >
                                                                                      0 &&
                                                                                      data.adverseNeurologicalEventsDiscontinuationreason.map(
                                                                                        (
                                                                                          aeNeuro,
                                                                                          aeNeuroIdx,
                                                                                        ) => {
                                                                                          return (
                                                                                            <div
                                                                                              key={
                                                                                                aeIdx
                                                                                              }
                                                                                            >
                                                                                              <label
                                                                                                className="d-flex align-items-start"
                                                                                                htmlFor={`adverse_${idx}_${agentIdx}_${data.agentName}_${itemidx}_${aeIdx}_${aeNeuroIdx}`}
                                                                                              >
                                                                                                <input
                                                                                                  type="checkbox"
                                                                                                  id={`adverse_${idx}_${agentIdx}_${data.agentName}_${itemidx}_${aeIdx}_${aeNeuroIdx}`}
                                                                                                  name={`adverse_${data.agentName}_${itemidx}_${aeIdx}_${aeNeuroIdx}`}
                                                                                                  checked={
                                                                                                    aeNeuro.isSelected
                                                                                                  }
                                                                                                  onChange={(
                                                                                                    e,
                                                                                                  ) =>
                                                                                                    HandleQ26OneRepeaterFieldChange(
                                                                                                      e,
                                                                                                      data.agentName,
                                                                                                      "Adverse Events",
                                                                                                      idx,
                                                                                                      itemidx,
                                                                                                      aeIdx,
                                                                                                      aeNeuroIdx,
                                                                                                    )
                                                                                                  }
                                                                                                  style={{
                                                                                                    marginTop:
                                                                                                      "6px",
                                                                                                  }}
                                                                                                />

                                                                                                <span
                                                                                                  style={{
                                                                                                    textAlign:
                                                                                                      "left",
                                                                                                  }}
                                                                                                  className="radio-text-padding"
                                                                                                >
                                                                                                  {
                                                                                                    aeNeuro.reasonName
                                                                                                  }
                                                                                                </span>
                                                                                              </label>

                                                                                              {aeNeuro.reasonName.includes(
                                                                                                "Other",
                                                                                              ) && (
                                                                                                <label
                                                                                                  htmlFor={`discont_${idx}_${agentIdx}_${data.agentName}_${aeNeuro.reasonName}txt_${itemidx}_${aeNeuroIdx}`}
                                                                                                >
                                                                                                  <span
                                                                                                    style={{
                                                                                                      paddingLeft:
                                                                                                        "28px",
                                                                                                    }}
                                                                                                    className="radio-text-padding"
                                                                                                  >
                                                                                                    <textarea
                                                                                                      style={{
                                                                                                        width:
                                                                                                          "264px",
                                                                                                      }}
                                                                                                      //className="input-dash"
                                                                                                      id={`discont_${idx}_${agentIdx}_${data.agentName}_${aeNeuro.reasonName}txt_${itemidx}_${aeNeuroIdx}`}
                                                                                                      name={`discont_${data.agentName}_${aeNeuro.reasonName}txt_${itemidx}_${aeNeuroIdx}`}
                                                                                                      type="text"
                                                                                                      value={
                                                                                                        aeNeuro.reasonText
                                                                                                      }
                                                                                                      onChange={(
                                                                                                        e,
                                                                                                      ) =>
                                                                                                        HandleQ26OneRepeaterFieldChange(
                                                                                                          e,
                                                                                                          data.agentName,
                                                                                                          aeNeuro.reasonName,
                                                                                                          idx,
                                                                                                          itemidx,
                                                                                                          aeIdx,
                                                                                                          aeNeuroIdx,
                                                                                                        )
                                                                                                      }
                                                                                                      maxLength={
                                                                                                        300
                                                                                                      }
                                                                                                    />
                                                                                                  </span>
                                                                                                </label>
                                                                                              )}
                                                                                            </div>
                                                                                          );
                                                                                        },
                                                                                      )}
                                                                                  </div>
                                                                                )}
                                                                            </div>
                                                                          );
                                                                        },
                                                                      )}
                                                                  </div>
                                                                )}

                                                              {item.reasonName.includes(
                                                                "Other",
                                                              ) && (
                                                                <label
                                                                  htmlFor={`discont_${idx}_${agentIdx}_${data.agentName}_${item.reasonName}txt_${itemidx}`}
                                                                >
                                                                  <span className="radio-text-padding">
                                                                    <textarea
                                                                      style={{
                                                                        width:
                                                                          "264px",
                                                                      }}
                                                                      //className="input-dash"
                                                                      id={`discont_${idx}_${agentIdx}_${data.agentName}_${item.reasonName}txt_${itemidx}`}
                                                                      name={`discont_${data.agentName}_${item.reasonName}txt_${itemidx}`}
                                                                      type="text"
                                                                      value={
                                                                        item.reasonText
                                                                      }
                                                                      onChange={(
                                                                        e,
                                                                      ) =>
                                                                        HandleQ26OneRepeaterFieldChange(
                                                                          e,
                                                                          data.agentName,
                                                                          item.reasonName +
                                                                            item.supscripttext,
                                                                          idx,
                                                                          itemidx,
                                                                        )
                                                                      }
                                                                      maxLength={
                                                                        300
                                                                      }
                                                                    />
                                                                  </span>
                                                                </label>
                                                              )}
                                                            </div>
                                                          ),
                                                        )}
                                                        <div
                                                          className="option-without-input"
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "flex-start",
                                                          }}
                                                        >
                                                          <input
                                                            type="radio"
                                                            id={`discont_unk_${data.agentName}_${idx}`}
                                                            name={`discont_unk_${data.agentName}_${idx}`}
                                                            value={true}
                                                            checked={
                                                              data
                                                                .reasonForDiscontinuingMedications?.[0]
                                                                ?.reasonUnk
                                                                ? true
                                                                : ""
                                                            }
                                                            onChange={(e) =>
                                                              HandleQ26OneRepeaterFieldChange(
                                                                e,
                                                                data.agentName,
                                                                null,
                                                                idx,
                                                                null,
                                                              )
                                                            }
                                                          />
                                                          <label
                                                            htmlFor={`discont_unk_${data.agentName}_${idx}`}
                                                          >
                                                            <span className="radio-text-padding">
                                                              Unknown
                                                            </span>
                                                          </label>
                                                        </div>
                                                      </div>
                                                    )}
                                                    <ErrorField
                                                      style={{ padding: "0px" }}
                                                      show={data.showColGError}
                                                      message={
                                                        BispecificCartTreatmentCohort_Msgs.q26g
                                                      }
                                                    />
                                                    <ErrorField
                                                      style={{ padding: "0px" }}
                                                      show={
                                                        data.showColGOthError
                                                      }
                                                      message={
                                                        BispecificCartTreatmentCohort_Msgs.q26ga
                                                      }
                                                    />
                                                    <ErrorField
                                                      style={{ padding: "0px" }}
                                                      show={
                                                        data.discontinuationSoftError ==
                                                        true
                                                      }
                                                      message={
                                                        "WARNING: you have indicated that at least 1 reason for medication discontinuation was death however no date of death is reported in Q20. Please revise the reason for medication discontinuation to a reason besides death or otherwise add a date of death in Q20."
                                                      }
                                                    />
                                                    <ErrorField
                                                      style={{ padding: "0px" }}
                                                      show={
                                                        data.showAdverseEventError ==
                                                        true
                                                      }
                                                      message={
                                                        BispecificCartTreatmentCohort_Msgs.q26ae
                                                      }
                                                    />
                                                    <ErrorField
                                                      style={{ padding: "0px" }}
                                                      show={
                                                        data.showAdverseNeuroEventError ==
                                                        true
                                                      }
                                                      message={
                                                        BispecificCartTreatmentCohort_Msgs.q26aeNeuro
                                                      }
                                                    />
                                                    <ErrorField
                                                      style={{ padding: "0px" }}
                                                      show={
                                                        data.showAdverseNeuroEventOtherTextError ==
                                                        true
                                                      }
                                                      message={
                                                        BispecificCartTreatmentCohort_Msgs.q26aeNeuroOther
                                                      }
                                                    />
                                                  </td>
                                                </tr>
                                              ),
                                            )
                                          ) : (
                                            <tr>
                                              <td
                                                colSpan={8}
                                                style={{
                                                  textAlign: "center",
                                                  padding: "10px",
                                                }}
                                              >
                                                No agents available
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>
                                    </div>
                                  </Collapse>
                                </div>
                              ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {isNewEcrfA &&
                  bispecificHighestLotList &&
                  bispecificHighestLotList.length > 0 && (
                    <div className="survey-question-content calender-datefix-survey">
                      <div className="question-answer">
                        <div className="question-bot-sapce">
                          <div className="question question-weight">
                            <span>Q26.2.</span>
                            <span className="quest-text-pad">
                              Please provide information on all{" "}
                              <u>prior lines of therapy (LOTs)</u> received for
                              this patient before initiating treatment with{" "}
                              <span
                                style={{ color: PageDesignConstants.fontColor }}
                              >
                                <b>
                                  {bispecificHighestLotList[0]
                                    .cohorttreatmentid === null
                                    ? "[Bispecifics/CAR-T with the highest LOT number]"
                                    : bispecificHighestLotList[0]
                                        .cohorttreatmentName}
                                  .
                                </b>{" "}
                              </span>
                              <br />
                              <b>Please note that:</b>
                              <br />
                              <b>
                                - Start dates must be no later than end dates
                                within the same LOT; end dates of a LOT cannot
                                exceed the start date of the next LOT
                              </b>
                              <br />
                              <b>
                                - If the highest LOT is ongoing at the time of
                                abstraction, indicate that the LOT end date is{" "}
                                <i>Unknown</i>. A LOT end date should be
                                reported only if (i) there is a
                                physician-defined LOT end date or (ii) a
                                subsequent LOT was received (defined LOT end
                                date as subsequent LOT start date – 1 day)
                              </b>
                            </span>
                          </div>
                          <div className="sub-question">
                            <div className="" style={{ overflowX: "auto" }}>
                              <table
                                style={{
                                  border: "1px solid black",
                                  borderCollapse: "collapse",
                                  width: "100%",
                                }}
                              >
                                <thead>
                                  <tr>
                                    <th
                                      style={{
                                        border: "1px solid black",
                                        padding: "8px",
                                        textAlign: "center",
                                        width: "10%",
                                      }}
                                    >
                                      LOT
                                    </th>
                                    <th
                                      style={{
                                        border: "1px solid black",
                                        padding: "8px",
                                        textAlign: "center",
                                        width: "20%",
                                      }}
                                    >
                                      LOT start date
                                    </th>
                                    <th
                                      style={{
                                        border: "1px solid black",
                                        padding: "8px",
                                        textAlign: "center",
                                        width: "20%",
                                      }}
                                    >
                                      LOT end date
                                    </th>
                                    <th
                                      style={{
                                        border: "1px solid black",
                                        padding: "8px",
                                        textAlign: "center",
                                        width: "20%",
                                      }}
                                    >
                                      Treatments Received
                                    </th>
                                    <th
                                      style={{
                                        border: "1px solid black",
                                        padding: "8px",
                                        textAlign: "center",
                                        width: "15%",
                                      }}
                                    >
                                      SCT Received on LOT?
                                    </th>
                                    <th
                                      style={{
                                        border: "1px solid black",
                                        padding: "8px",
                                        textAlign: "center",
                                        width: "15%",
                                      }}
                                    >
                                      Refractory to treatment?
                                    </th>
                                    {isNewEcrfC && (
                                      <th
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          textAlign: "center",
                                          width: "20%",
                                        }}
                                      >
                                        Agents refractory to
                                      </th>
                                    )}
                                  </tr>
                                </thead>
                                <tbody>
                                  {bispecificHighestLotList.map((row, idx) => (
                                    <tr key={idx}>
                                      <td
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          alignContent: "flex-start",
                                        }}
                                      >
                                        <div>
                                          {" "}
                                          {/*  className="double-dig-answer" */}
                                          <div className="long-text-option">
                                            <label>
                                              <span className="radio-text-padding">
                                                <span
                                                  style={{
                                                    color:
                                                      PageDesignConstants.fontColor,
                                                  }}
                                                >
                                                  {row.q262_rbl_A}
                                                </span>
                                              </span>
                                            </label>
                                          </div>
                                        </div>
                                      </td>

                                      <td
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          alignContent: "flex-start",
                                        }}
                                      >
                                        <>
                                          <div className="">
                                            {/* double-dig-answer */}
                                            <div className="long-text-option">
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={"q262_rbl_B" + idx}
                                                value={1}
                                                checked={row.q262_rbl_B === 1}
                                                onChange={Handle262FieldChange}
                                              />
                                              <span className="date-field-padding">
                                                {!isStringEmpty(
                                                  row.q262_autodate_B,
                                                ) ? (
                                                  row.q262_autodate_B
                                                ) : (
                                                  <DatePickerComponent
                                                    ctrlId={"q262_date_B" + idx}
                                                    HandleDateChange={
                                                      Handle262DateChange
                                                    }
                                                    minDate={dayjs(
                                                      "01-01-1920",
                                                    )}
                                                    maxDate={dayjs()}
                                                    locale="en"
                                                    date={row.q262_date_B}
                                                    optionId={idx}
                                                  />
                                                )}
                                              </span>
                                            </div>
                                            {isStringEmpty(
                                              row.q262_autodate_B,
                                            ) && (
                                              <div>
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={"q262_rbl_B" + idx}
                                                    value={99}
                                                    checked={
                                                      row.q262_rbl_B === 99
                                                    }
                                                    onChange={
                                                      Handle262FieldChange
                                                    }
                                                  />
                                                  <span className="radio-text-padding">
                                                    Date unknown
                                                  </span>
                                                </label>
                                              </div>
                                            )}
                                          </div>
                                          <ErrorField
                                            show={row.q262_B_empty_err}
                                            message={
                                              BispecificCartTreatmentCohort_Msgs.q262_B
                                            }
                                            style={{ paddingLeft: "0px" }}
                                          />
                                          <ErrorField
                                            show={row.q262_B_unk_err}
                                            message={
                                              BispecificCartTreatmentCohort_Msgs.q262_BC_Warning
                                            }
                                            style={{ paddingLeft: "0px" }}
                                          />
                                          <ErrorField
                                            show={row.q262_B_before_err}
                                            message={
                                              BispecificCartTreatmentCohort_Msgs.q262_AfterPrevLot
                                            }
                                            style={{ paddingLeft: "0px" }}
                                          />
                                          <ErrorField
                                            show={row.q262_B_beyond_eof_err}
                                            message={
                                              BispecificCartTreatmentCohort_Msgs.Q32c_LessThanEOF
                                            }
                                            style={{ paddingLeft: "0px" }}
                                          />
                                          <ErrorField
                                            show={
                                              row.q262_B_before_next_lot_err
                                            }
                                            message={
                                              BispecificCartTreatmentCohort_Msgs.q32_MoreThanNxtLotStart
                                            }
                                            style={{ paddingLeft: "0px" }}
                                          />
                                          <ErrorField
                                            show={row.q262_B_invalid_date}
                                            message={
                                              CommonError_Msgs.InvalidDate
                                            }
                                            style={{ paddingLeft: "0px" }}
                                          />
                                          <ErrorField
                                            show={row.q262_B_after_end_err}
                                            message={
                                              BispecificCartTreatmentCohort_Msgs.q262_BeforeLotEnd
                                            }
                                            style={{ paddingLeft: "0px" }}
                                          />
                                          <ErrorField
                                            show={row.q262ChainErrStart}
                                            message={row.q262ChainErrStartMsg}
                                            style={{ paddingLeft: "0px" }}
                                          />
                                          <ErrorField
                                            show={row.q262RowChainErrStart}
                                            message={
                                              row.q262RowChainErrStartMsg
                                            }
                                            style={{ paddingLeft: "0px" }}
                                          />
                                        </>
                                      </td>

                                      <td
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          alignContent: "flex-start",
                                        }}
                                      >
                                        <>
                                          <div className="">
                                            {/* double-dig-answer */}
                                            <div className="long-text-option">
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={"q262_rbl_C" + idx}
                                                value={1}
                                                checked={row.q262_rbl_C === 1}
                                                onChange={Handle262FieldChange}
                                              />
                                              <span className="date-field-padding">
                                                {!isStringEmpty(
                                                  row.q262_autodate_C,
                                                ) ? (
                                                  row.q262_autodate_C
                                                ) : (
                                                  <DatePickerComponent
                                                    ctrlId={"q262_date_C" + idx}
                                                    HandleDateChange={
                                                      Handle262DateChange
                                                    }
                                                    minDate={dayjs(
                                                      "01-01-1920",
                                                    )}
                                                    maxDate={dayjs()}
                                                    locale="en"
                                                    date={row.q262_date_C}
                                                    optionId={idx}
                                                  />
                                                )}
                                              </span>
                                            </div>
                                            {isStringEmpty(
                                              row.q262_autodate_C,
                                            ) && (
                                              <div>
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={"q262_rbl_C" + idx}
                                                    value={99}
                                                    checked={
                                                      row.q262_rbl_C === 99
                                                    }
                                                    onChange={
                                                      Handle262FieldChange
                                                    }
                                                  />
                                                  <span className="radio-text-padding">
                                                    Date unknown
                                                  </span>
                                                </label>
                                              </div>
                                            )}
                                          </div>
                                          <ErrorField
                                            show={row.q262_C_empty_err}
                                            message={
                                              BispecificCartTreatmentCohort_Msgs.q262_C
                                            }
                                            style={{ paddingLeft: "0px" }}
                                          />
                                          <ErrorField
                                            show={row.q262_C_unk_err}
                                            message={
                                              BispecificCartTreatmentCohort_Msgs.q262_BC_Warning
                                            }
                                            style={{ paddingLeft: "0px" }}
                                          />
                                          <ErrorField
                                            show={row.q262_C_citaabecm_err}
                                            message={
                                              BispecificCartTreatmentCohort_Msgs.q262_CitaAbecm_Error
                                            }
                                            style={{ paddingLeft: "0px" }}
                                          />
                                          <ErrorField
                                            show={row.q262_C_before_err}
                                            message={
                                              BispecificCartTreatmentCohort_Msgs.q262_AfterLotStart
                                            }
                                            style={{ paddingLeft: "0px" }}
                                          />
                                          <ErrorField
                                            show={row.q262_C_beyond_eof_err}
                                            message={
                                              BispecificCartTreatmentCohort_Msgs.Q32c_LessThanEOF
                                            }
                                            style={{ paddingLeft: "0px" }}
                                          />
                                          <ErrorField
                                            show={
                                              row.q262_C_before_next_lot_err
                                            }
                                            message={
                                              BispecificCartTreatmentCohort_Msgs.q32_MoreThanNxtLotStart
                                            }
                                            style={{ paddingLeft: "0px" }}
                                          />
                                          <ErrorField
                                            show={row.q262_C_invalid_date}
                                            message={
                                              CommonError_Msgs.InvalidDate
                                            }
                                            style={{ paddingLeft: "0px" }}
                                          />
                                          <ErrorField
                                            show={row.q262ChainErrEnd}
                                            message={row.q262ChainErrEndMsg}
                                            style={{ paddingLeft: "0px" }}
                                          />
                                          <ErrorField
                                            show={row.q262RowChainErrEnd}
                                            message={row.q262RowChainErrEndMsg}
                                            style={{ paddingLeft: "0px" }}
                                          />
                                        </>
                                      </td>

                                      <td
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          alignContent: "flex-start",
                                        }}
                                      >
                                        <>
                                          <div className="">
                                            {row.prescribedTreatments &&
                                              row.prescribedTreatments.length >
                                                0 &&
                                              (() => {
                                                const cohort =
                                                  cohortConfig.find((c) =>
                                                    c.cohortIds.includes(
                                                      row.bindedCohorttreatmentid,
                                                    ),
                                                  );

                                                const flag = cohort?.flag;
                                                const isCohortUndefined =
                                                  row.bindedCohorttreatmentid ==
                                                  null;

                                                return (
                                                  row.q262_rbl_A >= 1 &&
                                                  row.prescribedTreatments.map(
                                                    (category, index) =>
                                                      (isCohortUndefined ||
                                                        category?.treatments?.some(
                                                          (x) =>
                                                            x[flag] === true,
                                                        )) && (
                                                        <div
                                                          key={index}
                                                          style={{
                                                            paddingBottom:
                                                              "10px",
                                                          }}
                                                        >
                                                          <h6>
                                                            {category?.category}
                                                          </h6>

                                                          {category.treatments
                                                            .filter((x) =>
                                                              isCohortUndefined
                                                                ? true
                                                                : x[flag] ===
                                                                  true,
                                                            )
                                                            .map((item) => (
                                                              <div
                                                                key={
                                                                  item.prescribedTreatmentId
                                                                }
                                                              >
                                                                <label
                                                                  className={`long-text-option ${
                                                                    item.name ===
                                                                    "Other, please specify"
                                                                      ? undefined
                                                                      : "radio-text-padding"
                                                                  }`}
                                                                >
                                                                  <input
                                                                    type="checkbox"
                                                                    id={`${idx}_${item.prescribedTreatmentId}`}
                                                                    name={`chk_q262_received_tmt${idx}_${item.prescribedTreatmentId}`}
                                                                    checked={row.q262_selectedReceivedTmtList?.some(
                                                                      (a) =>
                                                                        a.prescribedTreatmentId ===
                                                                        item.prescribedTreatmentId,
                                                                    )}
                                                                    onChange={(
                                                                      e,
                                                                    ) => {
                                                                      const isNonEditable =
                                                                        row.q262_selectedReceivedTmtList?.some(
                                                                          (a) =>
                                                                            a.prescribedTreatmentId ===
                                                                              item.prescribedTreatmentId &&
                                                                            a.isNonEditable,
                                                                        );
                                                                      if (
                                                                        isNonEditable !=
                                                                        true
                                                                      ) {
                                                                        Handle262FieldChange(
                                                                          e,
                                                                        );
                                                                      }
                                                                    }}
                                                                  />

                                                                  {item.name ===
                                                                  "Other, please specify" ? (
                                                                    <span className="radio-text-padding">
                                                                      {
                                                                        item.name
                                                                      }
                                                                      :{" "}
                                                                      <textarea
                                                                        style={{
                                                                          width:
                                                                            "264px",
                                                                        }}
                                                                        id={`${idx}_${item.prescribedTreatmentId}`}
                                                                        name="q262_txt_received_tmt_oth"
                                                                        value={
                                                                          row.q262_selectedReceivedTmtList?.find(
                                                                            (
                                                                              a,
                                                                            ) =>
                                                                              a.prescribedTreatmentId ===
                                                                              item.prescribedTreatmentId,
                                                                          )
                                                                            ?.prescribedTreatmentOthTxt ??
                                                                          ""
                                                                        }
                                                                        onChange={
                                                                          Handle262FieldChange
                                                                        }
                                                                        maxLength={
                                                                          300
                                                                        }
                                                                        className="option-fbox"
                                                                      />
                                                                    </span>
                                                                  ) : (
                                                                    <span className="radio-text-padding">
                                                                      {
                                                                        item.name
                                                                      }
                                                                    </span>
                                                                  )}
                                                                </label>
                                                              </div>
                                                            ))}
                                                        </div>
                                                      ),
                                                  )
                                                );
                                              })()}

                                            <div>
                                              {row.q262_rbl_A != 1 &&
                                              !row.q262_selectedReceivedTmtList?.some(
                                                (item) => item.isNonEditable,
                                              ) ? (
                                                <label className="long-text-option">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "q262_rb_received_tmt_unk" +
                                                      idx
                                                    }
                                                    checked={
                                                      row.q262_rb_received_tmt_unk
                                                    }
                                                    onChange={
                                                      Handle262FieldChange
                                                    }
                                                  />
                                                  <span className="radio-text-padding">
                                                    Unknown
                                                  </span>
                                                </label>
                                              ) : (
                                                <></>
                                              )}
                                            </div>
                                          </div>
                                          <ErrorField
                                            show={row.q262_D_empty_err}
                                            message={
                                              BispecificCartTreatmentCohort_Msgs.q262_D
                                            }
                                          />
                                          <ErrorField
                                            show={row.q262_D_txt_empty_err}
                                            message={
                                              BispecificCartTreatmentCohort_Msgs.q262_D_txt
                                            }
                                          />
                                          <ErrorField
                                            show={row.q262_DaraNotSelected_err}
                                            message={
                                              BispecificCartTreatmentCohort_Msgs.q262_DaraNotSelected
                                            }
                                          />
                                        </>
                                      </td>

                                      <td
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          alignContent: "flex-start",
                                        }}
                                      >
                                        <div className="">
                                          {/* double-dig-answer */}
                                          <div>
                                            <label>
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={"q262_rbl_E" + idx}
                                                value={1}
                                                checked={row.q262_rbl_E === 1}
                                                onChange={Handle262FieldChange}
                                              />
                                              <span className="radio-text-padding">
                                                Yes
                                              </span>
                                            </label>
                                          </div>
                                          <div>
                                            <label>
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={"q262_rbl_E" + idx}
                                                value={0}
                                                checked={row.q262_rbl_E === 0}
                                                onChange={Handle262FieldChange}
                                              />
                                              <span className="radio-text-padding">
                                                No
                                              </span>
                                            </label>
                                          </div>
                                          <div>
                                            <label
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={"q262_rbl_E" + idx}
                                                value={99}
                                                checked={row.q262_rbl_E === 99}
                                                onChange={Handle262FieldChange}
                                              />
                                              <span className="radio-text-padding">
                                                Unknown
                                              </span>
                                            </label>
                                          </div>
                                        </div>
                                        <ErrorField
                                          show={row.q262_E_empty_err}
                                          message={
                                            BispecificCartTreatmentCohort_Msgs.q262_EF
                                          }
                                          style={{ paddingLeft: "0px" }}
                                        />
                                      </td>

                                      <td
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          alignContent: "flex-start",
                                        }}
                                      >
                                        <div className="">
                                          {/* double-dig-answer */}
                                          <div>
                                            <label>
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={"q262_rbl_F" + idx}
                                                value={1}
                                                checked={row.q262_rbl_F === 1}
                                                onChange={Handle262FieldChange}
                                              />
                                              <span className="radio-text-padding">
                                                Yes
                                              </span>
                                            </label>
                                          </div>
                                          <div>
                                            <label>
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={"q262_rbl_F" + idx}
                                                value={0}
                                                checked={row.q262_rbl_F === 0}
                                                onChange={Handle262FieldChange}
                                              />
                                              <span className="radio-text-padding">
                                                No
                                              </span>
                                            </label>
                                          </div>
                                          <div>
                                            <label
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={"q262_rbl_F" + idx}
                                                value={99}
                                                checked={row.q262_rbl_F === 99}
                                                onChange={Handle262FieldChange}
                                              />
                                              <span className="radio-text-padding">
                                                Unknown
                                              </span>
                                            </label>
                                          </div>
                                        </div>
                                        <ErrorField
                                          show={row.q262_F_empty_err}
                                          message={
                                            BispecificCartTreatmentCohort_Msgs.q262_EF
                                          }
                                          style={{ paddingLeft: "0px" }}
                                        />
                                      </td>

                                      {isNewEcrfC && (
                                        <td
                                          style={{
                                            border: "1px solid black",
                                            padding: "8px",
                                            alignContent: "flex-start",
                                          }}
                                        >
                                          {(() => {
                                            if (row.q262_rbl_F !== 1) {
                                              return <b>Not applicable</b>;
                                            }

                                            const qualifyingOptions =
                                              getQualifyingRefractoryAgentOptions(
                                                row,
                                              );

                                            if (
                                              qualifyingOptions.length === 0
                                            ) {
                                              return <b>Not applicable</b>;
                                            }

                                            return (
                                              <>
                                                {qualifyingOptions.map(
                                                  (option) => (
                                                    <div key={option.field}>
                                                      <label className="long-text-option">
                                                        <input
                                                          type="checkbox"
                                                          id={idx}
                                                          name={
                                                            "chk_q262_agentRefractory" +
                                                            option.field.replace(
                                                              "q262_agentRefractory",
                                                              "",
                                                            ) +
                                                            idx
                                                          }
                                                          checked={
                                                            row[
                                                              option.field
                                                            ] === true
                                                          }
                                                          onChange={
                                                            Handle262FieldChange
                                                          }
                                                        />
                                                        <span className="radio-text-padding">
                                                          {option.name}
                                                        </span>
                                                      </label>
                                                    </div>
                                                  ),
                                                )}
                                                <div>
                                                  <label className="long-text-option">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "q262_rb_agentRefractoryNone" +
                                                        idx
                                                      }
                                                      checked={
                                                        row.q262_agentRefractoryNone ===
                                                        true
                                                      }
                                                      onChange={
                                                        Handle262FieldChange
                                                      }
                                                    />
                                                    <span className="radio-text-padding">
                                                      None of the above
                                                    </span>
                                                  </label>
                                                </div>
                                                <ErrorField
                                                  show={row.q262_G_empty_err}
                                                  message={
                                                    BispecificCartTreatmentCohort_Msgs.q262_G
                                                  }
                                                  style={{
                                                    paddingLeft: "0px",
                                                  }}
                                                />
                                              </>
                                            );
                                          })()}
                                        </td>
                                      )}
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                {isNewEcrfC &&
                  (() => {
                    const q263Row = GetQ263EligibleRow(
                      bispecificHighestLotList,
                    );
                    if (!q263Row) return null;

                    const q263Idx = bispecificHighestLotList.findIndex(
                      (r) => r === q263Row,
                    );
                    const discInfo = GetQ263DiscontinuationInfo(q263Row);

                    return (
                      <div className="survey-question-content calender-datefix-survey">
                        <div className="question-answer">
                          <div className="question-bot-sapce">
                            <div className="question question-weight">
                              <span>Q26.3.C.</span>
                              <span className="quest-text-pad">
                                Please provide the date of{" "}
                                <u>daratumumab discontinuation</u> on the{" "}
                                <u>most recent prior line</u> of therapy that
                                utilized daratumumab.
                              </span>
                            </div>
                            <div className="sub-question">
                              <div className="" style={{ overflowX: "auto" }}>
                                <table
                                  style={{
                                    border: "1px solid black",
                                    borderCollapse: "collapse",
                                    width: "100%",
                                  }}
                                >
                                  <thead>
                                    <tr>
                                      <th
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          textAlign: "center",
                                          width: "10%",
                                        }}
                                      >
                                        LOT
                                      </th>
                                      <th
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          textAlign: "center",
                                          width: "20%",
                                        }}
                                      >
                                        LOT start date
                                      </th>
                                      <th
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          textAlign: "center",
                                          width: "20%",
                                        }}
                                      >
                                        LOT end date
                                      </th>
                                      <th
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          textAlign: "center",
                                          width: "30%",
                                        }}
                                      >
                                        Date of daratumumab discontinuation
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          alignContent: "flex-start",
                                          textAlign: "center",
                                        }}
                                      >
                                        <span
                                          style={{
                                            color:
                                              PageDesignConstants.fontColor,
                                          }}
                                        >
                                          {q263Row.q262_rbl_A}
                                        </span>
                                      </td>
                                      <td
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          alignContent: "flex-start",
                                          textAlign: "center",
                                        }}
                                      >
                                        {!isStringEmpty(q263Row.q262_autodate_B)
                                          ? q263Row.q262_autodate_B
                                          : q263Row.q262_rbl_B === 99
                                            ? "Unknown"
                                            : q263Row.q262_date_B}
                                      </td>
                                      <td
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          alignContent: "flex-start",
                                          textAlign: "center",
                                        }}
                                      >
                                        {!isStringEmpty(q263Row.q262_autodate_C)
                                          ? q263Row.q262_autodate_C
                                          : q263Row.q262_rbl_C === 99
                                            ? "Unknown"
                                            : q263Row.q262_date_C}
                                      </td>
                                      <td
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          alignContent: "flex-start",
                                        }}
                                      >
                                        {discInfo.isAuto ? (
                                          <span>{discInfo.date}</span>
                                        ) : (
                                          <>
                                            <div className="long-text-option">
                                              <input
                                                type="radio"
                                                id={q263Idx}
                                                name={"q263_rbl_D" + q263Idx}
                                                value={1}
                                                checked={
                                                  q263Row.q263_rbl_D === 1
                                                }
                                                onChange={Handle262FieldChange}
                                              />
                                              <span className="date-field-padding">
                                                <DatePickerComponent
                                                  ctrlId={
                                                    "q263_date_D" + q263Idx
                                                  }
                                                  HandleDateChange={
                                                    Handle262DateChange
                                                  }
                                                  minDate={dayjs("01-01-1920")}
                                                  maxDate={dayjs()}
                                                  locale="en"
                                                  date={q263Row.q263_date_D}
                                                  optionId={q263Idx}
                                                />
                                              </span>
                                            </div>
                                            <div>
                                              <label className="long-text-option">
                                                <input
                                                  type="radio"
                                                  id={q263Idx}
                                                  name={"q263_rbl_D" + q263Idx}
                                                  value={99}
                                                  checked={
                                                    q263Row.q263_rbl_D === 99
                                                  }
                                                  onChange={
                                                    Handle262FieldChange
                                                  }
                                                />
                                                <span className="radio-text-padding">
                                                  Date of discontinuation
                                                  unknown
                                                </span>
                                              </label>
                                            </div>
                                            <ErrorField
                                              show={q263Row.q263_C_empty_err}
                                              message={
                                                BispecificCartTreatmentCohort_Msgs.q263_C
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                            <ErrorField
                                              show={q263Row.q263_C_invalid_date}
                                              message={
                                                CommonError_Msgs.InvalidDate
                                              }
                                              style={{
                                                paddingLeft: "0px",
                                              }}
                                            />
                                          </>
                                        )}
                                        <ErrorField
                                          show={q263Row.q263_C_chain_err}
                                          message={
                                            BispecificCartTreatmentCohort_Msgs.q263_C_chain
                                          }
                                          style={{ paddingLeft: "0px" }}
                                        />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })()}
              </div>
              <div className="survey-section-content-foot">
                <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
              </div>
            </div>
          </div>

          {showConfirm && (
            <div className="deleteActionModal">
              <div
                className="modal"
                style={{ display: "block", zIndex: Number.MAX_SAFE_INTEGER }}
              >
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h4 className="modal-title">Alert</h4>
                    </div>
                    <div className="modal-body">
                      <p>
                        <b>{modalDescription}</b>
                      </p>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={handleYes}
                      >
                        Yes
                      </button>
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={handleNo}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default BispecificsCartTreatmentCohort;
